import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
//   html,
//   body {
//     height: 100%;
//     width: 100%;
//     line-height: 1.5;
//   }
//
//   body {
//     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
//   }
//
//   body.fontLoaded {
//     font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
//   }
//
//   #app {
//     background-color: #fafafa;
//     min-height: 100%;
//     min-width: 100%;
//   }
//
//   * {
//     transition: all 0.3s;
//   }
//
//
//   @charset "UTF-8";
// /*
// Theme Name: Material Apto
// Theme URI: https://wordpress.org/themes/twentynineteen/
// Author: Apto
// Author URI: https://wordpress.org/
// Description: Our 2019 default theme is designed to show off the power of the block editor. It features custom styles for all the default blocks, and is built so that what you see in the editor looks like what you'll see on your website. Twenty Nineteen is designed to be adaptable to a wide range of websites, whether you’re running a photo blog, launching a new business, or supporting a non-profit. Featuring ample whitespace and modern sans-serif headlines paired with classic serif body text, it's built to be beautiful on all screen sizes.
// Requires at least: WordPress 4.9.6
// Version: 1.4
// License: GNU General Public License v2 or later
// License URI: LICENSE
// Text Domain: twentynineteen
// Tags: one-column, flexible-header, accessibility-ready, custom-colors, custom-menu, custom-logo, editor-style, featured-images, footer-widgets, rtl-language-support, sticky-post, threaded-comments, translation-ready
//
// This theme, like WordPress, is licensed under the GPL.
// Use it to make something cool, have fun, and share what you've learned with others.
//
// Twenty Nineteen is based on Underscores https://underscores.me/, (C) 2012-2018 Automattic, Inc.
// Underscores is distributed under the terms of the GNU GPL v2 or later.
//
// Normalizing styles have been helped along thanks to the fine work of
// Nicolas Gallagher and Jonathan Neal https://necolas.github.io/normalize.css/
//
// /*
//  * Chrome renders extra-wide &nbsp; characters for the Hoefler Text font.
//  * This results in a jumping cursor when typing in both the Classic and block
//  * editors. The following font-face override fixes the issue by manually inserting
//  * a custom font that includes just a Hoefler Text space replacement for that
//  * character instead.
//  */
// @font-face {
//   font-family: 'NonBreakingSpaceOverride';
//   src: url(data:application/font-woff2;charset=utf-8;base64,d09GMgABAAAAAAMoAA0AAAAACDQAAALTAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP0ZGVE0cGh4GYACCahEICjx3CywAATYCJANUBCAFhiEHgWwbXQfILgpsY+rQRRARwyAs6uL7pxzYhxEE+32b3aeHmifR6tklkS9hiZA0ewkqGRJE+H7/+6378ASViK/PGeavqJyOzsceKi1s3BCiQsiOdn1r/RBgIJYEgCUhbm/8/8/h4saPssnTNkkiWUBrTRtjmQSajw3Ui3pZ3LYDPD+XG2C3JA/yKAS8/rU5eNfuGqRf4eNNgV4YAlIIgxglEkWe6FYpq10+wi3g+/nUgvgPFczNrz/RsTgVm/zfbPuHZlsuQECxuyqBcQwKFBjFgKO8AqP4bAN9tFJtnM9xPcbNjeXS/x1wY/xU52f5W/X1+9cnH4YwKIaoRRAkUkj/YlAAeF/624foiIDBgBmgQBeGAyhBljUPZUm/l2dTvmpqcBDUOHdbPZWd8JsBAsGr4w8/EDn82/bUPx4eh0YNrQTBuHO2FjQEAGBwK0DeI37DpQVqdERS4gZBhpeUhWCfLFz7J99aEBgsJCHvUGAdAPp4IADDCAPCEFMGpMZ9AQpTfQtQGhLbGVBZFV8BaqNyP68oTZgHNj3M8kBPfXTTC9t90UuzYhy9ciH0grVlOcqyCytisvbsERsEYztiznR0WCrmTksJwbSNK6fd1Rvr25I9oLvctUoEbNOmXJbqgYgPXEHJ82IUsrCnpkxh23F1rfZ2zcRnJYoXtauB3VTFkFXQg3uoZYD5qE0kdjDtoDoF1h2bulGmev5HbYhbrjtohQSRI4aNOkffIcT+d3v6atpaYh3JvPoQsztCcqvaBkppDSPcQ3bw3KaCBo1f5CJWTZEgW3LjLofYg51MaVezrx8xZitYbQ9KYeoRaqQdVLwSEfrKXLK1otCWOKNdR/YwYAfon5Yk8O2MJfSD10dPGA5PIJJQMkah0ugMJiv6x4Dm7LEa8xnrRGGGLAg4sAlbsA07sAt76DOsXKO3hIjtIlpnnFrt1qW4kh6NhS83P/6HB/fl1SMAAA==) format("woff2"), url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAUQAA0AAAAACDQAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAE9AAAABwAAAAchf5yU0dERUYAAATYAAAAHAAAAB4AJwAbT1MvMgAAAaAAAABJAAAAYJAcgU5jbWFwAAACIAAAAF4AAAFqUUxBZ2dhc3AAAATQAAAACAAAAAgAAAAQZ2x5ZgAAApAAAAAyAAAAPL0n8y9oZWFkAAABMAAAADAAAAA2Fi93Z2hoZWEAAAFgAAAAHQAAACQOSgWaaG10eAAAAewAAAAzAAAAVC7TAQBsb2NhAAACgAAAABAAAAAsAOQBAm1heHAAAAGAAAAAHQAAACAAWQALbmFtZQAAAsQAAAF6AAADIYvD/Adwb3N0AAAEQAAAAI4AAADsapk2o3jaY2BkYGAA4ov5mwzj+W2+MnCzXwCKMNzgCBSB0LfbQDQ7AxuI4mBgAlEAFKQIRHjaY2BkYGD3+NvCwMDBAALsDAyMDKhAFAA3+wH3AAAAeNpjYGRgYBBl4GBgYgABEMnIABJzAPMZAAVmAGUAAAB42mNgZlJhnMDAysDCKsKygYGBYRqEZtrDYMT4D8gHSmEHjgUFOQwODAqqf9g9/rYwMLB7MNUAhRlBcsxBrMlASoGBEQAj8QtyAAAAeNrjYGBkAAGmWQwMjO8gmBnIZ2NA0ExAzNjAAFYJVn0ASBsD6VAIDZb7AtELAgANIgb9AHjaY2BgYGaAYBkGRgYQSAHyGMF8FgYPIM3HwMHAxMDGoMCwQIFLQV8hXvXP//9AcRCfAcb///h/ygPW+w/vb7olBjUHCTCyMcAFGZmABBO6AogThgZgIUsXAEDcEzcAAHjaY2BgECMCyoEgACZaAed42mNgYmRgYGBnYGNgYAZSDJqMgorCgoqCjECRXwwNrCAKSP5mAAFGBiRgyAAAi/YFBQAAeNqtkc1OwkAUhU/5M25cEhcsZick0AwlBJq6MWwgJkAgYV/KAA2lJeUn+hY+gktXvpKv4dLTMqKycGHsTZNv7px7z50ZAFd4hYHjdw1Ls4EiHjVncIFnzVnc4F1zDkWjrzmPW+NNcwGlzIRKI3fJlUyrEjZQxb3mDH2fNGfRx4vmHKqG0JzHg6E0F9DOlFBGBxUI1GEzLNT4S0aLuTtsGAEUuYcQHkyg3KmIum1bNUvKlrjbbAIleqHHnS4iSudpQcySMYtdFiXlAxzSbAwfMxK6kZoHKhbjjespMTioOPZnzI+4ucCeTVyKMVKLfeAS6vSWaTinuZwzyy/Dc7vaed+6KaV0kukdPUk6yOcctZPvvxxqksq2lEW8RvHjMEO2FCl/zy6p3NEm0R9OFSafJdldc4QVeyaaObMBO0/5cCaa6d9Ggyubxire+lEojscdjoWUR1xGOy8KD8mG2ZLO2l2paDc3A39qmU2z2W5YNv5+u79e6QfGJY/hAAB42m3NywrCMBQE0DupWp/1AYI7/6DEaLQu66Mrd35BKUWKJSlFv1+rue4cGM7shgR981qSon+ZNwUJ8iDgoYU2OvDRRQ99DDDECAHGmGCKmf80hZSx/Kik/LliFbtmN6xmt+yOjdg9GztV4tROnRwX/Bsaaw51nt4Lc7tWaZYHp/MlzKx51LZs5htNri+2AAAAAQAB//8AD3jaY2BkYGDgAWIxIGZiYARCESBmAfMYAAR6AEMAAAABAAAAANXtRbgAAAAA2AhRFAAAAADYCNuG) format("woff");
// }
//
//
// img {
//
//   max-width: 100%;
//   height: auto;
//
// }
//
// html, body {
//   max-width: 100%;
// }
//
// /* Footer
// ========================================================================== */
// footer.page-footer {
//   padding: 60px 0 0;
//   background-color: #000;
// }
//
// footer #menu-footer-menu li a {
//   color: inherit;
// }
//
// footer.page-footer .footer-copyright {
//   margin-top: 40px;
// }
//
// footer .widget-title {
//   font-size: 1.8rem;
//   font-weight: 700;
//   margin-bottom: 10px;
//   margin-top: 0;
// }
//
// footer .footer-menu li {
//   display: inline-block;
//   margin-right: 8px;
//   text-transform: capitalize;
// }
//
// footer .copyright-text {
//   margin-top: 18px;
// }
//
// footer img {
//   width: 100%;
// }
//
// @media only screen and (max-width: 600px) {
//
//   ul#menu-footer-menu.right {
//     float: left!important;
//   }
//
//   footer .row.footer-widgets.flex {
//
//     margin-bottom: 0;
//
//   }
//
//   footer .widget_nav_menu li {
//     display: inline-block;
//     margin-right: 10px;
//   }
//
//   footer.page-footer .footer-copyright {
//     margin-top: 0;
//   }
//
//
//   footer.page-footer .footer-copyright  .developed-by {
//     display: block;
//     margin-top: 2px;
//   }
//
//
// }
//
// @media only screen and (max-width: 700px) {
//
//   footer.page-footer {
//     padding-top:50px!important;
//   }
//
//   footer .widget-column {
//
//     margin-top: 5px;
//
//   }
//
//
//
// }
//
//
// /* Header
// ========================================================================== */
//
// header nav {
//   background-color: #fefefe;
//   color: #222;
// }
//
// header nav .brand-logo img {
//   height: 64px;
//   width: auto;
//   padding: 5px;
// }
//
// header nav .social-links-menu .screen-reader-text {
//   display: none;
// }
//
// header nav .social-links-menu svg {
//   display: inline-block;
//   vertical-align: middle;
// }
//
// header nav .social-links-menu svg {
//   fill: #222;
// }
//
// header nav .apto-login-register, header nav .social-links-menu, header nav .apto-profile {
//   border-left: 1px solid #e5e5e5;
// }
//
// header nav .social-links-menu {
//   margin-left:0;
// }
//
// header nav .apto-login-register li {
//   margin:0;
// }
//
// header nav .apto-login-register li:first-child {
//   padding-left:10px;
// }
//
// header nav .apto-login-register .btn {
//   margin:0 5px;
//   font-weight: 700;
//   font-size: 13px !important;
//   height: 45px;
//   line-height: 45px;
//
// }
//
// header nav .dropdown-content li > a {
//   font-size: inherit;
//   color: inherit;
//
// }
//
// header nav .profile-trigger .avatar {
//
//   width: 35px;
//   height: 35px;
//   border-radius: 50%;
//   display: inline-block;
//   vertical-align: middle;
//   margin-right: 5px;
//
// }
//
// header.mobileSticky nav {
//
//   transform: translateY(-46px);
//
// }
//
// @media screen and (max-width: 990px) {
//
//   body header nav .brand-logo {
//     left: 0;
//     -webkit-transform: translateX(0);
//     transform: translateX(0);
//     float: left;
//     padding-left: 10px;
//
//   }
//
//   body header nav a.custom-logo-link {
//     display: inline-block;
//     height: 100%;
//   }
//
// }
//
// @media screen and (max-width: 600px) {
//
//   #wpadminbar,
//   header nav {
//     position: fixed!important;
//     -webkit-transition: transform 0.2s ease;
//     -o-transition: transform 0.2s ease;
//     transition: transform 0.2s ease;
//     transform: translateY(0);
//
//   }
//
//   #wpadminbar.scrollDown,
//   .admin-bar header nav.scrollDown {
//     -webkit-transform:translateY(0);
//     -ms-transform:translateY(0);
//     transform: translateY(0);
//   }
//
//   #wpadminbar.scrollUp,
//   header nav.scrollUp{
//     -webkit-transform: translateY(-56px);
//     -ms-transform: translateY(-56px);
//     transform: translateY(-56px);
//   }
//
//   .admin-bar #wpadminbar.scrollUp,
//   .admin-bar header nav.scrollUp{
//     -webkit-transform: translateY(-106px);
//     -ms-transform: translateY(-106px);
//     transform: translateY(-106px);
//   }
//
// }
//
//
// /* Sidenav
// ========================================================================== */
//
// header nav .sidenav-trigger {
//   margin:0;
//   padding:0 18px;
// }
//
// body.admin-bar .sidenav {
//   top: 0;
//   margin-left: -1px;
//   z-index: 9999999;
// }
//
// body .sidenav .user-view {
//   color: #fff;
//   padding: 20px;
//   margin-bottom: 0;
//   display: block;
//   float: left;
//   width: 100%;
// }
//
// .sidenav .mobile-logo {
//   padding: 10px 50% 0 15px;
//   border-bottom: 1px solid #e5e5e5;
// }
//
// .sidenav .user-view .background img {
//   width: calc(100% + 8px);
//   height: auto;
//   -webkit-filter: blur(10px);
//   filter: blur(10px);
// }
//
// .sidenav .user-view .avatar {
//   -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//   box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
// }
//
// .sidenav .user-view > a {
//   color: inherit;
// }
//
// .sidenav .user-view .user-avatar {
//
//   float: left;
//   margin-right: 10px;
//   margin-top: 1px;
// }
//
// .sidenav .user-view .user-avatar .avatar {
//
//   width: 50px;
//   border-radius: 50%;
//
// }
//
// .sidenav .user-view .user-info {
//   color: #fff;
//   float: left;
//   margin-top: 2px;
// }
//
// .sidenav .user-view .user-info a {
//   color:inherit;
// }
//
// .sidenav .user-view a .avatar {
//
//   border-radius: 50%;
//   width: 50px;
//   float: left;
//   margin-right: 10px;
//   margin-top: 8px;
//
// }
//
// .sidenav .user-view .user-info .name {
//   color: inherit;
//   font-weight: 700;
//   margin-top: 0;
// }
//
//
// .sidenav .user-view .user-info .email {
//   color: inherit;
//   opacity: 0.7;
//   font-weight: 400;
//   line-height: 18px;
//
// }
//
// .sidenav .apto-profile.mobile {
//   margin: 0;
//   border-bottom: 1px solid #e5e5e5;
// }
//
// .sidenav .apto-profile.mobile li > a {
//   padding: 0 20px;
//   color: inherit!important;
// }
//
// .sidenav li > a > i {
//   margin-right:15px;
// }
//
// .sidenav li > a > i.right {
//   margin-right:0!important;
// }
//
// .sidenav li > a > i.left {
//   margin-right:5px!important;
// }
//
// .sidenav #mobileMenu {
//   margin-top: 0;
// }
//
// .sidenav #mobileMenu li > a {
//   padding:0 20px;
// }
//
//
// .sidenav ul.social-mobile-menu {
//   border-top: 1px solid #e5e5e5;
//   padding: 10px 15px;
//   margin: 0;
// }
//
// .sidenav .social-mobile-menu li {
//   display: inline-block;
// }
//
// .sidenav .social-mobile-menu li a {
//   padding: 0 10px;
// }
//
// .sidenav .social-mobile-menu span.screen-reader-text {
//   display: none;
// }
//
// .sidenav .social-mobile-menu li a svg {
//   vertical-align: middle;
// }
//
//
// .sidenav ul.apto-login-register.mobile {
//   border-top: 1px solid #e5e5e5;
//   padding-top: 10px;
//   margin: 0;
// }
//
// .sidenav ul.apto-login-register.mobile li a {
//   margin-bottom: 15px;
//   font-size: 0.9rem;
// }
//
// /* Other
// ========================================================================== */
// .card-image svg {
//   width: 100%;
//   height: auto;
// }
//
//
// /* Pagination
// ========================================================================== */
//
// .pagination-wrapper {
//
//   margin-top: 20px;
//   text-align: center;
//
// }
//
// .page-numbers {
//   display: inline-block;
//   background-color: #fff;
//   padding: 10px 18px;
//   margin: 0 5px;
//   border-radius: 4px;
//   font-weight: 700;
//   -webkit-box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
//   box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
//   -webkit-transition:0.3s ease-in;
//   transition:0.3s ease-in;
//   color: #666;
// }
//
//
// .page-numbers:hover {
//
//   -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//   box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
//
//
// .page-numbers.current {
//
//   background-color: #039be5;
//   color: #fff;
//
// }
//
//
// /* Comments
// ========================================================================== */
// #comments .svg-icon {
//
//   width: 24px;
//   height: 24px;
//
// }
//
// #comments .comment-author .avatar {
//
//   width: 45px;
//   height: 45px;
//   border-radius: 50%;
//   float: left;
//   margin-right: 10px;
//   margin-top: 5px;
//
// }
//
// #comments .post-author-badge svg {
//
//   fill: #5ea7f4;
//
// }
//
// #comments .comment-list {
//
//   list-style-type: none;
//   padding: 0;
// }
//
// #comments .comment-metadata {
//
//   display: inline-block;
//   margin-top: -4px;
//   font-size: 0.9rem;
//
// }
//
// .comment-form-flex {
//
//   margin-top: 40px;
//
// }
//
//
// /* WordPress Media Uploader
// ========================================================================== */
//
// body .media-modal.wp-core-ui {
//   border-radius: 10px;
//   overflow: hidden;
// }
//
// body .media-modal .screen-reader-text {
//   display: none!important;
// }
//
// body .media-modal .selected.attachment {
//   box-shadow:none;
//
// }
//
// body .wp-core-ui .attachment.details:focus,
// body .wp-core-ui .attachment:focus,
// body .wp-core-ui .selected.attachment:focus {
//
//   box-shadow: none;
//   outline: none;
//   outline-offset: 0;
//
// }
//
// body .media-modal .attachment .thumbnail {
//   border-radius: 4px;
//   border: 3px solid #dce4fb;
// }
//
// body .media-modal .attachment .thumbnail:hover {
//   -webkit-box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44) !important;
//   box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44) !important;
// }
//
// body .media-modal .selected.attachment .thumbnail {
//   border: 3px solid #3c5ea5;
//   -webkit-box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44) !important;
//   box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44) !important;
// }
//
// body .media-modal .wp-core-ui .attachment-preview {
//   position: relative;
//   box-shadow: none;
//   background: #e5ecff;
//   cursor: pointer;
// }
//
// body  .wp-core-ui .selected.attachment {
//   border-radius: 10px;
// }
//
// body .wp-core-ui .attachment.details .check,
// body .wp-core-ui .attachment.selected .check:focus,
// body .wp-core-ui .media-frame.mode-grid .attachment.selected .check {
//   border-radius: 4px;
//   background-color: #3c5ea5;
//   box-shadow: 0 0 0 1px #fff,0 0 0 2px #3c5ea5;
// }
//
// body .wp-core-ui .attachment .filename {
//   box-shadow:none;
// }
//
// body .wp-core-ui .attachment .thumbnail::after {
//   box-shadow:none;
// }
//
// body #media-search-input:hover,
// body #media-search-input:focus {
//   -webkit-box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44) !important;
//   box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44) !important;
// }
//
// body #media-search-input {
//   font-size: 14px;
//   font-weight: 400;
//   height: 40px;
//   line-height: 40px;
//   margin-top: 4px;
// }
//
// body .attachment-details .setting .value,
// body .attachment-details .setting input[type="email"],
// body .attachment-details .setting input[type="number"],
// body .attachment-details .setting input[type="password"],
// body .attachment-details .setting input[type="search"],
// body .attachment-details .setting input[type="tel"],
// body .attachment-details .setting input[type="text"],
// body .attachment-details .setting input[type="url"],
// body .attachment-details .setting textarea,
// body .attachment-details .setting + .description,
// body .media-sidebar .setting .value,
// body .media-sidebar .setting input[type="email"],
// body .media-sidebar .setting input[type="number"],
// body .media-sidebar .setting input[type="password"],
// body .media-sidebar .setting input[type="search"],
// body .media-sidebar .setting input[type="tel"],
// body .media-sidebar .setting input[type="text"],
// body .media-sidebar .setting input[type="url"],
// body .media-sidebar .setting textarea {
//   font-weight: 400;
//   font-size: 13px;
//   padding-left: 10px;
//   height: 40px;
//   margin-top: -3px;
//   background: #dce4fb;
//   border-radius: 10px;
//   border: 2px solid #dce4fb;
// }
//
// body .media-modal-content {
//   background:#fff;
// }
//
// body .media-modal-content .media-toolbar-primary .media-button {
//   float: right;
//   outline: none !important;
//   height: 40px;
//   line-height: 38px;
//   padding: 0 40px;
//   border-radius: 30px;
//   margin-top: 10px;
//   border: 1px solid #3c5ea5;
//   -webkit-transition: 0.2s ease;
//   -o-transition: 0.2s ease;
//   -moz-transition: 0.2s ease;
//   transition: 0.2s ease;
//   display: inline-block;
//   cursor: pointer;
//   text-align: center;
//   background: #3c5ea5;
//   text-shadow: none;
//   font-weight: 700;
//   box-shadow: none !important;
//   min-width: 250px;
// }
//
// body .wp-core-ui .button-primary-disabled,
// body .wp-core-ui .button-primary.disabled,
// body .wp-core-ui .button-primary:disabled,
// body .wp-core-ui .button-primary[disabled] {
//   color: #7e87a6 !important;
//   background: #e5ecff !important;
//   border-color: #dce4fb !important;
//   box-shadow: none !important;
//   text-shadow: 0 -1px 0 rgba(0,0,0,.1) !important;
//   cursor: default;
// }
//
// body .media-modal-close {
//   background: #e5ecff;
//   color: #3c5ea5;
//   border-radius: 50%;
//   top: 15px;
//   right: 15px;
// }
//
// body .media-modal-close:hover,
// body .media-modal-close:focus,
// body .media-modal-close:active {
//   background: #3c5ea5;
//   color: #fff;
//   box-shadow: none;
//   border: 0;
// }
//
// body .media-frame-content {
//   border-top: 2px solid #d1daf4;
// }
//
// body .media-sidebar {
//   background-color: #e5ecff;
//   border-left: 1px solid #d1daf4;
// }
//
// body .media-frame a {
//   color: #3c5ea5;
// }
//
// body .attachment-info {
//   color: #808ba1;
//   border-bottom: 1px solid #dce4fb;
// }
//
// body .media-sidebar .setting .name {
//   text-align: left;
// }
//
// body .attachment-details .setting span,
// body .compat-item label span,
// body .media-sidebar .setting span {
//   color: #808ba1;
// }
//
// body .image-details h2,
// body .image-details h3,
// body .media-sidebar h2,
// body .media-sidebar h3 {
//   color: #636c86;
// }
//
// body .media-modal .delete-attachment,
// body .media-modal .trash-attachment,
// body .media-modal .untrash-attachment {
//   display: inline;
//   padding: 0;
//   color: #626f93;
// }
//
// body .media-frame a {
//   box-shadow: none;
//   color: #626f93;
//   border-bottom: 2px solid #d1daf4;
//   margin-top: -1px;
//   font-size: 15px;
//   transition:0.2s ease-in;
//   font-weight: 700;
// }
//
// body .media-router .active,
// body .media-router > a.active:last-child,
// body .media-frame a:hover,
// body .media-frame a:focus {
//   box-shadow: none;
//   border-top: 0 !important;
//   border-left: 0 !important;
//   border-right: 0 !important;
//   border-bottom: 2px solid #3c5ea5 !important;
//   margin-top: -1px !important;
//   outline: none !important;
//   color: #3c5ea5;
// }
//
// body .attachment-details .setting,
// body .media-sidebar .setting {
//   margin-bottom:10px;
// }
//
// body .wp-core-ui .attachments-browser .attachment .thumbnail .centered img.icon {
//   filter: brightness(0.55);
// }
//
// body .attachment-info .thumbnail img.icon {
//   filter: brightness(0.55);
// }
//
// body .media-frame-toolbar .media-toolbar {
//   border-top: 1px solid #d1daf4;
// }
//
// body .uploader-inline .browser {
//   display: inline-block !important;
//   background: #e5ecff;
//   border-radius: 25px;
//   width: 200px;
//   border-color: #d1daf4;
//   color: #3c5ea5;
//   font-weight: 700;
//   transition: 0.2s ease;
// }
//
// body .supports-drag-drop .uploader-inline .drop-instructions {
//   color: #626f93;
//   font-weight: 700;
// }
//
// body .uploader-inline p {
//   color: #808ba1;
//   font-weight:400;
// }
//
// body .uploader-inline .browser:hover {
//   background: #3c5ea5;
//   color: #fff;
// }
//
// @media screen and (max-width: 600px){
//
//   .attachments-browser .media-toolbar-secondary {
//     display: none;
//   }
//
//   body .media-modal.wp-core-ui {
//     border-radius: 0;
//   }
//
//   .attachments-browser .media-toolbar-primary {
//     max-width: 100%;
//   }
//
//   .attachments-browser .media-toolbar-primary {
//     max-width: 100%;
//     width: 100%;
//     margin-top: 2px;
//   }
//
//   .attachments-browser .attachments {
//     margin-top: 10px;
//   }
//
//   body .media-frame-toolbar .media-toolbar {
//     border-top: 0;
//   }
//
// }
//
//
// /* Owl Carousel
// ========================================================================== */
// body .owl-carousel .owl-nav {
//   position: absolute;
//   top: calc(50% - 50px);
//   width: 100%;
//   z-index: 0;
// }
//
// body .owl-carousel .owl-dots {
//   text-align: center;
//   margin-top: 25px;
// }
//
// body .owl-carousel .owl-nav button.owl-next,
// body .owl-carousel .owl-nav button.owl-prev,
// body .owl-carousel button.owl-dot {
//   border-radius: 50%;
//   outline: none;
//   transition:0.3s ease-in;
// }
//
// body .owl-carousel .owl-nav button.owl-next,
// body .owl-carousel .owl-nav button.owl-prev {
//   position: absolute;
//   font-size: 1.7rem;
//   width: 60px;
//   height: 60px;
//   background-color: #fff;
//   font-weight: 700;
//   -webkit-box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44);
//   box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44);
// }
//
// body .owl-carousel .owl-nav button.owl-prev {
//   left:-30px;
// }
//
// body .owl-carousel .owl-nav button.owl-next {
//   right:-30px;
// }
//
//
// body .owl-carousel .owl-nav button.owl-next.disabled,
// body .owl-carousel .owl-nav button.owl-prev.disabled {
//   opacity: 0;
// }
//
// body .owl-carousel button.owl-dot {
//   width: 15px;
//   height: 15px;
//   background: #bfdae8;
//   margin: 0 5px;
// }
//
// body .owl-carousel button.owl-dot.active {
//   background: #048fc8;
// }
//
//
//
// /*!
//  * Materialize v1.0.0 (http://materializecss.com)
//  * Copyright 2014-2017 Materialize
//  * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)
//  */
//
// /*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */
// /* Document
//    ========================================================================== */
// /**
//  * 1. Correct the line height in all browsers.
//  * 2. Prevent adjustments of font size after orientation changes in
//  *    IE on Windows Phone and in iOS.
//  */
// html {
//   line-height: 1.15;
//   /* 1 */
//   -ms-text-size-adjust: 100%;
//   /* 2 */
//   -webkit-text-size-adjust: 100%;
//   /* 2 */
// }
//
// /* Sections
//    ========================================================================== */
// /**
//  * Remove the margin in all browsers (opinionated).
//  */
// body {
//   margin: 0;
// }
//
// /**
//  * Add the correct display in IE 9-.
//  */
// article,
// aside,
// footer,
// header,
// nav,
// section {
//   display: block;
// }
//
// /**
//  * Correct the font size and margin on \`h1\` elements within \`section\` and
//  * \`article\` contexts in Chrome, Firefox, and Safari.
//  */
// h1 {
//   font-size: 2em;
//   margin: 0.67em 0;
// }
//
// /* Grouping content
//    ========================================================================== */
// /**
//  * Add the correct display in IE 9-.
//  * 1. Add the correct display in IE.
//  */
// figcaption,
// figure,
// main {
//   /* 1 */
//   display: block;
// }
//
// /**
//  * Add the correct margin in IE 8.
//  */
// figure {
//   margin: 1em 40px;
// }
//
// /**
//  * 1. Add the correct box sizing in Firefox.
//  * 2. Show the overflow in Edge and IE.
//  */
// hr {
//   -webkit-box-sizing: content-box;
//           box-sizing: content-box;
//   /* 1 */
//   height: 0;
//   /* 1 */
//   overflow: visible;
//   /* 2 */
// }
//
// /**
//  * 1. Correct the inheritance and scaling of font size in all browsers.
//  * 2. Correct the odd \`em\` font sizing in all browsers.
//  */
// pre {
//   font-family: monospace, monospace;
//   /* 1 */
//   font-size: 1em;
//   /* 2 */
// }
//
// /* Text-level semantics
//    ========================================================================== */
// /**
//  * 1. Remove the gray background on active links in IE 10.
//  * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
//  */
// a {
//   background-color: transparent;
//   /* 1 */
//   -webkit-text-decoration-skip: objects;
//   /* 2 */
// }
//
// /**
//  * 1. Remove the bottom border in Chrome 57- and Firefox 39-.
//  * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
//  */
// abbr[title] {
//   border-bottom: none;
//   /* 1 */
//   text-decoration: underline;
//   /* 2 */
//   -webkit-text-decoration: underline dotted;
//      -moz-text-decoration: underline dotted;
//           text-decoration: underline dotted;
//   /* 2 */
// }
//
// /**
//  * Prevent the duplicate application of \`bolder\` by the next rule in Safari 6.
//  */
// b,
// strong {
//   font-weight: inherit;
// }
//
// /**
//  * Add the correct font weight in Chrome, Edge, and Safari.
//  */
// b,
// strong {
//   font-weight: bolder;
// }
//
// /**
//  * 1. Correct the inheritance and scaling of font size in all browsers.
//  * 2. Correct the odd \`em\` font sizing in all browsers.
//  */
// code,
// kbd,
// samp {
//   font-family: monospace, monospace;
//   /* 1 */
//   font-size: 1em;
//   /* 2 */
// }
//
// /**
//  * Add the correct font style in Android 4.3-.
//  */
// dfn {
//   font-style: italic;
// }
//
// /**
//  * Add the correct background and color in IE 9-.
//  */
// mark {
//   background-color: #ff0;
//   color: #000;
// }
//
// /**
//  * Add the correct font size in all browsers.
//  */
// small {
//   font-size: 80%;
// }
//
// /**
//  * Prevent \`sub\` and \`sup\` elements from affecting the line height in
//  * all browsers.
//  */
// sub,
// sup {
//   font-size: 75%;
//   line-height: 0;
//   position: relative;
//   vertical-align: baseline;
// }
//
// sub {
//   bottom: -0.25em;
// }
//
// sup {
//   top: -0.5em;
// }
//
// /* Embedded content
//    ========================================================================== */
// /**
//  * Add the correct display in IE 9-.
//  */
// audio,
// video {
//   display: inline-block;
// }
//
// /**
//  * Add the correct display in iOS 4-7.
//  */
// audio:not([controls]) {
//   display: none;
//   height: 0;
// }
//
// /**
//  * Remove the border on images inside links in IE 10-.
//  */
// img {
//   border-style: none;
// }
//
// /**
//  * Hide the overflow in IE.
//  */
// svg:not(:root) {
//   overflow: hidden;
// }
//
// /* Forms
//    ========================================================================== */
// /**
//  * 1. Change the font styles in all browsers (opinionated).
//  * 2. Remove the margin in Firefox and Safari.
//  */
// button,
// input,
// optgroup,
// select,
// textarea {
//   font-family: sans-serif;
//   /* 1 */
//   font-size: 100%;
//   /* 1 */
//   line-height: 1.15;
//   /* 1 */
//   margin: 0;
//   /* 2 */
// }
//
// /**
//  * Show the overflow in IE.
//  * 1. Show the overflow in Edge.
//  */
// button,
// input {
//   /* 1 */
//   overflow: visible;
// }
//
// /**
//  * Remove the inheritance of text transform in Edge, Firefox, and IE.
//  * 1. Remove the inheritance of text transform in Firefox.
//  */
// button,
// select {
//   /* 1 */
//   text-transform: none;
// }
//
// /**
//  * 1. Prevent a WebKit bug where (2) destroys native \`audio\` and \`video\`
//  *    controls in Android 4.
//  * 2. Correct the inability to style clickable types in iOS and Safari.
//  */
// button,
// html [type="button"],
// [type="reset"],
// [type="submit"] {
//   -webkit-appearance: button;
//   /* 2 */
// }
//
// /**
//  * Remove the inner border and padding in Firefox.
//  */
// button::-moz-focus-inner,
// [type="button"]::-moz-focus-inner,
// [type="reset"]::-moz-focus-inner,
// [type="submit"]::-moz-focus-inner {
//   border-style: none;
//   padding: 0;
// }
//
// /**
//  * Restore the focus styles unset by the previous rule.
//  */
// button:-moz-focusring,
// [type="button"]:-moz-focusring,
// [type="reset"]:-moz-focusring,
// [type="submit"]:-moz-focusring {
//   outline: 1px dotted ButtonText;
// }
//
// /**
//  * Correct the padding in Firefox.
//  */
// fieldset {
//   padding: 0.35em 0.75em 0.625em;
// }
//
// /**
//  * 1. Correct the text wrapping in Edge and IE.
//  * 2. Correct the color inheritance from \`fieldset\` elements in IE.
//  * 3. Remove the padding so developers are not caught out when they zero out
//  *    \`fieldset\` elements in all browsers.
//  */
// legend {
//   -webkit-box-sizing: border-box;
//           box-sizing: border-box;
//   /* 1 */
//   color: inherit;
//   /* 2 */
//   display: table;
//   /* 1 */
//   max-width: 100%;
//   /* 1 */
//   padding: 0;
//   /* 3 */
//   white-space: normal;
//   /* 1 */
// }
//
// /**
//  * 1. Add the correct display in IE 9-.
//  * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
//  */
// progress {
//   display: inline-block;
//   /* 1 */
//   vertical-align: baseline;
//   /* 2 */
// }
//
// /**
//  * Remove the default vertical scrollbar in IE.
//  */
// textarea {
//   overflow: auto;
// }
//
// /**
//  * 1. Add the correct box sizing in IE 10-.
//  * 2. Remove the padding in IE 10-.
//  */
// [type="checkbox"],
// [type="radio"] {
//   -webkit-box-sizing: border-box;
//           box-sizing: border-box;
//   /* 1 */
//   padding: 0;
//   /* 2 */
// }
//
// /**
//  * Correct the cursor style of increment and decrement buttons in Chrome.
//  */
// [type="number"]::-webkit-inner-spin-button,
// [type="number"]::-webkit-outer-spin-button {
//   height: auto;
// }
//
// /**
//  * 1. Correct the odd appearance in Chrome and Safari.
//  * 2. Correct the outline style in Safari.
//  */
// [type="search"] {
//   -webkit-appearance: textfield;
//   /* 1 */
//   outline-offset: -2px;
//   /* 2 */
// }
//
// /**
//  * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.
//  */
// [type="search"]::-webkit-search-cancel-button,
// [type="search"]::-webkit-search-decoration {
//   -webkit-appearance: none;
// }
//
// /**
//  * 1. Correct the inability to style clickable types in iOS and Safari.
//  * 2. Change font properties to \`inherit\` in Safari.
//  */
// ::-webkit-file-upload-button {
//   -webkit-appearance: button;
//   /* 1 */
//   font: inherit;
//   /* 2 */
// }
//
// /* Interactive
//    ========================================================================== */
// /*
//  * Add the correct display in IE 9-.
//  * 1. Add the correct display in Edge, IE, and Firefox.
//  */
// details,
// menu {
//   display: block;
// }
//
// /*
//  * Add the correct display in all browsers.
//  */
// summary {
//   display: list-item;
// }
//
// /* Scripting
//    ========================================================================== */
// /**
//  * Add the correct display in IE 9-.
//  */
// canvas {
//   display: inline-block;
// }
//
// /**
//  * Add the correct display in IE.
//  */
// template {
//   display: none;
// }
//
// /* Hidden
//    ========================================================================== */
// /**
//  * Add the correct display in IE 10-.
//  */
// [hidden] {
//   display: none;
// }
//
// html {
//   -webkit-box-sizing: border-box;
//           box-sizing: border-box;
// }
//
// *, *:before, *:after {
//   -webkit-box-sizing: inherit;
//           box-sizing: inherit;
// }
//
// button,
// input,
// optgroup,
// select,
// textarea {
//   font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
// }
//
// // ul:not(.browser-default) {
// //   padding-left: 0;
// //   list-style-type: none;
// // }
// //
// // ul:not(.browser-default) > li {
// //   list-style-type: none;
// // }
//
// a {
//   color: #ff411d;
//   text-decoration: none;
//   -webkit-tap-highlight-color: transparent;
// }
//
// .valign-wrapper {
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-align: center;
//   -webkit-align-items: center;
//       -ms-flex-align: center;
//           align-items: center;
// }
//
// .flex {
//   display: -webkit-box;
//   display: -moz-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -ms-flex-wrap: wrap;
//   -webkit-flex-wrap: wrap;
//   flex-wrap: wrap;
// }
//
// .clearfix {
//   clear: both;
// }
//
// .z-depth-0 {
//   -webkit-box-shadow: none !important;
//           box-shadow: none !important;
// }
//
// /* 2dp elevation modified*/
// .z-depth-1, nav, .card-panel, .card, .toast, .btn, .btn-large, .btn-small, .btn-floating, .dropdown-content, .collapsible, .sidenav {
//   -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//           box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
// .z-depth-1-half, .btn:hover, .btn-large:hover, .btn-small:hover, .btn-floating:hover {
//   -webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);
//           box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);
// }
//
// /* 6dp elevation modified*/
// .z-depth-2 {
//   -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//           box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
// }
//
// /* 12dp elevation modified*/
// .z-depth-3 {
//   -webkit-box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
//           box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
// }
//
// /* 16dp elevation */
// .z-depth-4 {
//   -webkit-box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -7px rgba(0, 0, 0, 0.2);
//           box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -7px rgba(0, 0, 0, 0.2);
// }
//
// /* 24dp elevation */
// .z-depth-5, .modal {
//   -webkit-box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.2);
//           box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.2);
// }
//
// .hoverable {
//   -webkit-transition: -webkit-box-shadow .25s;
//   transition: -webkit-box-shadow .25s;
//   transition: box-shadow .25s;
//   transition: box-shadow .25s, -webkit-box-shadow .25s;
// }
//
// .hoverable:hover {
//   -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
//           box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
// }
//
// .divider {
//   height: 1px;
//   overflow: hidden;
//   background-color: #e0e0e0;
// }
//
// blockquote {
//   margin: 20px 0;
//   padding-left: 1.5rem;
//   border-left: 5px solid #ee6e73;
// }
//
// i {
//   line-height: inherit;
// }
//
// i.left {
//   float: left;
//   margin-right: 15px;
// }
//
// i.right {
//   float: right;
//   margin-left: 15px;
// }
//
// i.tiny {
//   font-size: 1rem;
// }
//
// i.small {
//   font-size: 2rem;
// }
//
// i.medium {
//   font-size: 4rem;
// }
//
// i.large {
//   font-size: 6rem;
// }
//
// img.responsive-img,
// video.responsive-video {
//   max-width: 100%;
//   height: auto;
// }
//
// .pagination li {
//   display: inline-block;
//   border-radius: 2px;
//   text-align: center;
//   vertical-align: top;
//   height: 30px;
// }
//
// .pagination li a {
//   color: #444;
//   display: inline-block;
//   font-size: 1.2rem;
//   padding: 0 10px;
//   line-height: 30px;
// }
//
// .pagination li.active a {
//   color: #fff;
// }
//
// .pagination li.active {
//   background-color: #ee6e73;
// }
//
// .pagination li.disabled a {
//   cursor: default;
//   color: #999;
// }
//
// .pagination li i {
//   font-size: 2rem;
// }
//
// .pagination li.pages ul li {
//   display: inline-block;
//   float: none;
// }
//
// @media only screen and (max-width: 992px) {
//   .pagination {
//     width: 100%;
//   }
//   .pagination li.prev,
//   .pagination li.next {
//     width: 10%;
//   }
//   .pagination li.pages {
//     width: 80%;
//     overflow: hidden;
//     white-space: nowrap;
//   }
// }
//
// .breadcrumb {
//   font-size: 18px;
//   color: rgba(255, 255, 255, 0.7);
// }
//
// .breadcrumb i,
// .breadcrumb [class^="mdi-"], .breadcrumb [class*="mdi-"],
// .breadcrumb i.material-icons {
//   display: inline-block;
//   float: left;
//   font-size: 24px;
// }
//
// .breadcrumb:before {
//   content: '\\E5CC';
//   color: rgba(255, 255, 255, 0.7);
//   vertical-align: top;
//   display: inline-block;
//   font-family: 'Material Icons';
//   font-weight: normal;
//   font-style: normal;
//   font-size: 25px;
//   margin: 0 10px 0 8px;
//   -webkit-font-smoothing: antialiased;
// }
//
// .breadcrumb:first-child:before {
//   display: none;
// }
//
// .breadcrumb:last-child {
//   color: #fff;
// }
//
// .parallax-container {
//   position: relative;
//   overflow: hidden;
//   height: 500px;
// }
//
// .parallax-container .parallax {
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   z-index: -1;
// }
//
// .parallax-container .parallax img {
//   opacity: 0;
//   position: absolute;
//   left: 50%;
//   bottom: 0;
//   min-width: 100%;
//   min-height: 100%;
//   -webkit-transform: translate3d(0, 0, 0);
//           transform: translate3d(0, 0, 0);
//   -webkit-transform: translateX(-50%);
//           transform: translateX(-50%);
// }
//
// .pin-top, .pin-bottom {
//   position: relative;
// }
//
// .pinned {
//   position: fixed !important;
// }
//
// /*********************
//   Transition Classes
// **********************/
// ul.staggered-list li {
//   opacity: 0;
// }
//
// .fade-in {
//   opacity: 0;
//   -webkit-transform-origin: 0 50%;
//           transform-origin: 0 50%;
// }
//
// /*********************
//   Media Query Classes
// **********************/
// @media only screen and (max-width: 600px) {
//   .hide-on-small-only, .hide-on-small-and-down {
//     display: none !important;
//   }
// }
//
// @media only screen and (max-width: 992px) {
//   .hide-on-med-and-down {
//     display: none !important;
//   }
// }
//
// @media only screen and (min-width: 601px) {
//   .hide-on-med-and-up {
//     display: none !important;
//   }
// }
//
// @media only screen and (min-width: 600px) and (max-width: 992px) {
//   .hide-on-med-only {
//     display: none !important;
//   }
// }
//
// @media only screen and (min-width: 993px) {
//   .hide-on-large-only {
//     display: none !important;
//   }
// }
//
// @media only screen and (min-width: 1201px) {
//   .hide-on-extra-large-only {
//     display: none !important;
//   }
// }
//
// @media only screen and (min-width: 1201px) {
//   .show-on-extra-large {
//     display: block !important;
//   }
// }
//
// @media only screen and (min-width: 993px) {
//   .show-on-large {
//     display: block !important;
//   }
// }
//
// @media only screen and (min-width: 600px) and (max-width: 992px) {
//   .show-on-medium {
//     display: block !important;
//   }
// }
//
// @media only screen and (max-width: 600px) {
//   .show-on-small {
//     display: block !important;
//   }
// }
//
// @media only screen and (min-width: 601px) {
//   .show-on-medium-and-up {
//     display: block !important;
//   }
// }
//
// @media only screen and (max-width: 992px) {
//   .show-on-medium-and-down {
//     display: block !important;
//   }
// }
//
// @media only screen and (max-width: 600px) {
//   .center-on-small-only {
//     text-align: center;
//   }
// }
//
// .page-footer {
//   padding-top: 20px;
//   color: #fff;
//   background-color: #121212;
// }
//
// .page-footer .footer-copyright {
//   overflow: hidden;
//   min-height: 50px;
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-align: center;
//   -webkit-align-items: center;
//       -ms-flex-align: center;
//           align-items: center;
//   -webkit-box-pack: justify;
//   -webkit-justify-content: space-between;
//       -ms-flex-pack: justify;
//           justify-content: space-between;
//   padding: 10px 0px;
//   color: rgba(255, 255, 255, 0.8);
//   background-color: rgba(51, 51, 51, 0.08);
// }
//
// // table, th, td {
// //   border: none;
// // }
// //
// // table {
// //   width: 100%;
// //   display: table;
// //   border-collapse: collapse;
// //   border-spacing: 0;
// // }
// //
// // table.striped tr {
// //   border-bottom: none;
// // }
// //
// // table.striped > tbody > tr:nth-child(odd) {
// //   background-color: rgba(242, 242, 242, 0.5);
// // }
// //
// // table.striped > tbody > tr > td {
// //   border-radius: 0;
// // }
// //
// // table.highlight > tbody > tr {
// //   -webkit-transition: background-color .25s ease;
// //   transition: background-color .25s ease;
// // }
// //
// // table.highlight > tbody > tr:hover {
// //   background-color: rgba(242, 242, 242, 0.5);
// // }
// //
// // table.centered thead tr th, table.centered tbody tr td {
// //   text-align: center;
// // }
// //
// // tr {
// //   border-bottom: 1px solid rgba(0, 0, 0, 0.12);
// // }
// //
// // td, th {
// //   padding: 15px 5px;
// //   display: table-cell;
// //   text-align: left;
// //   vertical-align: middle;
// //   border-radius: 2px;
// // }
// //
// // @media only screen and (max-width: 992px) {
// //   table.responsive-table {
// //     width: 100%;
// //     border-collapse: collapse;
// //     border-spacing: 0;
// //     display: block;
// //     position: relative;
// //     /* sort out borders */
// //   }
// //   table.responsive-table td:empty:before {
// //     content: '\\00a0';
// //   }
// //   table.responsive-table th,
// //   table.responsive-table td {
// //     margin: 0;
// //     vertical-align: top;
// //   }
// //   table.responsive-table th {
// //     text-align: left;
// //   }
// //   table.responsive-table thead {
// //     display: block;
// //     float: left;
// //   }
// //   table.responsive-table thead tr {
// //     display: block;
// //     padding: 0 10px 0 0;
// //   }
// //   table.responsive-table thead tr th::before {
// //     content: "\\00a0";
// //   }
// //   table.responsive-table tbody {
// //     display: block;
// //     width: auto;
// //     position: relative;
// //     overflow-x: auto;
// //     white-space: nowrap;
// //   }
// //   table.responsive-table tbody tr {
// //     display: inline-block;
// //     vertical-align: top;
// //   }
// //   table.responsive-table th {
// //     display: block;
// //     text-align: right;
// //   }
// //   table.responsive-table td {
// //     display: block;
// //     min-height: 1.25em;
// //     text-align: left;
// //   }
// //   table.responsive-table tr {
// //     border-bottom: none;
// //     padding: 0 10px;
// //   }
// //   table.responsive-table thead {
// //     border: 0;
// //     border-right: 1px solid rgba(0, 0, 0, 0.12);
// //   }
// // }
//
// .collection {
//   margin: 0.5rem 0 1rem 0;
//   border: 1px solid #e0e0e0;
//   border-radius: 2px;
//   overflow: hidden;
//   position: relative;
// }
//
// .collection .collection-item {
//   background-color: #fff;
//   line-height: 1.5rem;
//   padding: 10px 20px;
//   margin: 0;
//   border-bottom: 1px solid #e0e0e0;
// }
//
// .collection .collection-item.avatar {
//   min-height: 84px;
//   padding-left: 72px;
//   position: relative;
// }
//
// .collection .collection-item.avatar:not(.circle-clipper) > .circle,
// .collection .collection-item.avatar :not(.circle-clipper) > .circle {
//   position: absolute;
//   width: 42px;
//   height: 42px;
//   overflow: hidden;
//   left: 15px;
//   display: inline-block;
//   vertical-align: middle;
// }
//
// .collection .collection-item.avatar i.circle {
//   font-size: 18px;
//   line-height: 42px;
//   color: #fff;
//   background-color: #999;
//   text-align: center;
// }
//
// .collection .collection-item.avatar .title {
//   font-size: 16px;
// }
//
// .collection .collection-item.avatar p {
//   margin: 0;
// }
//
// .collection .collection-item.avatar .secondary-content {
//   position: absolute;
//   top: 16px;
//   right: 16px;
// }
//
// .collection .collection-item:last-child {
//   border-bottom: none;
// }
//
// .collection .collection-item.active {
//   background-color: #ff411d;
//   color: #eafaf9;
// }
//
// .collection .collection-item.active .secondary-content {
//   color: #fff;
// }
//
// .collection a.collection-item {
//   display: block;
//   -webkit-transition: .25s;
//   transition: .25s;
//   color: #ff411d;
// }
//
// .collection a.collection-item:not(.active):hover {
//   background-color: #ddd;
// }
//
// .collection.with-header .collection-header {
//   background-color: #fff;
//   border-bottom: 1px solid #e0e0e0;
//   padding: 10px 20px;
// }
//
// .collection.with-header .collection-item {
//   padding-left: 30px;
// }
//
// .collection.with-header .collection-item.avatar {
//   padding-left: 72px;
// }
//
// .secondary-content {
//   float: right;
//   color: #ff411d;
// }
//
// .collapsible .collection {
//   margin: 0;
//   border: none;
// }
//
// .video-container {
//   position: relative;
//   padding-bottom: 56.25%;
//   height: 0;
//   overflow: hidden;
// }
//
// .video-container iframe, .video-container object, .video-container embed {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
// }
//
// .progress {
//   position: relative;
//   height: 4px;
//   display: block;
//   width: 100%;
//   background-color: #acece6;
//   border-radius: 2px;
//   margin: 0.5rem 0 1rem 0;
//   overflow: hidden;
// }
//
// .progress .determinate {
//   position: absolute;
//   top: 0;
//   left: 0;
//   bottom: 0;
//   background-color: #ff411d;
//   -webkit-transition: width .3s linear;
//   transition: width .3s linear;
// }
//
// .progress .indeterminate {
//   background-color: #ff411d;
// }
//
// .progress .indeterminate:before {
//   content: '';
//   position: absolute;
//   background-color: inherit;
//   top: 0;
//   left: 0;
//   bottom: 0;
//   will-change: left, right;
//   -webkit-animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
//           animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
// }
//
// .progress .indeterminate:after {
//   content: '';
//   position: absolute;
//   background-color: inherit;
//   top: 0;
//   left: 0;
//   bottom: 0;
//   will-change: left, right;
//   -webkit-animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
//           animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
//   -webkit-animation-delay: 1.15s;
//           animation-delay: 1.15s;
// }
//
// @-webkit-keyframes indeterminate {
//   0% {
//     left: -35%;
//     right: 100%;
//   }
//   60% {
//     left: 100%;
//     right: -90%;
//   }
//   100% {
//     left: 100%;
//     right: -90%;
//   }
// }
//
// @keyframes indeterminate {
//   0% {
//     left: -35%;
//     right: 100%;
//   }
//   60% {
//     left: 100%;
//     right: -90%;
//   }
//   100% {
//     left: 100%;
//     right: -90%;
//   }
// }
//
// @-webkit-keyframes indeterminate-short {
//   0% {
//     left: -200%;
//     right: 100%;
//   }
//   60% {
//     left: 107%;
//     right: -8%;
//   }
//   100% {
//     left: 107%;
//     right: -8%;
//   }
// }
//
// @keyframes indeterminate-short {
//   0% {
//     left: -200%;
//     right: 100%;
//   }
//   60% {
//     left: 107%;
//     right: -8%;
//   }
//   100% {
//     left: 107%;
//     right: -8%;
//   }
// }
//
// /*******************
//   Utility Classes
// *******************/
// .hide {
//   display: none !important;
// }
//
// .left-align {
//   text-align: left;
// }
//
// .right-align {
//   text-align: right;
// }
//
// .center, .center-align {
//   text-align: center;
// }
//
// .left {
//   float: left !important;
// }
//
// .right {
//   float: right !important;
// }
//
// .no-select, input[type=range],
// input[type=range] + .thumb {
//   -webkit-user-select: none;
//      -moz-user-select: none;
//       -ms-user-select: none;
//           user-select: none;
// }
//
// .circle {
//   border-radius: 50%;
// }
//
// .center-block {
//   display: block;
//   margin-left: auto;
//   margin-right: auto;
// }
//
// .truncate {
//   display: block;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }
//
// .no-padding {
//   padding: 0 !important;
// }
//
// span.badge {
//   min-width: 3rem;
//   padding: 0 6px;
//   margin-left: 14px;
//   text-align: center;
//   font-size: 1rem;
//   line-height: 22px;
//   height: 22px;
//   color: #757575;
//   float: right;
//   -webkit-box-sizing: border-box;
//           box-sizing: border-box;
// }
//
// span.badge.new {
//   font-weight: 300;
//   font-size: 0.8rem;
//   color: #fff;
//   background-color: #ff411d;
//   border-radius: 2px;
// }
//
// span.badge.new:after {
//   content: " new";
// }
//
// span.badge[data-badge-caption]::after {
//   content: " " attr(data-badge-caption);
// }
//
// nav ul a span.badge {
//   display: inline-block;
//   float: none;
//   margin-left: 4px;
//   line-height: 22px;
//   height: 22px;
// }
//
// .collection-item span.badge {
//   margin-top: calc(0.75rem - 11px);
// }
//
// .collapsible span.badge {
//   margin-left: auto;
// }
//
// .sidenav span.badge {
//   margin-top: calc(24px - 11px);
// }
//
// table span.badge {
//   display: inline-block;
//   float: none;
//   margin-left: auto;
// }
//
// /* This is needed for some mobile phones to display the Google Icon font properly */
// .material-icons {
//   text-rendering: optimizeLegibility;
//   -webkit-font-feature-settings: 'liga';
//      -moz-font-feature-settings: 'liga';
//           font-feature-settings: 'liga';
// }
//
// .container {
//   margin: 0 auto;
//   max-width: 1280px;
//   width: 90%;
// }
//
// @media only screen and (min-width: 601px) {
//   .container {
//     width: 85%;
//   }
// }
//
// @media only screen and (min-width: 993px) {
//   .container {
//     width: 70%;
//   }
// }
//
// .col .row {
//   margin-left: -0.75rem;
//   margin-right: -0.75rem;
// }
//
// .section {
//   padding-top: 1rem;
//   padding-bottom: 1rem;
// }
//
// .section.no-pad {
//   padding: 0;
// }
//
// .section.no-pad-bot {
//   padding-bottom: 0;
// }
//
// .section.no-pad-top {
//   padding-top: 0;
// }
//
// .row {
//   margin-left: auto;
//   margin-right: auto;
//   margin-bottom: 20px;
// }
//
// .row.no-margin-row {
//   margin-bottom: 0;
// }
//
// .row:after {
//   content: "";
//   display: table;
//   clear: both;
// }
//
// .row .col {
//   float: left;
//   -webkit-box-sizing: border-box;
//           box-sizing: border-box;
//   padding: 0 0.75rem;
//   min-height: 1px;
// }
//
// .row .col[class*="push-"], .row .col[class*="pull-"] {
//   position: relative;
// }
//
// .row .col.s1 {
//   width: 8.3333333333%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.s2 {
//   width: 16.6666666667%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.s3 {
//   width: 25%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.s4 {
//   width: 33.3333333333%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.s5 {
//   width: 41.6666666667%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.s6 {
//   width: 50%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.s7 {
//   width: 58.3333333333%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.s8 {
//   width: 66.6666666667%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.s9 {
//   width: 75%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.s10 {
//   width: 83.3333333333%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.s11 {
//   width: 91.6666666667%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.s12 {
//   width: 100%;
//   margin-left: auto;
//   left: auto;
//   right: auto;
// }
//
// .row .col.offset-s1 {
//   margin-left: 8.3333333333%;
// }
//
// .row .col.pull-s1 {
//   right: 8.3333333333%;
// }
//
// .row .col.push-s1 {
//   left: 8.3333333333%;
// }
//
// .row .col.offset-s2 {
//   margin-left: 16.6666666667%;
// }
//
// .row .col.pull-s2 {
//   right: 16.6666666667%;
// }
//
// .row .col.push-s2 {
//   left: 16.6666666667%;
// }
//
// .row .col.offset-s3 {
//   margin-left: 25%;
// }
//
// .row .col.pull-s3 {
//   right: 25%;
// }
//
// .row .col.push-s3 {
//   left: 25%;
// }
//
// .row .col.offset-s4 {
//   margin-left: 33.3333333333%;
// }
//
// .row .col.pull-s4 {
//   right: 33.3333333333%;
// }
//
// .row .col.push-s4 {
//   left: 33.3333333333%;
// }
//
// .row .col.offset-s5 {
//   margin-left: 41.6666666667%;
// }
//
// .row .col.pull-s5 {
//   right: 41.6666666667%;
// }
//
// .row .col.push-s5 {
//   left: 41.6666666667%;
// }
//
// .row .col.offset-s6 {
//   margin-left: 50%;
// }
//
// .row .col.pull-s6 {
//   right: 50%;
// }
//
// .row .col.push-s6 {
//   left: 50%;
// }
//
// .row .col.offset-s7 {
//   margin-left: 58.3333333333%;
// }
//
// .row .col.pull-s7 {
//   right: 58.3333333333%;
// }
//
// .row .col.push-s7 {
//   left: 58.3333333333%;
// }
//
// .row .col.offset-s8 {
//   margin-left: 66.6666666667%;
// }
//
// .row .col.pull-s8 {
//   right: 66.6666666667%;
// }
//
// .row .col.push-s8 {
//   left: 66.6666666667%;
// }
//
// .row .col.offset-s9 {
//   margin-left: 75%;
// }
//
// .row .col.pull-s9 {
//   right: 75%;
// }
//
// .row .col.push-s9 {
//   left: 75%;
// }
//
// .row .col.offset-s10 {
//   margin-left: 83.3333333333%;
// }
//
// .row .col.pull-s10 {
//   right: 83.3333333333%;
// }
//
// .row .col.push-s10 {
//   left: 83.3333333333%;
// }
//
// .row .col.offset-s11 {
//   margin-left: 91.6666666667%;
// }
//
// .row .col.pull-s11 {
//   right: 91.6666666667%;
// }
//
// .row .col.push-s11 {
//   left: 91.6666666667%;
// }
//
// .row .col.offset-s12 {
//   margin-left: 100%;
// }
//
// .row .col.pull-s12 {
//   right: 100%;
// }
//
// .row .col.push-s12 {
//   left: 100%;
// }
//
// @media only screen and (min-width: 601px) {
//   .row .col.m1 {
//     width: 8.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.m2 {
//     width: 16.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.m3 {
//     width: 25%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.m4 {
//     width: 33.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.m5 {
//     width: 41.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.m6 {
//     width: 50%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.m7 {
//     width: 58.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.m8 {
//     width: 66.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.m9 {
//     width: 75%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.m10 {
//     width: 83.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.m11 {
//     width: 91.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.m12 {
//     width: 100%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.offset-m1 {
//     margin-left: 8.3333333333%;
//   }
//   .row .col.pull-m1 {
//     right: 8.3333333333%;
//   }
//   .row .col.push-m1 {
//     left: 8.3333333333%;
//   }
//   .row .col.offset-m2 {
//     margin-left: 16.6666666667%;
//   }
//   .row .col.pull-m2 {
//     right: 16.6666666667%;
//   }
//   .row .col.push-m2 {
//     left: 16.6666666667%;
//   }
//   .row .col.offset-m3 {
//     margin-left: 25%;
//   }
//   .row .col.pull-m3 {
//     right: 25%;
//   }
//   .row .col.push-m3 {
//     left: 25%;
//   }
//   .row .col.offset-m4 {
//     margin-left: 33.3333333333%;
//   }
//   .row .col.pull-m4 {
//     right: 33.3333333333%;
//   }
//   .row .col.push-m4 {
//     left: 33.3333333333%;
//   }
//   .row .col.offset-m5 {
//     margin-left: 41.6666666667%;
//   }
//   .row .col.pull-m5 {
//     right: 41.6666666667%;
//   }
//   .row .col.push-m5 {
//     left: 41.6666666667%;
//   }
//   .row .col.offset-m6 {
//     margin-left: 50%;
//   }
//   .row .col.pull-m6 {
//     right: 50%;
//   }
//   .row .col.push-m6 {
//     left: 50%;
//   }
//   .row .col.offset-m7 {
//     margin-left: 58.3333333333%;
//   }
//   .row .col.pull-m7 {
//     right: 58.3333333333%;
//   }
//   .row .col.push-m7 {
//     left: 58.3333333333%;
//   }
//   .row .col.offset-m8 {
//     margin-left: 66.6666666667%;
//   }
//   .row .col.pull-m8 {
//     right: 66.6666666667%;
//   }
//   .row .col.push-m8 {
//     left: 66.6666666667%;
//   }
//   .row .col.offset-m9 {
//     margin-left: 75%;
//   }
//   .row .col.pull-m9 {
//     right: 75%;
//   }
//   .row .col.push-m9 {
//     left: 75%;
//   }
//   .row .col.offset-m10 {
//     margin-left: 83.3333333333%;
//   }
//   .row .col.pull-m10 {
//     right: 83.3333333333%;
//   }
//   .row .col.push-m10 {
//     left: 83.3333333333%;
//   }
//   .row .col.offset-m11 {
//     margin-left: 91.6666666667%;
//   }
//   .row .col.pull-m11 {
//     right: 91.6666666667%;
//   }
//   .row .col.push-m11 {
//     left: 91.6666666667%;
//   }
//   .row .col.offset-m12 {
//     margin-left: 100%;
//   }
//   .row .col.pull-m12 {
//     right: 100%;
//   }
//   .row .col.push-m12 {
//     left: 100%;
//   }
// }
//
// @media only screen and (min-width: 993px) {
//   .row .col.l1 {
//     width: 8.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.l2 {
//     width: 16.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.l3 {
//     width: 25%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.l4 {
//     width: 33.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.l5 {
//     width: 41.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.l6 {
//     width: 50%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.l7 {
//     width: 58.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.l8 {
//     width: 66.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.l9 {
//     width: 75%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.l10 {
//     width: 83.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.l11 {
//     width: 91.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.l12 {
//     width: 100%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.offset-l1 {
//     margin-left: 8.3333333333%;
//   }
//   .row .col.pull-l1 {
//     right: 8.3333333333%;
//   }
//   .row .col.push-l1 {
//     left: 8.3333333333%;
//   }
//   .row .col.offset-l2 {
//     margin-left: 16.6666666667%;
//   }
//   .row .col.pull-l2 {
//     right: 16.6666666667%;
//   }
//   .row .col.push-l2 {
//     left: 16.6666666667%;
//   }
//   .row .col.offset-l3 {
//     margin-left: 25%;
//   }
//   .row .col.pull-l3 {
//     right: 25%;
//   }
//   .row .col.push-l3 {
//     left: 25%;
//   }
//   .row .col.offset-l4 {
//     margin-left: 33.3333333333%;
//   }
//   .row .col.pull-l4 {
//     right: 33.3333333333%;
//   }
//   .row .col.push-l4 {
//     left: 33.3333333333%;
//   }
//   .row .col.offset-l5 {
//     margin-left: 41.6666666667%;
//   }
//   .row .col.pull-l5 {
//     right: 41.6666666667%;
//   }
//   .row .col.push-l5 {
//     left: 41.6666666667%;
//   }
//   .row .col.offset-l6 {
//     margin-left: 50%;
//   }
//   .row .col.pull-l6 {
//     right: 50%;
//   }
//   .row .col.push-l6 {
//     left: 50%;
//   }
//   .row .col.offset-l7 {
//     margin-left: 58.3333333333%;
//   }
//   .row .col.pull-l7 {
//     right: 58.3333333333%;
//   }
//   .row .col.push-l7 {
//     left: 58.3333333333%;
//   }
//   .row .col.offset-l8 {
//     margin-left: 66.6666666667%;
//   }
//   .row .col.pull-l8 {
//     right: 66.6666666667%;
//   }
//   .row .col.push-l8 {
//     left: 66.6666666667%;
//   }
//   .row .col.offset-l9 {
//     margin-left: 75%;
//   }
//   .row .col.pull-l9 {
//     right: 75%;
//   }
//   .row .col.push-l9 {
//     left: 75%;
//   }
//   .row .col.offset-l10 {
//     margin-left: 83.3333333333%;
//   }
//   .row .col.pull-l10 {
//     right: 83.3333333333%;
//   }
//   .row .col.push-l10 {
//     left: 83.3333333333%;
//   }
//   .row .col.offset-l11 {
//     margin-left: 91.6666666667%;
//   }
//   .row .col.pull-l11 {
//     right: 91.6666666667%;
//   }
//   .row .col.push-l11 {
//     left: 91.6666666667%;
//   }
//   .row .col.offset-l12 {
//     margin-left: 100%;
//   }
//   .row .col.pull-l12 {
//     right: 100%;
//   }
//   .row .col.push-l12 {
//     left: 100%;
//   }
// }
//
// @media only screen and (min-width: 1201px) {
//   .row .col.xl1 {
//     width: 8.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.xl2 {
//     width: 16.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.xl3 {
//     width: 25%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.xl4 {
//     width: 33.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.xl5 {
//     width: 41.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.xl6 {
//     width: 50%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.xl7 {
//     width: 58.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.xl8 {
//     width: 66.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.xl9 {
//     width: 75%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.xl10 {
//     width: 83.3333333333%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.xl11 {
//     width: 91.6666666667%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.xl12 {
//     width: 100%;
//     margin-left: auto;
//     left: auto;
//     right: auto;
//   }
//   .row .col.offset-xl1 {
//     margin-left: 8.3333333333%;
//   }
//   .row .col.pull-xl1 {
//     right: 8.3333333333%;
//   }
//   .row .col.push-xl1 {
//     left: 8.3333333333%;
//   }
//   .row .col.offset-xl2 {
//     margin-left: 16.6666666667%;
//   }
//   .row .col.pull-xl2 {
//     right: 16.6666666667%;
//   }
//   .row .col.push-xl2 {
//     left: 16.6666666667%;
//   }
//   .row .col.offset-xl3 {
//     margin-left: 25%;
//   }
//   .row .col.pull-xl3 {
//     right: 25%;
//   }
//   .row .col.push-xl3 {
//     left: 25%;
//   }
//   .row .col.offset-xl4 {
//     margin-left: 33.3333333333%;
//   }
//   .row .col.pull-xl4 {
//     right: 33.3333333333%;
//   }
//   .row .col.push-xl4 {
//     left: 33.3333333333%;
//   }
//   .row .col.offset-xl5 {
//     margin-left: 41.6666666667%;
//   }
//   .row .col.pull-xl5 {
//     right: 41.6666666667%;
//   }
//   .row .col.push-xl5 {
//     left: 41.6666666667%;
//   }
//   .row .col.offset-xl6 {
//     margin-left: 50%;
//   }
//   .row .col.pull-xl6 {
//     right: 50%;
//   }
//   .row .col.push-xl6 {
//     left: 50%;
//   }
//   .row .col.offset-xl7 {
//     margin-left: 58.3333333333%;
//   }
//   .row .col.pull-xl7 {
//     right: 58.3333333333%;
//   }
//   .row .col.push-xl7 {
//     left: 58.3333333333%;
//   }
//   .row .col.offset-xl8 {
//     margin-left: 66.6666666667%;
//   }
//   .row .col.pull-xl8 {
//     right: 66.6666666667%;
//   }
//   .row .col.push-xl8 {
//     left: 66.6666666667%;
//   }
//   .row .col.offset-xl9 {
//     margin-left: 75%;
//   }
//   .row .col.pull-xl9 {
//     right: 75%;
//   }
//   .row .col.push-xl9 {
//     left: 75%;
//   }
//   .row .col.offset-xl10 {
//     margin-left: 83.3333333333%;
//   }
//   .row .col.pull-xl10 {
//     right: 83.3333333333%;
//   }
//   .row .col.push-xl10 {
//     left: 83.3333333333%;
//   }
//   .row .col.offset-xl11 {
//     margin-left: 91.6666666667%;
//   }
//   .row .col.pull-xl11 {
//     right: 91.6666666667%;
//   }
//   .row .col.push-xl11 {
//     left: 91.6666666667%;
//   }
//   .row .col.offset-xl12 {
//     margin-left: 100%;
//   }
//   .row .col.pull-xl12 {
//     right: 100%;
//   }
//   .row .col.push-xl12 {
//     left: 100%;
//   }
// }
//
// nav {
//   color: #222;
//   background-color: #fff;
//   width: 100%;
//   height: 56px;
//   line-height: 56px;
//   padding: 0 3%;
// }
//
// nav.nav-extended {
//   height: auto;
// }
//
// nav.nav-extended .nav-wrapper {
//   min-height: 56px;
//   height: auto;
// }
//
// nav.nav-extended .nav-content {
//   position: relative;
//   line-height: normal;
// }
//
// nav a {
//   color: inherit;
//   outline:none!important;
// }
//
// nav i,
// nav [class^="mdi-"], nav [class*="mdi-"],
// nav i.material-icons {
//   display: block;
//   font-size: 24px;
//   height: 56px;
//   line-height: 56px;
// }
//
// nav .nav-wrapper {
//   position: relative;
//   height: 100%;
// }
//
// @media only screen and (min-width: 993px) {
//   nav a.sidenav-trigger {
//     display: none;
//   }
// }
//
// nav .sidenav-trigger {
//   float: left;
//   position: relative;
//   z-index: 1;
//   height: 56px;
//   margin: 0 18px;
// }
//
// nav .sidenav-trigger i {
//   height: 56px;
//   line-height: 56px;
// }
//
// nav .brand-logo {
//   position: absolute;
//   color: #fff;
//   display: inline-block;
//   font-size: 2.1rem;
//   padding: 0;
//   height: 100%;
// }
//
// nav .brand-logo.center {
//   left: 50%;
//   -webkit-transform: translateX(-50%);
//           transform: translateX(-50%);
// }
//
// @media only screen and (max-width: 992px) {
//   nav .brand-logo {
//     left: 50%;
//     -webkit-transform: translateX(-50%);
//             transform: translateX(-50%);
//   }
//   nav .brand-logo.left, nav .brand-logo.right {
//     padding: 0;
//     -webkit-transform: none;
//             transform: none;
//   }
//   nav .brand-logo.left {
//     left: 0.5rem;
//   }
//   nav .brand-logo.right {
//     right: 0.5rem;
//     left: auto;
//   }
// }
//
// nav .brand-logo.right {
//   right: 0.5rem;
//   padding: 0;
// }
//
// nav .brand-logo i,
// nav .brand-logo [class^="mdi-"], nav .brand-logo [class*="mdi-"],
// nav .brand-logo i.material-icons {
//   float: left;
//   margin-right: 15px;
// }
//
// nav .nav-title {
//   display: inline-block;
//   font-size: 32px;
//   padding: 28px 0;
// }
//
// nav ul {
//   margin: 0;
// }
//
// nav ul li {
//   -webkit-transition: background-color .3s;
//   transition: background-color .3s;
//   float: left;
//   padding: 0;
// }
//
// nav ul li.active {
//   background-color: rgba(0, 0, 0, 0.1);
// }
//
// nav ul a {
//   -webkit-transition: background-color .3s;
//   transition: background-color .3s;
//   font-size: 1rem;
//   color: inherit;
//   display: block;
//   padding: 0 15px;
//   cursor: pointer;
// }
//
// nav ul a.btn, nav ul a.btn-large, nav ul a.btn-small, nav ul a.btn-large, nav ul a.btn-flat, nav ul a.btn-floating {
//   margin-top: -2px;
//   margin-left: 15px;
//   margin-right: 15px;
// }
//
// nav ul a.btn > .material-icons, nav ul a.btn-large > .material-icons, nav ul a.btn-small > .material-icons, nav ul a.btn-large > .material-icons, nav ul a.btn-flat > .material-icons, nav ul a.btn-floating > .material-icons {
//   height: inherit;
//   line-height: inherit;
// }
//
// nav ul a:hover {
//   background-color: rgba(0, 0, 0, 0.1);
// }
//
// nav ul.left {
//   float: left;
// }
//
// nav form {
//   height: 100%;
// }
//
// nav .input-field {
//   margin: 0;
//   height: 100%;
// }
//
// nav .input-field input {
//   height: 100%;
//   font-size: 1.2rem;
//   border: none;
//   padding-left: 2rem;
// }
//
// nav .input-field input:focus, nav .input-field input[type=text]:valid, nav .input-field input[type=password]:valid, nav .input-field input[type=email]:valid, nav .input-field input[type=url]:valid, nav .input-field input[type=date]:valid {
//   border: none;
//   -webkit-box-shadow: none;
//           box-shadow: none;
// }
//
// nav .input-field label {
//   top: 0;
//   left: 0;
// }
//
// nav .input-field label i {
//   color: rgba(255, 255, 255, 0.7);
//   -webkit-transition: color .3s;
//   transition: color .3s;
// }
//
// nav .input-field label.active i {
//   color: #fff;
// }
//
// .navbar-fixed {
//   position: relative;
//   height: 56px;
//   z-index: 997;
// }
//
// .navbar-fixed nav {
//   position: fixed;
// }
//
// header nav .brand-logo img {
//
//   height: 56px;
//   width: auto;
//   padding: 0;
//
// }
//
// @media only screen and (min-width: 601px) {
//   nav.nav-extended .nav-wrapper {
//     min-height: 64px;
//   }
//   nav, nav .nav-wrapper i, nav a.sidenav-trigger, nav a.sidenav-trigger i {
//     height: 64px;
//     line-height: 64px;
//   }
//   .navbar-fixed {
//     height: 64px;
//   }
//
//   header nav .brand-logo img {
//
//     height: 64px;
//     width: auto;
//     padding: 5px;
//
//   }
// }
//
// a {
//   text-decoration: none;
// }
//
// html {
//   line-height: 1.5;
//   font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
//   font-weight: normal;
//   color: rgba(0, 0, 0, 0.87);
// }
//
// @media only screen and (min-width: 0) {
//   html {
//     font-size: 14px;
//   }
// }
//
// @media only screen and (min-width: 992px) {
//   html {
//     font-size: 14.5px;
//   }
// }
//
// @media only screen and (min-width: 1200px) {
//   html {
//     font-size: 15px;
//   }
// }
//
// h1, h2, h3, h4, h5, h6 {
//   font-weight: 400;
//   line-height: 1.3;
// }
//
// h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
//   font-weight: inherit;
// }
//
// h1 {
//   font-size: 4.2rem;
//   line-height: 110%;
//   margin: 2.8rem 0 1.68rem 0;
// }
//
// h2 {
//   font-size: 3.56rem;
//   line-height: 110%;
//   margin: 2.3733333333rem 0 1.424rem 0;
// }
//
// h3 {
//   font-size: 2.92rem;
//   line-height: 110%;
//   margin: 1.9466666667rem 0 1.168rem 0;
// }
//
// h4 {
//   font-size: 2.28rem;
//   line-height: 110%;
//   margin: 1.52rem 0 0.912rem 0;
// }
//
// h5 {
//   font-size: 1.64rem;
//   line-height: 110%;
//   margin: 1.0933333333rem 0 0.656rem 0;
// }
//
// h6 {
//   font-size: 1.15rem;
//   line-height: 110%;
//   margin: 0.7666666667rem 0 0.46rem 0;
// }
//
// em {
//   font-style: italic;
// }
//
// strong {
//   font-weight: 700;
// }
//
// small {
//   font-size: 75%;
// }
//
// .light {
//   font-weight: 300;
// }
//
// .thin {
//   font-weight: 200;
// }
//
// @media only screen and (min-width: 360px) {
//   .flow-text {
//     font-size: 1.2rem;
//   }
// }
//
// @media only screen and (min-width: 390px) {
//   .flow-text {
//     font-size: 1.224rem;
//   }
// }
//
// @media only screen and (min-width: 420px) {
//   .flow-text {
//     font-size: 1.248rem;
//   }
// }
//
// @media only screen and (min-width: 450px) {
//   .flow-text {
//     font-size: 1.272rem;
//   }
// }
//
// @media only screen and (min-width: 480px) {
//   .flow-text {
//     font-size: 1.296rem;
//   }
// }
//
// @media only screen and (min-width: 510px) {
//   .flow-text {
//     font-size: 1.32rem;
//   }
// }
//
// @media only screen and (min-width: 540px) {
//   .flow-text {
//     font-size: 1.344rem;
//   }
// }
//
// @media only screen and (min-width: 570px) {
//   .flow-text {
//     font-size: 1.368rem;
//   }
// }
//
// @media only screen and (min-width: 600px) {
//   .flow-text {
//     font-size: 1.392rem;
//   }
// }
//
// @media only screen and (min-width: 630px) {
//   .flow-text {
//     font-size: 1.416rem;
//   }
// }
//
// @media only screen and (min-width: 660px) {
//   .flow-text {
//     font-size: 1.44rem;
//   }
// }
//
// @media only screen and (min-width: 690px) {
//   .flow-text {
//     font-size: 1.464rem;
//   }
// }
//
// @media only screen and (min-width: 720px) {
//   .flow-text {
//     font-size: 1.488rem;
//   }
// }
//
// @media only screen and (min-width: 750px) {
//   .flow-text {
//     font-size: 1.512rem;
//   }
// }
//
// @media only screen and (min-width: 780px) {
//   .flow-text {
//     font-size: 1.536rem;
//   }
// }
//
// @media only screen and (min-width: 810px) {
//   .flow-text {
//     font-size: 1.56rem;
//   }
// }
//
// @media only screen and (min-width: 840px) {
//   .flow-text {
//     font-size: 1.584rem;
//   }
// }
//
// @media only screen and (min-width: 870px) {
//   .flow-text {
//     font-size: 1.608rem;
//   }
// }
//
// @media only screen and (min-width: 900px) {
//   .flow-text {
//     font-size: 1.632rem;
//   }
// }
//
// @media only screen and (min-width: 930px) {
//   .flow-text {
//     font-size: 1.656rem;
//   }
// }
//
// @media only screen and (min-width: 960px) {
//   .flow-text {
//     font-size: 1.68rem;
//   }
// }
//
// @media only screen and (max-width: 360px) {
//   .flow-text {
//     font-size: 1.2rem;
//   }
// }
//
// .scale-transition {
//   -webkit-transition: -webkit-transform 0.3s cubic-bezier(0.53, 0.01, 0.36, 1.63) !important;
//   transition: -webkit-transform 0.3s cubic-bezier(0.53, 0.01, 0.36, 1.63) !important;
//   transition: transform 0.3s cubic-bezier(0.53, 0.01, 0.36, 1.63), -webkit-transform 0.3s cubic-bezier(0.53, 0.01, 0.36, 1.63) !important;
// }
//
// .scale-transition.scale-out {
//   -webkit-transform: scale(0);
//           transform: scale(0);
//   -webkit-transition: -webkit-transform .2s !important;
//   transition: -webkit-transform .2s !important;
//   transition: transform .2s, -webkit-transform .2s !important;
// }
//
// .scale-transition.scale-in {
//   -webkit-transform: scale(1);
//           transform: scale(1);
// }
//
// .card-panel {
//   -webkit-transition: -webkit-box-shadow .25s;
//   transition: -webkit-box-shadow .25s;
//   transition: box-shadow .25s, -webkit-box-shadow .25s;
//   padding: 24px;
//   margin: 0.5rem 0 1rem 0;
//   border-radius: 2px;
//   background-color: #fff;
// }
//
// .card {
//   position: relative;
//   margin: 0.5rem 0 1rem 0;
//   background-color: #fff;
//   -webkit-transition: -webkit-box-shadow .25s;
//   transition: -webkit-box-shadow .25s;
//   transition: box-shadow .25s, -webkit-box-shadow .25s;
//   border-radius: 2px;
// }
//
// .card .card-title {
//   font-size: 24px;
//   font-weight: 300;
// }
//
// .card .card-title.activator {
//   cursor: pointer;
// }
//
// .card.small, .card.medium, .card.large {
//   position: relative;
// }
//
// .card.small .card-image, .card.medium .card-image, .card.large .card-image {
//   max-height: 60%;
//   overflow: hidden;
// }
//
// .card.small .card-image + .card-content, .card.medium .card-image + .card-content, .card.large .card-image + .card-content {
//   max-height: 40%;
// }
//
// .card.small .card-content, .card.medium .card-content, .card.large .card-content {
//   max-height: 100%;
//   overflow: hidden;
// }
//
// .card.small .card-action, .card.medium .card-action, .card.large .card-action {
//   position: absolute;
//   bottom: 0;
//   left: 0;
//   right: 0;
// }
//
// .card.small {
//   height: 300px;
// }
//
// .card.medium {
//   height: 400px;
// }
//
// .card.large {
//   height: 500px;
// }
//
// .card.horizontal {
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
// }
//
// .card.horizontal.small .card-image, .card.horizontal.medium .card-image, .card.horizontal.large .card-image {
//   height: 100%;
//   max-height: none;
//   overflow: visible;
// }
//
// .card.horizontal.small .card-image img, .card.horizontal.medium .card-image img, .card.horizontal.large .card-image img {
//   height: 100%;
// }
//
// .card.horizontal .card-image {
//   max-width: 50%;
// }
//
// .card.horizontal .card-image img {
//   border-radius: 2px 0 0 2px;
//   max-width: 100%;
//   width: auto;
// }
//
// .card.horizontal .card-stacked {
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-orient: vertical;
//   -webkit-box-direction: normal;
//   -webkit-flex-direction: column;
//       -ms-flex-direction: column;
//           flex-direction: column;
//   -webkit-box-flex: 1;
//   -webkit-flex: 1;
//       -ms-flex: 1;
//           flex: 1;
//   position: relative;
// }
//
// .card.horizontal .card-stacked .card-content {
//   -webkit-box-flex: 1;
//   -webkit-flex-grow: 1;
//           flex-grow: 1;
// }
//
// .card.sticky-action .card-action {
//   z-index: 2;
// }
//
// .card.sticky-action .card-reveal {
//   z-index: 1;
//   padding-bottom: 64px;
// }
//
// .card .card-image {
//   position: relative;
// }
//
// .card .card-image img {
//   display: block;
//   border-radius: 2px 2px 0 0;
//   position: relative;
//   left: 0;
//   right: 0;
//   top: 0;
//   bottom: 0;
//   width: 100%;
// }
//
// .card .card-image .card-title {
//   color: #fff;
//   position: absolute;
//   bottom: 0;
//   left: 0;
//   max-width: 100%;
//   padding: 24px;
// }
//
// .card .card-content {
//   padding: 24px;
//   border-radius: 0 0 2px 2px;
// }
//
// .card .card-content p {
//   margin: 0;
// }
//
// .card .card-content .card-title {
//   display: block;
//   line-height: 32px;
//   margin-bottom: 8px;
// }
//
// .card .card-content .card-title i {
//   line-height: 32px;
// }
//
// .card .card-action {
//   background-color: inherit;
//   border-top: 1px solid rgba(160, 160, 160, 0.2);
//   position: relative;
//   padding: 16px 24px;
// }
//
// .card .card-action:last-child {
//   border-radius: 0 0 2px 2px;
// }
//
// .card .card-action a:not(.btn):not(.btn-large):not(.btn-small):not(.btn-large):not(.btn-floating) {
//   color: #ffab40;
//   margin-right: 24px;
//   -webkit-transition: color .3s ease;
//   transition: color .3s ease;
//   text-transform: uppercase;
// }
//
// .card .card-action a:not(.btn):not(.btn-large):not(.btn-small):not(.btn-large):not(.btn-floating):hover {
//   color: #ffd8a6;
// }
//
// .btn {
//   transition:0.2s ease-in;
// }
//
// .card .card-reveal {
//   padding: 24px;
//   position: absolute;
//   background-color: #fff;
//   width: 100%;
//   overflow-y: auto;
//   left: 0;
//   top: 100%;
//   height: 100%;
//   z-index: 3;
//   display: none;
// }
//
// .card .card-reveal .card-title {
//   cursor: pointer;
//   display: block;
// }
//
// #toast-container {
//   display: block;
//   position: fixed;
//   z-index: 10000;
// }
//
// @media only screen and (max-width: 600px) {
//   #toast-container {
//     min-width: 100%;
//     bottom: 0%;
//   }
// }
//
// @media only screen and (min-width: 601px) and (max-width: 992px) {
//   #toast-container {
//     left: 5%;
//     bottom: 7%;
//     max-width: 90%;
//   }
// }
//
// @media only screen and (min-width: 993px) {
//   #toast-container {
//     top: 10%;
//     right: 7%;
//     max-width: 86%;
//   }
// }
//
// .toast {
//   border-radius: 2px;
//   top: 35px;
//   width: auto;
//   margin-top: 10px;
//   position: relative;
//   max-width: 100%;
//   height: auto;
//   min-height: 48px;
//   line-height: 1.5em;
//   background-color: #323232;
//   padding: 10px 25px;
//   font-size: 1.1rem;
//   font-weight: 300;
//   color: #fff;
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-align: center;
//   -webkit-align-items: center;
//       -ms-flex-align: center;
//           align-items: center;
//   -webkit-box-pack: justify;
//   -webkit-justify-content: space-between;
//       -ms-flex-pack: justify;
//           justify-content: space-between;
//   cursor: default;
// }
//
// .toast .toast-action {
//   color: #eeff41;
//   font-weight: 500;
//   margin-right: -25px;
//   margin-left: 3rem;
// }
//
// .toast.rounded {
//   border-radius: 24px;
// }
//
// @media only screen and (max-width: 600px) {
//   .toast {
//     width: 100%;
//     border-radius: 0;
//   }
// }
//
// .tabs {
//   position: relative;
//   overflow-x: auto;
//   overflow-y: hidden;
//   height: 48px;
//   width: 100%;
//   background-color: #fff;
//   margin: 0 auto;
//   white-space: nowrap;
// }
//
// .tabs.tabs-transparent {
//   background-color: transparent;
// }
//
// .tabs.tabs-transparent .tab a,
// .tabs.tabs-transparent .tab.disabled a,
// .tabs.tabs-transparent .tab.disabled a:hover {
//   color: rgba(255, 255, 255, 0.7);
// }
//
// .tabs.tabs-transparent .tab a:hover,
// .tabs.tabs-transparent .tab a.active {
//   color: #fff;
// }
//
// .tabs.tabs-transparent .indicator {
//   background-color: #fff;
// }
//
// .tabs.tabs-fixed-width {
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
// }
//
// .tabs.tabs-fixed-width .tab {
//   -webkit-box-flex: 1;
//   -webkit-flex-grow: 1;
//           flex-grow: 1;
// }
//
// .tabs .tab {
//   display: inline-block;
//   text-align: center;
//   line-height: 48px;
//   height: 48px;
//   padding: 0;
//   margin: 0;
//   text-transform: uppercase;
// }
//
// .tabs .tab a {
//   color: rgba(238, 110, 115, 0.7);
//   display: block;
//   width: 100%;
//   height: 100%;
//   padding: 0 24px;
//   font-size: 14px;
//   text-overflow: ellipsis;
//   overflow: hidden;
//   -webkit-transition: color .28s ease, background-color .28s ease;
//   transition: color .28s ease, background-color .28s ease;
// }
//
// .tabs .tab a:focus, .tabs .tab a:focus.active {
//   background-color: rgba(246, 178, 181, 0.2);
//   outline: none;
// }
//
// .tabs .tab a:hover, .tabs .tab a.active {
//   background-color: transparent;
//   color: #ee6e73;
// }
//
// .tabs .tab.disabled a,
// .tabs .tab.disabled a:hover {
//   color: rgba(238, 110, 115, 0.4);
//   cursor: default;
// }
//
// .tabs .indicator {
//   position: absolute;
//   bottom: 0;
//   height: 2px;
//   background-color: #f6b2b5;
//   will-change: left, right;
// }
//
// @media only screen and (max-width: 992px) {
//   .tabs {
//     display: -webkit-box;
//     display: -webkit-flex;
//     display: -ms-flexbox;
//     display: flex;
//   }
//   .tabs .tab {
//     -webkit-box-flex: 1;
//     -webkit-flex-grow: 1;
//             flex-grow: 1;
//   }
//   .tabs .tab a {
//     padding: 0 12px;
//   }
// }
//
// .material-tooltip {
//   padding: 10px 8px;
//   font-size: 1rem;
//   z-index: 2000;
//   border-radius: 2px;
//   color: #fff;
//   min-height: 36px;
//   line-height: 120%;
//   opacity: 0;
//   position: absolute;
//   text-align: center;
//   max-width: calc(100% - 4px);
//   overflow: hidden;
//   left: 0;
//   top: 0;
//   pointer-events: none;
//   visibility: hidden;
//   background-color: #323232;
// }
//
// .backdrop {
//   position: absolute;
//   opacity: 0;
//   height: 7px;
//   width: 14px;
//   border-radius: 0 0 50% 50%;
//   background-color: #323232;
//   z-index: -1;
//   -webkit-transform-origin: 50% 0;
//           transform-origin: 50% 0;
//   visibility: hidden;
// }
//
// .btn, .btn-large, .btn-small,
// .btn-flat {
//   border: none;
//   border-radius: 2px;
//   display: inline-block;
//   height: 36px;
//   line-height: 36px;
//   padding: 0 16px;
//   text-transform: uppercase;
//   vertical-align: middle;
//   -webkit-tap-highlight-color: transparent;
// }
//
// .btn.disabled, .disabled.btn-large, .disabled.btn-small,
// .btn-floating.disabled,
// .btn-large.disabled,
// .btn-small.disabled,
// .btn-flat.disabled,
// .btn:disabled,
// .btn-large:disabled,
// .btn-small:disabled,
// .btn-floating:disabled,
// .btn-large:disabled,
// .btn-small:disabled,
// .btn-flat:disabled,
// .btn[disabled],
// .btn-large[disabled],
// .btn-small[disabled],
// .btn-floating[disabled],
// .btn-large[disabled],
// .btn-small[disabled],
// .btn-flat[disabled] {
//   pointer-events: none;
//   background-color: #DFDFDF !important;
//   -webkit-box-shadow: none;
//           box-shadow: none;
//   color: #9F9F9F !important;
//   cursor: default;
// }
//
// .btn.disabled:hover, .disabled.btn-large:hover, .disabled.btn-small:hover,
// .btn-floating.disabled:hover,
// .btn-large.disabled:hover,
// .btn-small.disabled:hover,
// .btn-flat.disabled:hover,
// .btn:disabled:hover,
// .btn-large:disabled:hover,
// .btn-small:disabled:hover,
// .btn-floating:disabled:hover,
// .btn-large:disabled:hover,
// .btn-small:disabled:hover,
// .btn-flat:disabled:hover,
// .btn[disabled]:hover,
// .btn-large[disabled]:hover,
// .btn-small[disabled]:hover,
// .btn-floating[disabled]:hover,
// .btn-large[disabled]:hover,
// .btn-small[disabled]:hover,
// .btn-flat[disabled]:hover {
//   background-color: #DFDFDF !important;
//   color: #9F9F9F !important;
// }
//
// .btn, .btn-large, .btn-small,
// .btn-floating,
// .btn-large,
// .btn-small,
// .btn-flat {
//   font-size: 14px;
//   outline: 0;
// }
//
// .btn i, .btn-large i, .btn-small i,
// .btn-floating i,
// .btn-large i,
// .btn-small i,
// .btn-flat i {
//   font-size: 1.3rem;
//   line-height: inherit;
// }
//
// .btn:focus, .btn-large:focus, .btn-small:focus,
// .btn-floating:focus {
//   background-color: #E64A19;
// }
//
// .btn, .btn-large, .btn-small {
//   text-decoration: none;
//   color: #fff;
//   background-color: #ff411d;
//   text-align: center;
//   -webkit-transition: background-color .2s ease-out;
//   transition: background-color .2s ease-out;
//   cursor: pointer;
// }
//
// .btn:hover, .btn-large:hover, .btn-small:hover {
//   background-color: #E64A19;
// }
//
// .btn-floating {
//   display: inline-block;
//   color: #fff;
//   position: relative;
//   overflow: hidden;
//   z-index: 1;
//   width: 40px;
//   height: 40px;
//   line-height: 40px;
//   padding: 0;
//   background-color: #ff411d;
//   border-radius: 50%;
//   -webkit-transition: background-color .3s;
//   transition: background-color .3s;
//   cursor: pointer;
//   vertical-align: middle;
// }
//
// .btn-floating:hover {
//   background-color: #ff411d;
// }
//
// .btn-floating:before {
//   border-radius: 0;
// }
//
// .btn-floating.btn-large {
//   width: 56px;
//   height: 56px;
//   padding: 0;
// }
//
// .btn-floating.btn-large.halfway-fab {
//   bottom: -28px;
// }
//
// .btn-floating.btn-large i {
//   line-height: 56px;
// }
//
// .btn-floating.btn-small {
//   width: 32.4px;
//   height: 32.4px;
// }
//
// .btn-floating.btn-small.halfway-fab {
//   bottom: -16.2px;
// }
//
// .btn-floating.btn-small i {
//   line-height: 32.4px;
// }
//
// .btn-floating.halfway-fab {
//   position: absolute;
//   right: 24px;
//   bottom: -20px;
// }
//
// .btn-floating.halfway-fab.left {
//   right: auto;
//   left: 24px;
// }
//
// .btn-floating i {
//   width: inherit;
//   display: inline-block;
//   text-align: center;
//   color: #fff;
//   font-size: 1.6rem;
//   line-height: 40px;
// }
//
// button.btn-floating {
//   border: none;
// }
//
// .fixed-action-btn {
//   position: fixed;
//   right: 23px;
//   bottom: 23px;
//   padding-top: 15px;
//   margin-bottom: 0;
//   z-index: 997;
// }
//
// .fixed-action-btn.active ul {
//   visibility: visible;
// }
//
// .fixed-action-btn.direction-left, .fixed-action-btn.direction-right {
//   padding: 0 0 0 15px;
// }
//
// .fixed-action-btn.direction-left ul, .fixed-action-btn.direction-right ul {
//   text-align: right;
//   right: 64px;
//   top: 50%;
//   -webkit-transform: translateY(-50%);
//           transform: translateY(-50%);
//   height: 100%;
//   left: auto;
//   /*width 100% only goes to width of button container */
//   width: 500px;
// }
//
// .fixed-action-btn.direction-left ul li, .fixed-action-btn.direction-right ul li {
//   display: inline-block;
//   margin: 7.5px 15px 0 0;
// }
//
// .fixed-action-btn.direction-right {
//   padding: 0 15px 0 0;
// }
//
// .fixed-action-btn.direction-right ul {
//   text-align: left;
//   direction: rtl;
//   left: 64px;
//   right: auto;
// }
//
// .fixed-action-btn.direction-right ul li {
//   margin: 7.5px 0 0 15px;
// }
//
// .fixed-action-btn.direction-bottom {
//   padding: 0 0 15px 0;
// }
//
// .fixed-action-btn.direction-bottom ul {
//   top: 64px;
//   bottom: auto;
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-orient: vertical;
//   -webkit-box-direction: reverse;
//   -webkit-flex-direction: column-reverse;
//       -ms-flex-direction: column-reverse;
//           flex-direction: column-reverse;
// }
//
// .fixed-action-btn.direction-bottom ul li {
//   margin: 15px 0 0 0;
// }
//
// .fixed-action-btn.toolbar {
//   padding: 0;
//   height: 56px;
// }
//
// .fixed-action-btn.toolbar.active > a i {
//   opacity: 0;
// }
//
// .fixed-action-btn.toolbar ul {
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   top: 0;
//   bottom: 0;
//   z-index: 1;
// }
//
// .fixed-action-btn.toolbar ul li {
//   -webkit-box-flex: 1;
//   -webkit-flex: 1;
//       -ms-flex: 1;
//           flex: 1;
//   display: inline-block;
//   margin: 0;
//   height: 100%;
//   -webkit-transition: none;
//   transition: none;
// }
//
// .fixed-action-btn.toolbar ul li a {
//   display: block;
//   overflow: hidden;
//   position: relative;
//   width: 100%;
//   height: 100%;
//   background-color: transparent;
//   -webkit-box-shadow: none;
//           box-shadow: none;
//   color: #fff;
//   line-height: 56px;
//   z-index: 1;
// }
//
// .fixed-action-btn.toolbar ul li a i {
//   line-height: inherit;
// }
//
// .fixed-action-btn ul {
//   left: 0;
//   right: 0;
//   text-align: center;
//   position: absolute;
//   bottom: 64px;
//   margin: 0;
//   visibility: hidden;
// }
//
// .fixed-action-btn ul li {
//   margin-bottom: 15px;
// }
//
// .fixed-action-btn ul a.btn-floating {
//   opacity: 0;
// }
//
// .fixed-action-btn .fab-backdrop {
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: -1;
//   width: 40px;
//   height: 40px;
//   background-color: #ff411d;
//   border-radius: 50%;
//   -webkit-transform: scale(0);
//           transform: scale(0);
// }
//
// .btn-flat {
//   -webkit-box-shadow: none;
//           box-shadow: none;
//   background-color: transparent;
//   color: #343434;
//   cursor: pointer;
//   -webkit-transition: background-color .2s;
//   transition: background-color .2s;
// }
//
// .btn-flat:focus, .btn-flat:hover {
//   -webkit-box-shadow: none;
//           box-shadow: none;
// }
//
// .btn-flat:focus {
//   background-color: rgba(0, 0, 0, 0.1);
// }
//
// .btn-flat.disabled, .btn-flat.btn-flat[disabled] {
//   background-color: transparent !important;
//   color: #b3b2b2 !important;
//   cursor: default;
// }
//
// .btn-large {
//   height: 50px;
//   line-height: 50px;
//   font-size: 15px;
//   padding: 0 28px;
// }
//
// .btn-large i {
//   font-size: 1.6rem;
// }
//
// .btn-small {
//   height: 32px;
//   line-height: 32px;
//   font-size: 13px;
// }
//
// .btn-small i {
//   font-size: 1.2rem;
// }
//
// .btn-block {
//   display: block;
// }
//
// .dropdown-content {
//   background-color: #fff;
//   margin: 0;
//   display: none;
//   min-width: 100px;
//   overflow-y: auto;
//   opacity: 0;
//   position: absolute;
//   left: 0;
//   top: 0;
//   z-index: 9999;
//   -webkit-transform-origin: 0 0;
//           transform-origin: 0 0;
// }
//
// .dropdown-content:focus {
//   outline: 0;
// }
//
// .dropdown-content li {
//   clear: both;
//   color: rgba(0, 0, 0, 0.87);
//   cursor: pointer;
//   min-height: 50px;
//   line-height: 1.5rem;
//   width: 100%;
//   text-align: left;
// }
//
// .dropdown-content li:hover, .dropdown-content li.active {
//   background-color: #eee;
// }
//
// .dropdown-content li:focus {
//   outline: none;
// }
//
// .dropdown-content li.divider {
//   min-height: 0;
//   height: 1px;
// }
//
// .dropdown-content li > a, .dropdown-content li > span {
//   font-size: 16px;
//   color: #ff411d;
//   display: block;
//   line-height: 22px;
//   padding: 14px 16px;
// }
//
// .dropdown-content li > span > label {
//   top: 1px;
//   left: 0;
//   height: 18px;
// }
//
// .dropdown-content li > a > i {
//   height: inherit;
//   line-height: inherit;
//   float: left;
//   margin: 0 24px 0 0;
//   width: 24px;
// }
//
// body.keyboard-focused .dropdown-content li:focus {
//   background-color: #dadada;
// }
//
// .input-field.col .dropdown-content [type="checkbox"] + label {
//   top: 1px;
//   left: 0;
//   height: 18px;
//   -webkit-transform: none;
//           transform: none;
// }
//
// .dropdown-trigger {
//   cursor: pointer;
// }
//
// /*!
//  * Waves v0.6.0
//  * http://fian.my.id/Waves
//  *
//  * Copyright 2014 Alfiana E. Sibuea and other contributors
//  * Released under the MIT license
//  * https://github.com/fians/Waves/blob/master/LICENSE
//  */
// .waves-effect {
//   position: relative;
//   cursor: pointer;
//   display: inline-block;
//   overflow: hidden;
//   -webkit-user-select: none;
//      -moz-user-select: none;
//       -ms-user-select: none;
//           user-select: none;
//   -webkit-tap-highlight-color: transparent;
//   vertical-align: middle;
//   z-index: 1;
//   -webkit-transition: .3s ease-out;
//   transition: .3s ease-out;
// }
//
// .waves-effect .waves-ripple {
//   position: absolute;
//   border-radius: 50%;
//   width: 20px;
//   height: 20px;
//   margin-top: -10px;
//   margin-left: -10px;
//   opacity: 0;
//   background: rgba(0, 0, 0, 0.2);
//   -webkit-transition: all 0.7s ease-out;
//   transition: all 0.7s ease-out;
//   -webkit-transition-property: opacity, -webkit-transform;
//   transition-property: transform, opacity, -webkit-transform;
//   -webkit-transform: scale(0);
//           transform: scale(0);
//   pointer-events: none;
// }
//
// .waves-effect.waves-light .waves-ripple {
//   background-color: rgba(255, 255, 255, 0.45);
// }
//
// .waves-effect.waves-red .waves-ripple {
//   background-color: rgba(244, 67, 54, 0.7);
// }
//
// .waves-effect.waves-yellow .waves-ripple {
//   background-color: rgba(255, 235, 59, 0.7);
// }
//
// .waves-effect.waves-orange .waves-ripple {
//   background-color: rgba(255, 152, 0, 0.7);
// }
//
// .waves-effect.waves-purple .waves-ripple {
//   background-color: rgba(156, 39, 176, 0.7);
// }
//
// .waves-effect.waves-green .waves-ripple {
//   background-color: rgba(76, 175, 80, 0.7);
// }
//
// .waves-effect.waves-teal .waves-ripple {
//   background-color: rgba(0, 150, 136, 0.7);
// }
//
// .waves-effect input[type="button"], .waves-effect input[type="reset"], .waves-effect input[type="submit"] {
//   border: 0;
//   font-style: normal;
//   font-size: inherit;
//   text-transform: inherit;
//   background: none;
// }
//
// .waves-effect img {
//   position: relative;
//   z-index: -1;
// }
//
// .waves-notransition {
//   -webkit-transition: none !important;
//   transition: none !important;
// }
//
// .waves-circle {
//   -webkit-transform: translateZ(0);
//           transform: translateZ(0);
// }
//
// .waves-input-wrapper {
//   border-radius: 0.2em;
//   vertical-align: bottom;
// }
//
// .waves-input-wrapper .waves-button-input {
//   position: relative;
//   top: 0;
//   left: 0;
//   z-index: 1;
// }
//
// .waves-circle {
//   text-align: center;
//   width: 2.5em;
//   height: 2.5em;
//   line-height: 2.5em;
//   border-radius: 50%;
//   -webkit-mask-image: none;
// }
//
// .waves-block {
//   display: block;
// }
//
// /* Firefox Bug: link not triggered */
// .waves-effect .waves-ripple {
//   z-index: -1;
// }
//
// .modal {
//   display: none;
//   position: fixed;
//   left: 0;
//   right: 0;
//   background-color: #fafafa;
//   padding: 0;
//   max-height: 70%;
//   width: 55%;
//   margin: auto;
//   overflow-y: auto;
//   border-radius: 2px;
//   will-change: top, opacity;
// }
//
// .modal:focus {
//   outline: none;
// }
//
// @media only screen and (max-width: 992px) {
//   .modal {
//     width: 80%;
//   }
// }
//
// .modal h1, .modal h2, .modal h3, .modal h4 {
//   margin-top: 0;
// }
//
// .modal .modal-content {
//   padding: 24px;
// }
//
// .modal .modal-close {
//   cursor: pointer;
// }
//
// .modal .modal-footer {
//   border-radius: 0 0 2px 2px;
//   background-color: #fafafa;
//   padding: 4px 6px;
//   height: 56px;
//   width: 100%;
//   text-align: right;
// }
//
// .modal .modal-footer .btn, .modal .modal-footer .btn-large, .modal .modal-footer .btn-small, .modal .modal-footer .btn-flat {
//   margin: 6px 0;
// }
//
// .modal-overlay {
//   position: fixed;
//   z-index: 999;
//   top: -25%;
//   left: 0;
//   bottom: 0;
//   right: 0;
//   height: 125%;
//   width: 100%;
//   background: #000;
//   display: none;
//   will-change: opacity;
// }
//
// .modal.modal-fixed-footer {
//   padding: 0;
//   height: 70%;
// }
//
// .modal.modal-fixed-footer .modal-content {
//   position: absolute;
//   height: calc(100% - 56px);
//   max-height: 100%;
//   width: 100%;
//   overflow-y: auto;
// }
//
// .modal.modal-fixed-footer .modal-footer {
//   border-top: 1px solid rgba(0, 0, 0, 0.1);
//   position: absolute;
//   bottom: 0;
// }
//
// .modal.bottom-sheet {
//   top: auto;
//   bottom: -100%;
//   margin: 0;
//   width: 100%;
//   max-height: 45%;
//   border-radius: 0;
//   will-change: bottom, opacity;
// }
//
// .collapsible {
//   border-top: 1px solid #ddd;
//   border-right: 1px solid #ddd;
//   border-left: 1px solid #ddd;
//   margin: 0.5rem 0 1rem 0;
// }
//
// .collapsible-header {
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   cursor: pointer;
//   -webkit-tap-highlight-color: transparent;
//   line-height: 1.5;
//   padding: 1rem;
//   background-color: #fff;
//   border-bottom: 1px solid #ddd;
// }
//
// .collapsible-header:focus {
//   outline: 0;
// }
//
// .collapsible-header i {
//   width: 2rem;
//   font-size: 1.6rem;
//   display: inline-block;
//   text-align: center;
//   margin-right: 1rem;
// }
//
// .keyboard-focused .collapsible-header:focus {
//   background-color: #eee;
// }
//
// .collapsible-body {
//   display: none;
//   border-bottom: 1px solid #ddd;
//   -webkit-box-sizing: border-box;
//           box-sizing: border-box;
//   padding: 2rem;
// }
//
// .sidenav .collapsible,
// .sidenav.fixed .collapsible {
//   border: none;
//   -webkit-box-shadow: none;
//           box-shadow: none;
// }
//
// .sidenav .collapsible li,
// .sidenav.fixed .collapsible li {
//   padding: 0;
// }
//
// .sidenav .collapsible-header,
// .sidenav.fixed .collapsible-header {
//   background-color: transparent;
//   border: none;
//   line-height: inherit;
//   height: inherit;
//   padding: 0 16px;
// }
//
// .sidenav .collapsible-header:hover,
// .sidenav.fixed .collapsible-header:hover {
//   background-color: rgba(0, 0, 0, 0.05);
// }
//
// .sidenav .collapsible-header i,
// .sidenav.fixed .collapsible-header i {
//   line-height: inherit;
// }
//
// .sidenav .collapsible-body,
// .sidenav.fixed .collapsible-body {
//   border: 0;
//   background-color: #fff;
// }
//
// .sidenav .collapsible-body li a,
// .sidenav.fixed .collapsible-body li a {
//   padding: 0 23.5px 0 31px;
// }
//
// .collapsible.popout {
//   border: none;
//   -webkit-box-shadow: none;
//           box-shadow: none;
// }
//
// .collapsible.popout > li {
//   -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
//           box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
//   margin: 0 24px;
//   -webkit-transition: margin 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//   transition: margin 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// }
//
// .collapsible.popout > li.active {
//   -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
//           box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
//   margin: 16px 0;
// }
//
// .chip {
//   display: inline-block;
//   height: 32px;
//   font-size: 13px;
//   font-weight: 500;
//   color: rgba(0, 0, 0, 0.6);
//   line-height: 32px;
//   padding: 0 12px;
//   border-radius: 16px;
//   background-color: #e4e4e4;
//   margin-bottom: 5px;
//   margin-right: 5px;
// }
//
// .chip:focus {
//   outline: none;
//   background-color: #ff411d;
//   color: #fff;
// }
//
// .chip > img {
//   float: left;
//   margin: 0 8px 0 -12px;
//   height: 32px;
//   width: 32px;
//   border-radius: 50%;
// }
//
// .chip .close {
//   cursor: pointer;
//   float: right;
//   font-size: 16px;
//   line-height: 32px;
//   padding-left: 8px;
// }
//
// .chips {
//   border: none;
//   border-bottom: 1px solid #9e9e9e;
//   -webkit-box-shadow: none;
//           box-shadow: none;
//   margin: 0 0 8px 0;
//   min-height: 45px;
//   outline: none;
//   -webkit-transition: all .3s;
//   transition: all .3s;
// }
//
// .chips.focus {
//   border-bottom: 1px solid #ff411d;
//   -webkit-box-shadow: 0 1px 0 0 #ff411d;
//           box-shadow: 0 1px 0 0 #ff411d;
// }
//
// .chips:hover {
//   cursor: text;
// }
//
// .chips .input {
//   background: none;
//   border: 0;
//   color: rgba(0, 0, 0, 0.6);
//   display: inline-block;
//   font-size: 16px;
//   height: 3rem;
//   line-height: 32px;
//   outline: 0;
//   margin: 0;
//   padding: 0 !important;
//   width: 120px !important;
// }
//
// .chips .input:focus {
//   border: 0 !important;
//   -webkit-box-shadow: none !important;
//           box-shadow: none !important;
// }
//
// .chips .autocomplete-content {
//   margin-top: 0;
//   margin-bottom: 0;
// }
//
// .prefix ~ .chips {
//   margin-left: 3rem;
//   width: calc(100% - 3rem);
// }
//
// .chips:empty ~ label {
//   font-size: 0.8rem;
//   -webkit-transform: translateY(-140%);
//           transform: translateY(-140%);
// }
//
// .materialboxed {
//   display: block;
//   cursor: zoom-in;
//   position: relative;
//   -webkit-transition: opacity .4s;
//   transition: opacity .4s;
//   -webkit-backface-visibility: hidden;
// }
//
// .materialboxed:hover:not(.active) {
//   opacity: .8;
// }
//
// .materialboxed.active {
//   cursor: zoom-out;
// }
//
// #materialbox-overlay {
//   position: fixed;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   background-color: #292929;
//   z-index: 1000;
//   will-change: opacity;
// }
//
// .materialbox-caption {
//   position: fixed;
//   display: none;
//   color: #fff;
//   line-height: 50px;
//   bottom: 0;
//   left: 0;
//   width: 100%;
//   text-align: center;
//   padding: 0 15%;
//   height: 50px;
//   z-index: 1000;
//   -webkit-font-smoothing: antialiased;
// }
//
// select:focus {
//   outline: 1px solid #c9f3ef;
// }
//
// button:focus {
//   outline: none;
//   background-color: #2ab7a9;
// }
//
// label {
//   font-size: 0.8rem;
//   color: #9e9e9e;
// }
//
// /* Text Inputs + Textarea
//    ========================================================================== */
// /* Style Placeholders */
// ::-webkit-input-placeholder {
//   color: #d1d1d1;
// }
// ::-moz-placeholder {
//   color: #d1d1d1;
// }
// :-ms-input-placeholder {
//   color: #d1d1d1;
// }
// ::-ms-input-placeholder {
//   color: #d1d1d1;
// }
// ::placeholder {
//   color: #d1d1d1;
// }
//
// /* Validation Sass Placeholders */
// input.valid:not([type]), input.valid:not([type]):focus,
// input.valid[type=text]:not(.browser-default),
// input.valid[type=text]:not(.browser-default):focus,
// input.valid[type=password]:not(.browser-default),
// input.valid[type=password]:not(.browser-default):focus,
// input.valid[type=email]:not(.browser-default),
// input.valid[type=email]:not(.browser-default):focus,
// input.valid[type=url]:not(.browser-default),
// input.valid[type=url]:not(.browser-default):focus,
// input.valid[type=time]:not(.browser-default),
// input.valid[type=time]:not(.browser-default):focus,
// input.valid[type=date]:not(.browser-default),
// input.valid[type=date]:not(.browser-default):focus,
// input.valid[type=datetime]:not(.browser-default),
// input.valid[type=datetime]:not(.browser-default):focus,
// input.valid[type=datetime-local]:not(.browser-default),
// input.valid[type=datetime-local]:not(.browser-default):focus,
// input.valid[type=tel]:not(.browser-default),
// input.valid[type=tel]:not(.browser-default):focus,
// input.valid[type=number]:not(.browser-default),
// input.valid[type=number]:not(.browser-default):focus,
// input.valid[type=search]:not(.browser-default),
// input.valid[type=search]:not(.browser-default):focus,
// textarea.materialize-textarea.valid,
// textarea.materialize-textarea.valid:focus, .select-wrapper.valid > input.select-dropdown {
//   border-bottom: 1px solid #4CAF50;
//   -webkit-box-shadow: 0 1px 0 0 #4CAF50;
//           box-shadow: 0 1px 0 0 #4CAF50;
// }
//
// input.invalid:not([type]), input.invalid:not([type]):focus,
// input.invalid[type=text]:not(.browser-default),
// input.invalid[type=text]:not(.browser-default):focus,
// input.invalid[type=password]:not(.browser-default),
// input.invalid[type=password]:not(.browser-default):focus,
// input.invalid[type=email]:not(.browser-default),
// input.invalid[type=email]:not(.browser-default):focus,
// input.invalid[type=url]:not(.browser-default),
// input.invalid[type=url]:not(.browser-default):focus,
// input.invalid[type=time]:not(.browser-default),
// input.invalid[type=time]:not(.browser-default):focus,
// input.invalid[type=date]:not(.browser-default),
// input.invalid[type=date]:not(.browser-default):focus,
// input.invalid[type=datetime]:not(.browser-default),
// input.invalid[type=datetime]:not(.browser-default):focus,
// input.invalid[type=datetime-local]:not(.browser-default),
// input.invalid[type=datetime-local]:not(.browser-default):focus,
// input.invalid[type=tel]:not(.browser-default),
// input.invalid[type=tel]:not(.browser-default):focus,
// input.invalid[type=number]:not(.browser-default),
// input.invalid[type=number]:not(.browser-default):focus,
// input.invalid[type=search]:not(.browser-default),
// input.invalid[type=search]:not(.browser-default):focus,
// textarea.materialize-textarea.invalid,
// textarea.materialize-textarea.invalid:focus, .select-wrapper.invalid > input.select-dropdown,
// .select-wrapper.invalid > input.select-dropdown:focus {
//   border-bottom: 1px solid #F44336;
//   -webkit-box-shadow: 0 1px 0 0 #F44336;
//           box-shadow: 0 1px 0 0 #F44336;
// }
//
// input:not([type]).valid ~ .helper-text[data-success],
// input:not([type]):focus.valid ~ .helper-text[data-success],
// input:not([type]).invalid ~ .helper-text[data-error],
// input:not([type]):focus.invalid ~ .helper-text[data-error],
// input[type=text]:not(.browser-default).valid ~ .helper-text[data-success],
// input[type=text]:not(.browser-default):focus.valid ~ .helper-text[data-success],
// input[type=text]:not(.browser-default).invalid ~ .helper-text[data-error],
// input[type=text]:not(.browser-default):focus.invalid ~ .helper-text[data-error],
// input[type=password]:not(.browser-default).valid ~ .helper-text[data-success],
// input[type=password]:not(.browser-default):focus.valid ~ .helper-text[data-success],
// input[type=password]:not(.browser-default).invalid ~ .helper-text[data-error],
// input[type=password]:not(.browser-default):focus.invalid ~ .helper-text[data-error],
// input[type=email]:not(.browser-default).valid ~ .helper-text[data-success],
// input[type=email]:not(.browser-default):focus.valid ~ .helper-text[data-success],
// input[type=email]:not(.browser-default).invalid ~ .helper-text[data-error],
// input[type=email]:not(.browser-default):focus.invalid ~ .helper-text[data-error],
// input[type=url]:not(.browser-default).valid ~ .helper-text[data-success],
// input[type=url]:not(.browser-default):focus.valid ~ .helper-text[data-success],
// input[type=url]:not(.browser-default).invalid ~ .helper-text[data-error],
// input[type=url]:not(.browser-default):focus.invalid ~ .helper-text[data-error],
// input[type=time]:not(.browser-default).valid ~ .helper-text[data-success],
// input[type=time]:not(.browser-default):focus.valid ~ .helper-text[data-success],
// input[type=time]:not(.browser-default).invalid ~ .helper-text[data-error],
// input[type=time]:not(.browser-default):focus.invalid ~ .helper-text[data-error],
// input[type=date]:not(.browser-default).valid ~ .helper-text[data-success],
// input[type=date]:not(.browser-default):focus.valid ~ .helper-text[data-success],
// input[type=date]:not(.browser-default).invalid ~ .helper-text[data-error],
// input[type=date]:not(.browser-default):focus.invalid ~ .helper-text[data-error],
// input[type=datetime]:not(.browser-default).valid ~ .helper-text[data-success],
// input[type=datetime]:not(.browser-default):focus.valid ~ .helper-text[data-success],
// input[type=datetime]:not(.browser-default).invalid ~ .helper-text[data-error],
// input[type=datetime]:not(.browser-default):focus.invalid ~ .helper-text[data-error],
// input[type=datetime-local]:not(.browser-default).valid ~ .helper-text[data-success],
// input[type=datetime-local]:not(.browser-default):focus.valid ~ .helper-text[data-success],
// input[type=datetime-local]:not(.browser-default).invalid ~ .helper-text[data-error],
// input[type=datetime-local]:not(.browser-default):focus.invalid ~ .helper-text[data-error],
// input[type=tel]:not(.browser-default).valid ~ .helper-text[data-success],
// input[type=tel]:not(.browser-default):focus.valid ~ .helper-text[data-success],
// input[type=tel]:not(.browser-default).invalid ~ .helper-text[data-error],
// input[type=tel]:not(.browser-default):focus.invalid ~ .helper-text[data-error],
// input[type=number]:not(.browser-default).valid ~ .helper-text[data-success],
// input[type=number]:not(.browser-default):focus.valid ~ .helper-text[data-success],
// input[type=number]:not(.browser-default).invalid ~ .helper-text[data-error],
// input[type=number]:not(.browser-default):focus.invalid ~ .helper-text[data-error],
// input[type=search]:not(.browser-default).valid ~ .helper-text[data-success],
// input[type=search]:not(.browser-default):focus.valid ~ .helper-text[data-success],
// input[type=search]:not(.browser-default).invalid ~ .helper-text[data-error],
// input[type=search]:not(.browser-default):focus.invalid ~ .helper-text[data-error],
// textarea.materialize-textarea.valid ~ .helper-text[data-success],
// textarea.materialize-textarea:focus.valid ~ .helper-text[data-success],
// textarea.materialize-textarea.invalid ~ .helper-text[data-error],
// textarea.materialize-textarea:focus.invalid ~ .helper-text[data-error], .select-wrapper.valid .helper-text[data-success],
// .select-wrapper.invalid ~ .helper-text[data-error] {
//   color: transparent;
//   -webkit-user-select: none;
//      -moz-user-select: none;
//       -ms-user-select: none;
//           user-select: none;
//   pointer-events: none;
// }
//
// input:not([type]).valid ~ .helper-text:after,
// input:not([type]):focus.valid ~ .helper-text:after,
// input[type=text]:not(.browser-default).valid ~ .helper-text:after,
// input[type=text]:not(.browser-default):focus.valid ~ .helper-text:after,
// input[type=password]:not(.browser-default).valid ~ .helper-text:after,
// input[type=password]:not(.browser-default):focus.valid ~ .helper-text:after,
// input[type=email]:not(.browser-default).valid ~ .helper-text:after,
// input[type=email]:not(.browser-default):focus.valid ~ .helper-text:after,
// input[type=url]:not(.browser-default).valid ~ .helper-text:after,
// input[type=url]:not(.browser-default):focus.valid ~ .helper-text:after,
// input[type=time]:not(.browser-default).valid ~ .helper-text:after,
// input[type=time]:not(.browser-default):focus.valid ~ .helper-text:after,
// input[type=date]:not(.browser-default).valid ~ .helper-text:after,
// input[type=date]:not(.browser-default):focus.valid ~ .helper-text:after,
// input[type=datetime]:not(.browser-default).valid ~ .helper-text:after,
// input[type=datetime]:not(.browser-default):focus.valid ~ .helper-text:after,
// input[type=datetime-local]:not(.browser-default).valid ~ .helper-text:after,
// input[type=datetime-local]:not(.browser-default):focus.valid ~ .helper-text:after,
// input[type=tel]:not(.browser-default).valid ~ .helper-text:after,
// input[type=tel]:not(.browser-default):focus.valid ~ .helper-text:after,
// input[type=number]:not(.browser-default).valid ~ .helper-text:after,
// input[type=number]:not(.browser-default):focus.valid ~ .helper-text:after,
// input[type=search]:not(.browser-default).valid ~ .helper-text:after,
// input[type=search]:not(.browser-default):focus.valid ~ .helper-text:after,
// textarea.materialize-textarea.valid ~ .helper-text:after,
// textarea.materialize-textarea:focus.valid ~ .helper-text:after, .select-wrapper.valid ~ .helper-text:after {
//   content: attr(data-success);
//   color: #4CAF50;
// }
//
// input:not([type]).invalid ~ .helper-text:after,
// input:not([type]):focus.invalid ~ .helper-text:after,
// input[type=text]:not(.browser-default).invalid ~ .helper-text:after,
// input[type=text]:not(.browser-default):focus.invalid ~ .helper-text:after,
// input[type=password]:not(.browser-default).invalid ~ .helper-text:after,
// input[type=password]:not(.browser-default):focus.invalid ~ .helper-text:after,
// input[type=email]:not(.browser-default).invalid ~ .helper-text:after,
// input[type=email]:not(.browser-default):focus.invalid ~ .helper-text:after,
// input[type=url]:not(.browser-default).invalid ~ .helper-text:after,
// input[type=url]:not(.browser-default):focus.invalid ~ .helper-text:after,
// input[type=time]:not(.browser-default).invalid ~ .helper-text:after,
// input[type=time]:not(.browser-default):focus.invalid ~ .helper-text:after,
// input[type=date]:not(.browser-default).invalid ~ .helper-text:after,
// input[type=date]:not(.browser-default):focus.invalid ~ .helper-text:after,
// input[type=datetime]:not(.browser-default).invalid ~ .helper-text:after,
// input[type=datetime]:not(.browser-default):focus.invalid ~ .helper-text:after,
// input[type=datetime-local]:not(.browser-default).invalid ~ .helper-text:after,
// input[type=datetime-local]:not(.browser-default):focus.invalid ~ .helper-text:after,
// input[type=tel]:not(.browser-default).invalid ~ .helper-text:after,
// input[type=tel]:not(.browser-default):focus.invalid ~ .helper-text:after,
// input[type=number]:not(.browser-default).invalid ~ .helper-text:after,
// input[type=number]:not(.browser-default):focus.invalid ~ .helper-text:after,
// input[type=search]:not(.browser-default).invalid ~ .helper-text:after,
// input[type=search]:not(.browser-default):focus.invalid ~ .helper-text:after,
// textarea.materialize-textarea.invalid ~ .helper-text:after,
// textarea.materialize-textarea:focus.invalid ~ .helper-text:after, .select-wrapper.invalid ~ .helper-text:after {
//   content: attr(data-error);
//   color: #F44336;
// }
//
// input:not([type]) + label:after,
// input[type=text]:not(.browser-default) + label:after,
// input[type=password]:not(.browser-default) + label:after,
// input[type=email]:not(.browser-default) + label:after,
// input[type=url]:not(.browser-default) + label:after,
// input[type=time]:not(.browser-default) + label:after,
// input[type=date]:not(.browser-default) + label:after,
// input[type=datetime]:not(.browser-default) + label:after,
// input[type=datetime-local]:not(.browser-default) + label:after,
// input[type=tel]:not(.browser-default) + label:after,
// input[type=number]:not(.browser-default) + label:after,
// input[type=search]:not(.browser-default) + label:after,
// textarea.materialize-textarea + label:after, .select-wrapper + label:after {
//   display: block;
//   content: "";
//   position: absolute;
//   top: 100%;
//   left: 0;
//   opacity: 0;
//   -webkit-transition: .2s opacity ease-out, .2s color ease-out;
//   transition: .2s opacity ease-out, .2s color ease-out;
// }
//
// .input-field.inline {
//   display: inline-block;
//   vertical-align: middle;
//   margin-left: 5px;
// }
//
// .input-field.inline input,
// .input-field.inline .select-dropdown {
//   margin-bottom: 1rem;
// }
//
//
// //
// // .input-field > label:not(.label-icon).active {
// //   -webkit-transform: translateY(-14px) scale(0.8);
// //           transform: translateY(-14px) scale(0.8);
// //   -webkit-transform-origin: 0 0;
// //           transform-origin: 0 0;
// // }
//
// .input-field > input[type]:-webkit-autofill:not(.browser-default):not([type="search"]) + label,
// .input-field > input[type=date]:not(.browser-default) + label,
// .input-field > input[type=time]:not(.browser-default) + label {
//   -webkit-transform: translateY(-14px) scale(0.8);
//           transform: translateY(-14px) scale(0.8);
//   -webkit-transform-origin: 0 0;
//           transform-origin: 0 0;
// }
//
// .input-field .helper-text {
//   position: relative;
//   min-height: 18px;
//   display: block;
//   font-size: 12px;
//   color: rgba(0, 0, 0, 0.54);
// }
//
// .input-field .helper-text::after {
//   opacity: 1;
//   position: absolute;
//   top: 0;
//   left: 0;
// }
//
// .input-field .prefix {
//   position: absolute;
//   width: 3rem;
//   font-size: 2rem;
//   -webkit-transition: color .2s;
//   transition: color .2s;
//   top: 0.5rem;
// }
//
// .input-field .prefix.active {
//   color: #ff411d;
// }
//
// .input-field .prefix ~ input,
// .input-field .prefix ~ textarea,
// .input-field .prefix ~ label,
// .input-field .prefix ~ .validate ~ label,
// .input-field .prefix ~ .helper-text,
// .input-field .prefix ~ .autocomplete-content {
//   margin-left: 3rem;
//   width: calc(100% - 3rem);
// }
//
// .input-field .prefix ~ label {
//   margin-left: 3rem;
// }
//
// @media only screen and (max-width: 992px) {
//   .input-field .prefix ~ input {
//     width: calc(100% - 3rem);
//   }
// }
//
// @media only screen and (max-width: 600px) {
//   .input-field .prefix ~ input {
//     width: calc(100% - 3rem);
//   }
// }
//
// /* Search Field */
// .input-field input[type=search] {
//   display: block;
//   line-height: inherit;
//   -webkit-transition: .3s background-color;
//   transition: .3s background-color;
// }
//
// .nav-wrapper .input-field input[type=search] {
//   height: inherit;
//   padding-left: 4rem;
//   width: calc(100% - 4rem);
//   border: 0;
//   -webkit-box-shadow: none;
//           box-shadow: none;
// }
//
// .input-field input[type=search]:focus:not(.browser-default) {
//   background-color: #fff;
//   border: 0;
//   -webkit-box-shadow: none;
//           box-shadow: none;
//   color: #444;
// }
//
// .input-field input[type=search]:focus:not(.browser-default) + label i,
// .input-field input[type=search]:focus:not(.browser-default) ~ .mdi-navigation-close,
// .input-field input[type=search]:focus:not(.browser-default) ~ .material-icons {
//   color: #444;
// }
//
// .input-field input[type=search] + .label-icon {
//   -webkit-transform: none;
//           transform: none;
//   left: 1rem;
// }
//
// .input-field input[type=search] ~ .mdi-navigation-close,
// .input-field input[type=search] ~ .material-icons {
//   position: absolute;
//   top: 0;
//   right: 1rem;
//   color: transparent;
//   cursor: pointer;
//   font-size: 2rem;
//   -webkit-transition: .3s color;
//   transition: .3s color;
// }
//
// /* Textarea */
// textarea {
//   width: 100%;
//   height: 3rem;
//   background-color: transparent;
// }
//
// textarea.materialize-textarea {
//   line-height: normal;
//   overflow-y: hidden;
//   /* prevents scroll bar flash */
//   padding: .8rem 0 .8rem 0;
//   /* prevents text jump on Enter keypress */
//   resize: none;
//   min-height: 3rem;
//   -webkit-box-sizing: border-box;
//           box-sizing: border-box;
// }
//
// .hiddendiv {
//   visibility: hidden;
//   white-space: pre-wrap;
//   word-wrap: break-word;
//   overflow-wrap: break-word;
//   /* future version of deprecated 'word-wrap' */
//   padding-top: 1.2rem;
//   /* prevents text jump on Enter keypress */
//   position: absolute;
//   top: 0;
//   z-index: -1;
// }
//
// /* Autocomplete */
// .autocomplete-content li .highlight {
//   color: #444;
// }
//
// .autocomplete-content li img {
//   height: 40px;
//   width: 40px;
//   margin: 5px 15px;
// }
//
// /* Character Counter */
// .character-counter {
//   min-height: 18px;
// }
//
// /* Radio Buttons
//    ========================================================================== */
// [type="radio"]:not(:checked),
// [type="radio"]:checked {
//   position: absolute;
//   opacity: 0;
//   pointer-events: none;
// }
//
// [type="radio"]:not(:checked) + span,
// [type="radio"]:checked + span {
//   position: relative;
//   padding-left: 35px;
//   cursor: pointer;
//   display: inline-block;
//   height: 25px;
//   line-height: 25px;
//   font-size: 1rem;
//   -webkit-transition: .28s ease;
//   transition: .28s ease;
//   -webkit-user-select: none;
//      -moz-user-select: none;
//       -ms-user-select: none;
//           user-select: none;
// }
//
// [type="radio"] + span:before,
// [type="radio"] + span:after {
//   content: '';
//   position: absolute;
//   left: 0;
//   top: 0;
//   margin: 4px;
//   width: 16px;
//   height: 16px;
//   z-index: 0;
//   -webkit-transition: .28s ease;
//   transition: .28s ease;
// }
//
// /* Unchecked styles */
// [type="radio"]:not(:checked) + span:before,
// [type="radio"]:not(:checked) + span:after,
// [type="radio"]:checked + span:before,
// [type="radio"]:checked + span:after,
// [type="radio"].with-gap:checked + span:before,
// [type="radio"].with-gap:checked + span:after {
//   border-radius: 50%;
// }
//
// [type="radio"]:not(:checked) + span:before,
// [type="radio"]:not(:checked) + span:after {
//   border: 2px solid #5a5a5a;
// }
//
// [type="radio"]:not(:checked) + span:after {
//   -webkit-transform: scale(0);
//           transform: scale(0);
// }
//
// /* Checked styles */
// [type="radio"]:checked + span:before {
//   border: 2px solid transparent;
// }
//
// [type="radio"]:checked + span:after,
// [type="radio"].with-gap:checked + span:before,
// [type="radio"].with-gap:checked + span:after {
//   border: 2px solid #ff411d;
// }
//
// [type="radio"]:checked + span:after,
// [type="radio"].with-gap:checked + span:after {
//   background-color: #ff411d;
// }
//
// [type="radio"]:checked + span:after {
//   -webkit-transform: scale(1.02);
//           transform: scale(1.02);
// }
//
// /* Radio With gap */
// [type="radio"].with-gap:checked + span:after {
//   -webkit-transform: scale(0.5);
//           transform: scale(0.5);
// }
//
// /* Focused styles */
// [type="radio"].tabbed:focus + span:before {
//   -webkit-box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.1);
//           box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.1);
// }
//
// /* Disabled Radio With gap */
// [type="radio"].with-gap:disabled:checked + span:before {
//   border: 2px solid rgba(0, 0, 0, 0.42);
// }
//
// [type="radio"].with-gap:disabled:checked + span:after {
//   border: none;
//   background-color: rgba(0, 0, 0, 0.42);
// }
//
// /* Disabled style */
// [type="radio"]:disabled:not(:checked) + span:before,
// [type="radio"]:disabled:checked + span:before {
//   background-color: transparent;
//   border-color: rgba(0, 0, 0, 0.42);
// }
//
// [type="radio"]:disabled + span {
//   color: rgba(0, 0, 0, 0.42);
// }
//
// [type="radio"]:disabled:not(:checked) + span:before {
//   border-color: rgba(0, 0, 0, 0.42);
// }
//
// [type="radio"]:disabled:checked + span:after {
//   background-color: rgba(0, 0, 0, 0.42);
//   border-color: #949494;
// }
//
// /* Checkboxes
//    ========================================================================== */
// /* Remove default checkbox */
// [type="checkbox"]:not(:checked),
// [type="checkbox"]:checked {
//   position: absolute;
//   opacity: 0;
//   pointer-events: none;
// }
//
// [type="checkbox"] {
//   /* checkbox aspect */
// }
//
// [type="checkbox"] + span:not(.lever) {
//   position: relative;
//   padding-left: 35px;
//   cursor: pointer;
//   display: inline-block;
//   height: 25px;
//   line-height: 25px;
//   font-size: 1rem;
//   -webkit-user-select: none;
//      -moz-user-select: none;
//       -ms-user-select: none;
//           user-select: none;
// }
//
// [type="checkbox"] + span:not(.lever):before,
// [type="checkbox"]:not(.filled-in) + span:not(.lever):after {
//   content: '';
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 18px;
//   height: 18px;
//   z-index: 0;
//   border: 2px solid #5a5a5a;
//   border-radius: 1px;
//   margin-top: 3px;
//   -webkit-transition: .2s;
//   transition: .2s;
// }
//
// [type="checkbox"]:not(.filled-in) + span:not(.lever):after {
//   border: 0;
//   -webkit-transform: scale(0);
//           transform: scale(0);
// }
//
// [type="checkbox"]:not(:checked):disabled + span:not(.lever):before {
//   border: none;
//   background-color: rgba(0, 0, 0, 0.42);
// }
//
// [type="checkbox"].tabbed:focus + span:not(.lever):after {
//   -webkit-transform: scale(1);
//           transform: scale(1);
//   border: 0;
//   border-radius: 50%;
//   -webkit-box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.1);
//           box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.1);
//   background-color: rgba(0, 0, 0, 0.1);
// }
//
// [type="checkbox"]:checked + span:not(.lever):before {
//   top: -4px;
//   left: -5px;
//   width: 12px;
//   height: 22px;
//   border-top: 2px solid transparent;
//   border-left: 2px solid transparent;
//   border-right: 2px solid #ff411d;
//   border-bottom: 2px solid #ff411d;
//   -webkit-transform: rotate(40deg);
//           transform: rotate(40deg);
//   -webkit-backface-visibility: hidden;
//           backface-visibility: hidden;
//   -webkit-transform-origin: 100% 100%;
//           transform-origin: 100% 100%;
// }
//
// [type="checkbox"]:checked:disabled + span:before {
//   border-right: 2px solid rgba(0, 0, 0, 0.42);
//   border-bottom: 2px solid rgba(0, 0, 0, 0.42);
// }
//
// /* Indeterminate checkbox */
// [type="checkbox"]:indeterminate + span:not(.lever):before {
//   top: -11px;
//   left: -12px;
//   width: 10px;
//   height: 22px;
//   border-top: none;
//   border-left: none;
//   border-right: 2px solid #ff411d;
//   border-bottom: none;
//   -webkit-transform: rotate(90deg);
//           transform: rotate(90deg);
//   -webkit-backface-visibility: hidden;
//           backface-visibility: hidden;
//   -webkit-transform-origin: 100% 100%;
//           transform-origin: 100% 100%;
// }
//
// [type="checkbox"]:indeterminate:disabled + span:not(.lever):before {
//   border-right: 2px solid rgba(0, 0, 0, 0.42);
//   background-color: transparent;
// }
//
// [type="checkbox"].filled-in + span:not(.lever):after {
//   border-radius: 2px;
// }
//
// [type="checkbox"].filled-in + span:not(.lever):before,
// [type="checkbox"].filled-in + span:not(.lever):after {
//   content: '';
//   left: 0;
//   position: absolute;
//   /* .1s delay is for check animation */
//   -webkit-transition: border .25s, background-color .25s, width .20s .1s, height .20s .1s, top .20s .1s, left .20s .1s;
//   transition: border .25s, background-color .25s, width .20s .1s, height .20s .1s, top .20s .1s, left .20s .1s;
//   z-index: 1;
// }
//
// [type="checkbox"].filled-in:not(:checked) + span:not(.lever):before {
//   width: 0;
//   height: 0;
//   border: 3px solid transparent;
//   left: 6px;
//   top: 10px;
//   -webkit-transform: rotateZ(37deg);
//           transform: rotateZ(37deg);
//   -webkit-transform-origin: 100% 100%;
//           transform-origin: 100% 100%;
// }
//
// [type="checkbox"].filled-in:not(:checked) + span:not(.lever):after {
//   height: 20px;
//   width: 20px;
//   background-color: transparent;
//   border: 2px solid #5a5a5a;
//   top: 0;
//   z-index: 0;
// }
//
// [type="checkbox"].filled-in:checked + span:not(.lever):before {
//   top: 0;
//   left: 1px;
//   width: 8px;
//   height: 13px;
//   border-top: 2px solid transparent;
//   border-left: 2px solid transparent;
//   border-right: 2px solid #fff;
//   border-bottom: 2px solid #fff;
//   -webkit-transform: rotateZ(37deg);
//           transform: rotateZ(37deg);
//   -webkit-transform-origin: 100% 100%;
//           transform-origin: 100% 100%;
// }
//
// [type="checkbox"].filled-in:checked + span:not(.lever):after {
//   top: 0;
//   width: 20px;
//   height: 20px;
//   border: 2px solid #ff411d;
//   background-color: #ff411d;
//   z-index: 0;
// }
//
// [type="checkbox"].filled-in.tabbed:focus + span:not(.lever):after {
//   border-radius: 2px;
//   border-color: #5a5a5a;
//   background-color: rgba(0, 0, 0, 0.1);
// }
//
// [type="checkbox"].filled-in.tabbed:checked:focus + span:not(.lever):after {
//   border-radius: 2px;
//   background-color: #ff411d;
//   border-color: #ff411d;
// }
//
// [type="checkbox"].filled-in:disabled:not(:checked) + span:not(.lever):before {
//   background-color: transparent;
//   border: 2px solid transparent;
// }
//
// [type="checkbox"].filled-in:disabled:not(:checked) + span:not(.lever):after {
//   border-color: transparent;
//   background-color: #949494;
// }
//
// [type="checkbox"].filled-in:disabled:checked + span:not(.lever):before {
//   background-color: transparent;
// }
//
// [type="checkbox"].filled-in:disabled:checked + span:not(.lever):after {
//   background-color: #949494;
//   border-color: #949494;
// }
//
// /* Switch
//    ========================================================================== */
// .switch,
// .switch * {
//   -webkit-tap-highlight-color: transparent;
//   -webkit-user-select: none;
//      -moz-user-select: none;
//       -ms-user-select: none;
//           user-select: none;
// }
//
// .switch label {
//   cursor: pointer;
// }
//
// .switch label input[type=checkbox] {
//   opacity: 0;
//   width: 0;
//   height: 0;
// }
//
// .switch label input[type=checkbox]:checked + .lever {
//   background-color: #84c7c1;
// }
//
// .switch label input[type=checkbox]:checked + .lever:before, .switch label input[type=checkbox]:checked + .lever:after {
//   left: 18px;
// }
//
// .switch label input[type=checkbox]:checked + .lever:after {
//   background-color: #ff411d;
// }
//
// .switch label .lever {
//   content: "";
//   display: inline-block;
//   position: relative;
//   width: 36px;
//   height: 14px;
//   background-color: rgba(0, 0, 0, 0.38);
//   border-radius: 15px;
//   -webkit-transition: background 0.3s ease;
//   transition: background 0.3s ease;
//   vertical-align: middle;
//   margin: 0 16px;
// }
//
// .switch label .lever:before, .switch label .lever:after {
//   content: "";
//   position: absolute;
//   display: inline-block;
//   width: 20px;
//   height: 20px;
//   border-radius: 50%;
//   left: 0;
//   top: -3px;
//   -webkit-transition: left 0.3s ease, background .3s ease, -webkit-box-shadow 0.1s ease, -webkit-transform .1s ease;
//   transition: left 0.3s ease, background .3s ease, box-shadow 0.1s ease, transform .1s ease, -webkit-box-shadow 0.1s ease, -webkit-transform .1s ease;
// }
//
// .switch label .lever:before {
//   background-color: rgba(38, 166, 154, 0.15);
// }
//
// .switch label .lever:after {
//   background-color: #F1F1F1;
//   -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
//           box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
// }
//
// input[type=checkbox]:checked:not(:disabled) ~ .lever:active::before,
// input[type=checkbox]:checked:not(:disabled).tabbed:focus ~ .lever::before {
//   -webkit-transform: scale(2.4);
//           transform: scale(2.4);
//   background-color: rgba(38, 166, 154, 0.15);
// }
//
// input[type=checkbox]:not(:disabled) ~ .lever:active:before,
// input[type=checkbox]:not(:disabled).tabbed:focus ~ .lever::before {
//   -webkit-transform: scale(2.4);
//           transform: scale(2.4);
//   background-color: rgba(0, 0, 0, 0.08);
// }
//
// .switch input[type=checkbox][disabled] + .lever {
//   cursor: default;
//   background-color: rgba(0, 0, 0, 0.12);
// }
//
// .switch label input[type=checkbox][disabled] + .lever:after,
// .switch label input[type=checkbox][disabled]:checked + .lever:after {
//   background-color: #949494;
// }
//
// /* Select Field
//    ========================================================================== */
// select {
//   display: none;
// }
//
// select.browser-default {
//   display: block;
// }
//
// select {
//   background-color: rgba(255, 255, 255, 0.9);
//   width: 100%;
//   padding: 5px;
//   border: 1px solid #f2f2f2;
//   border-radius: 2px;
//   height: 3rem;
// }
//
// .select-label {
//   position: absolute;
// }
//
// .select-wrapper {
//   position: relative;
// }
//
// .select-wrapper.valid + label,
// .select-wrapper.invalid + label {
//   width: 100%;
//   pointer-events: none;
// }
//
// .select-wrapper input.select-dropdown {
//   position: relative;
//   cursor: pointer;
//   background-color: transparent;
//   border: none;
//   border-bottom: 1px solid #9e9e9e;
//   outline: none;
//   height: 3rem;
//   line-height: 3rem;
//   width: 100%;
//   font-size: 16px;
//   margin: 0 0 8px 0;
//   padding: 0;
//   display: block;
//   -webkit-user-select: none;
//      -moz-user-select: none;
//       -ms-user-select: none;
//           user-select: none;
//   z-index: 1;
// }
//
// .select-wrapper input.select-dropdown:focus {
//   border-bottom: 1px solid #ff411d;
// }
//
// .select-wrapper .caret {
//   position: absolute;
//   right: 0;
//   top: 0;
//   bottom: 0;
//   margin: auto 0;
//   z-index: 0;
//   fill: rgba(0, 0, 0, 0.87);
// }
//
// .select-wrapper + label {
//   position: absolute;
//   top: -20px;
//   font-size: 0.8rem;
// }
//
// select:disabled {
//   color: rgba(0, 0, 0, 0.42);
// }
//
// .select-wrapper.disabled + label {
//   color: rgba(0, 0, 0, 0.42);
// }
//
// .select-wrapper.disabled .caret {
//   fill: rgba(0, 0, 0, 0.42);
// }
//
// .select-wrapper input.select-dropdown:disabled {
//   color: rgba(0, 0, 0, 0.42);
//   cursor: default;
//   -webkit-user-select: none;
//      -moz-user-select: none;
//       -ms-user-select: none;
//           user-select: none;
// }
//
// .select-wrapper i {
//   color: rgba(0, 0, 0, 0.3);
// }
//
// .select-dropdown li.disabled,
// .select-dropdown li.disabled > span,
// .select-dropdown li.optgroup {
//   color: rgba(0, 0, 0, 0.3);
//   background-color: transparent;
// }
//
// body.keyboard-focused .select-dropdown.dropdown-content li:focus {
//   background-color: rgba(0, 0, 0, 0.08);
// }
//
// .select-dropdown.dropdown-content li:hover {
//   background-color: rgba(0, 0, 0, 0.08);
// }
//
// .select-dropdown.dropdown-content li.selected {
//   background-color: rgba(0, 0, 0, 0.03);
// }
//
// .prefix ~ .select-wrapper {
//   margin-left: 3rem;
//   width: 92%;
// }
//
// .prefix ~ label {
//   margin-left: 3rem;
// }
//
// .select-dropdown li img {
//   height: 40px;
//   width: 40px;
//   margin: 5px 15px;
//   float: right;
// }
//
// .select-dropdown li.optgroup {
//   border-top: 1px solid #eee;
// }
//
// .select-dropdown li.optgroup.selected > span {
//   color: rgba(0, 0, 0, 0.7);
// }
//
// .select-dropdown li.optgroup > span {
//   color: rgba(0, 0, 0, 0.4);
// }
//
// .select-dropdown li.optgroup ~ li.optgroup-option {
//   padding-left: 1rem;
// }
//
// /* File Input
//    ========================================================================== */
// .file-field {
//   position: relative;
// }
//
// .file-field .file-path-wrapper {
//   overflow: hidden;
//   padding-left: 10px;
// }
//
// .file-field input.file-path {
//   width: 100%;
// }
//
// .file-field .btn, .file-field .btn-large, .file-field .btn-small {
//   float: left;
//   height: 3rem;
//   line-height: 3rem;
// }
//
// .file-field span {
//   cursor: pointer;
// }
//
// .file-field input[type=file] {
//   position: absolute;
//   top: 0;
//   right: 0;
//   left: 0;
//   bottom: 0;
//   width: 100%;
//   margin: 0;
//   padding: 0;
//   font-size: 20px;
//   cursor: pointer;
//   opacity: 0;
//   filter: alpha(opacity=0);
// }
//
// .file-field input[type=file]::-webkit-file-upload-button {
//   display: none;
// }
//
// /* Range
//    ========================================================================== */
// .range-field {
//   position: relative;
// }
//
// input[type=range],
// input[type=range] + .thumb {
//   cursor: pointer;
// }
//
// input[type=range] {
//   position: relative;
//   background-color: transparent;
//   border: none;
//   outline: none;
//   width: 100%;
//   margin: 15px 0;
//   padding: 0;
// }
//
// input[type=range]:focus {
//   outline: none;
// }
//
// input[type=range] + .thumb {
//   position: absolute;
//   top: 10px;
//   left: 0;
//   border: none;
//   height: 0;
//   width: 0;
//   border-radius: 50%;
//   background-color: #ff411d;
//   margin-left: 7px;
//   -webkit-transform-origin: 50% 50%;
//           transform-origin: 50% 50%;
//   -webkit-transform: rotate(-45deg);
//           transform: rotate(-45deg);
// }
//
// input[type=range] + .thumb .value {
//   display: block;
//   width: 30px;
//   text-align: center;
//   color: #ff411d;
//   font-size: 0;
//   -webkit-transform: rotate(45deg);
//           transform: rotate(45deg);
// }
//
// input[type=range] + .thumb.active {
//   border-radius: 50% 50% 50% 0;
// }
//
// input[type=range] + .thumb.active .value {
//   color: #fff;
//   margin-left: -1px;
//   margin-top: 8px;
//   font-size: 10px;
// }
//
// input[type=range] {
//   -webkit-appearance: none;
// }
//
// input[type=range]::-webkit-slider-runnable-track {
//   height: 3px;
//   background: #c2c0c2;
//   border: none;
// }
//
// input[type=range]::-webkit-slider-thumb {
//   border: none;
//   height: 14px;
//   width: 14px;
//   border-radius: 50%;
//   -webkit-transition: -webkit-box-shadow .3s;
//   transition: -webkit-box-shadow .3s;
//   transition: box-shadow .3s, -webkit-box-shadow .3s;
//   -webkit-appearance: none;
//   background-color: #ff411d;
//   -webkit-transform-origin: 50% 50%;
//           transform-origin: 50% 50%;
//   margin: -5px 0 0 0;
// }
//
// .keyboard-focused input[type=range]:focus:not(.active)::-webkit-slider-thumb {
//   -webkit-box-shadow: 0 0 0 10px rgba(38, 166, 154, 0.26);
//           box-shadow: 0 0 0 10px rgba(38, 166, 154, 0.26);
// }
//
// input[type=range] {
//   /* fix for FF unable to apply focus style bug  */
//   border: 1px solid white;
//   /*required for proper track sizing in FF*/
// }
//
// input[type=range]::-moz-range-track {
//   height: 3px;
//   background: #c2c0c2;
//   border: none;
// }
//
// input[type=range]::-moz-focus-inner {
//   border: 0;
// }
//
// input[type=range]::-moz-range-thumb {
//   border: none;
//   height: 14px;
//   width: 14px;
//   border-radius: 50%;
//   background: #ff411d;
//   -webkit-transition: -webkit-box-shadow .3s;
//   transition: -webkit-box-shadow .3s;
//   transition: box-shadow .3s, -webkit-box-shadow .3s;
//   margin-top: -5px;
// }
//
// input[type=range]:-moz-focusring {
//   outline: 1px solid #fff;
//   outline-offset: -1px;
// }
//
// .keyboard-focused input[type=range]:focus:not(.active)::-moz-range-thumb {
//   box-shadow: 0 0 0 10px rgba(38, 166, 154, 0.26);
// }
//
// input[type=range]::-ms-track {
//   height: 3px;
//   background: transparent;
//   border-color: transparent;
//   border-width: 6px 0;
//   /*remove default tick marks*/
//   color: transparent;
// }
//
// input[type=range]::-ms-fill-lower {
//   background: #777;
// }
//
// input[type=range]::-ms-fill-upper {
//   background: #ddd;
// }
//
// input[type=range]::-ms-thumb {
//   border: none;
//   height: 14px;
//   width: 14px;
//   border-radius: 50%;
//   background: #ff411d;
//   -webkit-transition: -webkit-box-shadow .3s;
//   transition: -webkit-box-shadow .3s;
//   transition: box-shadow .3s, -webkit-box-shadow .3s;
// }
//
// .keyboard-focused input[type=range]:focus:not(.active)::-ms-thumb {
//   box-shadow: 0 0 0 10px rgba(38, 166, 154, 0.26);
// }
//
// /***************
//     Nav List
// ***************/
// .table-of-contents.fixed {
//   position: fixed;
// }
//
// .table-of-contents li {
//   padding: 2px 0;
// }
//
// .table-of-contents a {
//   display: inline-block;
//   font-weight: 300;
//   color: #757575;
//   padding-left: 16px;
//   height: 1.5rem;
//   line-height: 1.5rem;
// }
//
// .table-of-contents a:hover {
//   color: #a8a8a8;
//   padding-left: 15px;
//   border-left: 1px solid #ee6e73;
// }
//
// .table-of-contents a.active {
//   font-weight: 500;
//   padding-left: 14px;
//   border-left: 2px solid #ee6e73;
// }
//
// .sidenav {
//   position: fixed;
//   width: 300px;
//   left: 0;
//   top: 0;
//   margin: 0;
//   -webkit-transform: translateX(-100%);
//           transform: translateX(-100%);
//   height: 100%;
//   height: calc(100% + 60px);
//   height: -moz-calc(100%);
//   padding-bottom: 60px;
//   background-color: #fff;
//   z-index: 999;
//   overflow-y: auto;
//   will-change: transform;
//   -webkit-backface-visibility: hidden;
//           backface-visibility: hidden;
//   -webkit-transform: translateX(-105%);
//           transform: translateX(-105%);
// }
//
// .sidenav.right-aligned {
//   right: 0;
//   -webkit-transform: translateX(105%);
//           transform: translateX(105%);
//   left: auto;
//   -webkit-transform: translateX(100%);
//           transform: translateX(100%);
// }
//
// .sidenav .collapsible {
//   margin: 0;
// }
//
// .sidenav li {
//   float: none;
//   line-height: 48px;
// }
//
// .sidenav li.active {
//   background-color: rgba(0, 0, 0, 0.05);
// }
//
// .sidenav li > a {
//   color: rgba(0, 0, 0, 0.87);
//   display: block;
//   font-size: 14px;
//   font-weight: 500;
//   height: 48px;
//   line-height: 48px;
//   padding: 0 32px;
// }
//
// .sidenav li > a:hover {
//   background-color: rgba(0, 0, 0, 0.05);
// }
//
// .sidenav li > a.btn, .sidenav li > a.btn-large, .sidenav li > a.btn-small, .sidenav li > a.btn-large, .sidenav li > a.btn-flat, .sidenav li > a.btn-floating {
//   margin: 10px 15px;
// }
//
// .sidenav li > a.btn, .sidenav li > a.btn-large, .sidenav li > a.btn-small, .sidenav li > a.btn-large, .sidenav li > a.btn-floating {
//   color: #fff;
// }
//
// .sidenav li > a.btn-flat {
//   color: #343434;
// }
//
// .sidenav li > a.btn:hover, .sidenav li > a.btn-large:hover, .sidenav li > a.btn-small:hover, .sidenav li > a.btn-large:hover {
//   background-color: #2bbbad;
// }
//
// .sidenav li > a.btn-floating:hover {
//   background-color: #ff411d;
// }
//
// .sidenav li > a > i,
// .sidenav li > a > [class^="mdi-"], .sidenav li > a li > a > [class*="mdi-"],
// .sidenav li > a > i.material-icons {
//   float: left;
//   height: 48px;
//   line-height: 48px;
//   margin: 0 32px 0 0;
//   width: 24px;
//   color: rgba(0, 0, 0, 0.54);
// }
//
// .sidenav .divider {
//   margin: 8px 0 0 0;
// }
//
// .sidenav .subheader {
//   cursor: initial;
//   pointer-events: none;
//   color: rgba(0, 0, 0, 0.54);
//   font-size: 14px;
//   font-weight: 500;
//   line-height: 48px;
// }
//
// .sidenav .subheader:hover {
//   background-color: transparent;
// }
//
// .sidenav .user-view {
//   position: relative;
//   padding: 32px 32px 0;
//   margin-bottom: 8px;
// }
//
// .sidenav .user-view > a {
//   height: auto;
//   padding: 0;
// }
//
// .sidenav .user-view > a:hover {
//   background-color: transparent;
// }
//
// .sidenav .user-view .background {
//   overflow: hidden;
//   position: absolute;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   z-index: -1;
// }
//
// .sidenav .user-view .circle, .sidenav .user-view .name, .sidenav .user-view .email {
//   display: block;
// }
//
// .sidenav .user-view .circle {
//   height: 64px;
//   width: 64px;
// }
//
// .sidenav .user-view .name,
// .sidenav .user-view .email {
//   font-size: 14px;
//   line-height: 24px;
// }
//
// .sidenav .user-view .name {
//   margin-top: 8px;
//   font-weight: 700;
// }
//
// .sidenav .user-view .email {
//   padding-bottom: 5px;
//   font-weight: 400;
// }
//
// .drag-target {
//   height: 100%;
//   width: 10px;
//   position: fixed;
//   top: 0;
//   z-index: 998;
// }
//
// .drag-target.right-aligned {
//   right: 0;
// }
//
// .sidenav.sidenav-fixed {
//   left: 0;
//   -webkit-transform: translateX(0);
//           transform: translateX(0);
//   position: fixed;
// }
//
// .sidenav.sidenav-fixed.right-aligned {
//   right: 0;
//   left: auto;
// }
//
// @media only screen and (max-width: 992px) {
//   .sidenav.sidenav-fixed {
//     -webkit-transform: translateX(-105%);
//             transform: translateX(-105%);
//   }
//   .sidenav.sidenav-fixed.right-aligned {
//     -webkit-transform: translateX(105%);
//             transform: translateX(105%);
//   }
//   .sidenav > a {
//     padding: 0 16px;
//   }
//   .sidenav .user-view {
//     padding: 16px 16px 0;
//   }
// }
//
// .sidenav .collapsible-body > ul:not(.collapsible) > li.active,
// .sidenav.sidenav-fixed .collapsible-body > ul:not(.collapsible) > li.active {
//   background-color: #ee6e73;
// }
//
// .sidenav .collapsible-body > ul:not(.collapsible) > li.active a,
// .sidenav.sidenav-fixed .collapsible-body > ul:not(.collapsible) > li.active a {
//   color: #fff;
// }
//
// .sidenav .collapsible-body {
//   padding: 0;
// }
//
// .sidenav-overlay {
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   opacity: 0;
//   height: 120vh;
//   background-color: rgba(0, 0, 0, 0.5);
//   z-index: 997;
//   display: none;
// }
//
// /*
//     @license
//     Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
//     This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
//     The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
//     The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
//     Code distributed by Google as part of the polymer project is also
//     subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
//  */
// /**************************/
// /* STYLES FOR THE SPINNER */
// /**************************/
// /*
//  * Constants:
//  *      STROKEWIDTH = 3px
//  *      ARCSIZE     = 270 degrees (amount of circle the arc takes up)
//  *      ARCTIME     = 1333ms (time it takes to expand and contract arc)
//  *      ARCSTARTROT = 216 degrees (how much the start location of the arc
//  *                                should rotate each time, 216 gives us a
//  *                                5 pointed star shape (it's 360/5 * 3).
//  *                                For a 7 pointed star, we might do
//  *                                360/7 * 3 = 154.286)
//  *      CONTAINERWIDTH = 28px
//  *      SHRINK_TIME = 400ms
//  */
// .preloader-wrapper {
//   display: inline-block;
//   position: relative;
//   width: 50px;
//   height: 50px;
// }
//
// .preloader-wrapper.small {
//   width: 36px;
//   height: 36px;
// }
//
// .preloader-wrapper.big {
//   width: 64px;
//   height: 64px;
// }
//
// .preloader-wrapper.active {
//   /* duration: 360 * ARCTIME / (ARCSTARTROT + (360-ARCSIZE)) */
//   -webkit-animation: container-rotate 1568ms linear infinite;
//   animation: container-rotate 1568ms linear infinite;
// }
//
// @-webkit-keyframes container-rotate {
//   to {
//     -webkit-transform: rotate(360deg);
//   }
// }
//
// @keyframes container-rotate {
//   to {
//     -webkit-transform: rotate(360deg);
//             transform: rotate(360deg);
//   }
// }
//
// .spinner-layer {
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   opacity: 0;
//   border-color: #ff411d;
// }
//
// .spinner-blue,
// .spinner-blue-only {
//   border-color: #4285f4;
// }
//
// .spinner-red,
// .spinner-red-only {
//   border-color: #db4437;
// }
//
// .spinner-yellow,
// .spinner-yellow-only {
//   border-color: #f4b400;
// }
//
// .spinner-green,
// .spinner-green-only {
//   border-color: #0f9d58;
// }
//
// /**
//  * IMPORTANT NOTE ABOUT CSS ANIMATION PROPERTIES (keanulee):
//  *
//  * iOS Safari (tested on iOS 8.1) does not handle animation-delay very well - it doesn't
//  * guarantee that the animation will start _exactly_ after that value. So we avoid using
//  * animation-delay and instead set custom keyframes for each color (as redundant as it
//  * seems).
//  *
//  * We write out each animation in full (instead of separating animation-name,
//  * animation-duration, etc.) because under the polyfill, Safari does not recognize those
//  * specific properties properly, treats them as -webkit-animation, and overrides the
//  * other animation rules. See https://github.com/Polymer/platform/issues/53.
//  */
// .active .spinner-layer.spinner-blue {
//   /* durations: 4 * ARCTIME */
//   -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, blue-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
//   animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, blue-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
// }
//
// .active .spinner-layer.spinner-red {
//   /* durations: 4 * ARCTIME */
//   -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, red-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
//   animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, red-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
// }
//
// .active .spinner-layer.spinner-yellow {
//   /* durations: 4 * ARCTIME */
//   -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, yellow-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
//   animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, yellow-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
// }
//
// .active .spinner-layer.spinner-green {
//   /* durations: 4 * ARCTIME */
//   -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, green-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
//   animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, green-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
// }
//
// .active .spinner-layer,
// .active .spinner-layer.spinner-blue-only,
// .active .spinner-layer.spinner-red-only,
// .active .spinner-layer.spinner-yellow-only,
// .active .spinner-layer.spinner-green-only {
//   /* durations: 4 * ARCTIME */
//   opacity: 1;
//   -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
//   animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
// }
//
// @-webkit-keyframes fill-unfill-rotate {
//   12.5% {
//     -webkit-transform: rotate(135deg);
//   }
//   /* 0.5 * ARCSIZE */
//   25% {
//     -webkit-transform: rotate(270deg);
//   }
//   /* 1   * ARCSIZE */
//   37.5% {
//     -webkit-transform: rotate(405deg);
//   }
//   /* 1.5 * ARCSIZE */
//   50% {
//     -webkit-transform: rotate(540deg);
//   }
//   /* 2   * ARCSIZE */
//   62.5% {
//     -webkit-transform: rotate(675deg);
//   }
//   /* 2.5 * ARCSIZE */
//   75% {
//     -webkit-transform: rotate(810deg);
//   }
//   /* 3   * ARCSIZE */
//   87.5% {
//     -webkit-transform: rotate(945deg);
//   }
//   /* 3.5 * ARCSIZE */
//   to {
//     -webkit-transform: rotate(1080deg);
//   }
//   /* 4   * ARCSIZE */
// }
//
// @keyframes fill-unfill-rotate {
//   12.5% {
//     -webkit-transform: rotate(135deg);
//             transform: rotate(135deg);
//   }
//   /* 0.5 * ARCSIZE */
//   25% {
//     -webkit-transform: rotate(270deg);
//             transform: rotate(270deg);
//   }
//   /* 1   * ARCSIZE */
//   37.5% {
//     -webkit-transform: rotate(405deg);
//             transform: rotate(405deg);
//   }
//   /* 1.5 * ARCSIZE */
//   50% {
//     -webkit-transform: rotate(540deg);
//             transform: rotate(540deg);
//   }
//   /* 2   * ARCSIZE */
//   62.5% {
//     -webkit-transform: rotate(675deg);
//             transform: rotate(675deg);
//   }
//   /* 2.5 * ARCSIZE */
//   75% {
//     -webkit-transform: rotate(810deg);
//             transform: rotate(810deg);
//   }
//   /* 3   * ARCSIZE */
//   87.5% {
//     -webkit-transform: rotate(945deg);
//             transform: rotate(945deg);
//   }
//   /* 3.5 * ARCSIZE */
//   to {
//     -webkit-transform: rotate(1080deg);
//             transform: rotate(1080deg);
//   }
//   /* 4   * ARCSIZE */
// }
//
// @-webkit-keyframes blue-fade-in-out {
//   from {
//     opacity: 1;
//   }
//   25% {
//     opacity: 1;
//   }
//   26% {
//     opacity: 0;
//   }
//   89% {
//     opacity: 0;
//   }
//   90% {
//     opacity: 1;
//   }
//   100% {
//     opacity: 1;
//   }
// }
//
// @keyframes blue-fade-in-out {
//   from {
//     opacity: 1;
//   }
//   25% {
//     opacity: 1;
//   }
//   26% {
//     opacity: 0;
//   }
//   89% {
//     opacity: 0;
//   }
//   90% {
//     opacity: 1;
//   }
//   100% {
//     opacity: 1;
//   }
// }
//
// @-webkit-keyframes red-fade-in-out {
//   from {
//     opacity: 0;
//   }
//   15% {
//     opacity: 0;
//   }
//   25% {
//     opacity: 1;
//   }
//   50% {
//     opacity: 1;
//   }
//   51% {
//     opacity: 0;
//   }
// }
//
// @keyframes red-fade-in-out {
//   from {
//     opacity: 0;
//   }
//   15% {
//     opacity: 0;
//   }
//   25% {
//     opacity: 1;
//   }
//   50% {
//     opacity: 1;
//   }
//   51% {
//     opacity: 0;
//   }
// }
//
// @-webkit-keyframes yellow-fade-in-out {
//   from {
//     opacity: 0;
//   }
//   40% {
//     opacity: 0;
//   }
//   50% {
//     opacity: 1;
//   }
//   75% {
//     opacity: 1;
//   }
//   76% {
//     opacity: 0;
//   }
// }
//
// @keyframes yellow-fade-in-out {
//   from {
//     opacity: 0;
//   }
//   40% {
//     opacity: 0;
//   }
//   50% {
//     opacity: 1;
//   }
//   75% {
//     opacity: 1;
//   }
//   76% {
//     opacity: 0;
//   }
// }
//
// @-webkit-keyframes green-fade-in-out {
//   from {
//     opacity: 0;
//   }
//   65% {
//     opacity: 0;
//   }
//   75% {
//     opacity: 1;
//   }
//   90% {
//     opacity: 1;
//   }
//   100% {
//     opacity: 0;
//   }
// }
//
// @keyframes green-fade-in-out {
//   from {
//     opacity: 0;
//   }
//   65% {
//     opacity: 0;
//   }
//   75% {
//     opacity: 1;
//   }
//   90% {
//     opacity: 1;
//   }
//   100% {
//     opacity: 0;
//   }
// }
//
// /**
//  * Patch the gap that appear between the two adjacent div.circle-clipper while the
//  * spinner is rotating (appears on Chrome 38, Safari 7.1, and IE 11).
//  */
// .gap-patch {
//   position: absolute;
//   top: 0;
//   left: 45%;
//   width: 10%;
//   height: 100%;
//   overflow: hidden;
//   border-color: inherit;
// }
//
// .gap-patch .circle {
//   width: 1000%;
//   left: -450%;
// }
//
// .circle-clipper {
//   display: inline-block;
//   position: relative;
//   width: 50%;
//   height: 100%;
//   overflow: hidden;
//   border-color: inherit;
// }
//
// .circle-clipper .circle {
//   width: 200%;
//   height: 100%;
//   border-width: 3px;
//   /* STROKEWIDTH */
//   border-style: solid;
//   border-color: inherit;
//   border-bottom-color: transparent !important;
//   border-radius: 50%;
//   -webkit-animation: none;
//   animation: none;
//   position: absolute;
//   top: 0;
//   right: 0;
//   bottom: 0;
// }
//
// .circle-clipper.left .circle {
//   left: 0;
//   border-right-color: transparent !important;
//   -webkit-transform: rotate(129deg);
//   transform: rotate(129deg);
// }
//
// .circle-clipper.right .circle {
//   left: -100%;
//   border-left-color: transparent !important;
//   -webkit-transform: rotate(-129deg);
//   transform: rotate(-129deg);
// }
//
// .active .circle-clipper.left .circle {
//   /* duration: ARCTIME */
//   -webkit-animation: left-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
//   animation: left-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
// }
//
// .active .circle-clipper.right .circle {
//   /* duration: ARCTIME */
//   -webkit-animation: right-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
//   animation: right-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
// }
//
// @-webkit-keyframes left-spin {
//   from {
//     -webkit-transform: rotate(130deg);
//   }
//   50% {
//     -webkit-transform: rotate(-5deg);
//   }
//   to {
//     -webkit-transform: rotate(130deg);
//   }
// }
//
// @keyframes left-spin {
//   from {
//     -webkit-transform: rotate(130deg);
//             transform: rotate(130deg);
//   }
//   50% {
//     -webkit-transform: rotate(-5deg);
//             transform: rotate(-5deg);
//   }
//   to {
//     -webkit-transform: rotate(130deg);
//             transform: rotate(130deg);
//   }
// }
//
// @-webkit-keyframes right-spin {
//   from {
//     -webkit-transform: rotate(-130deg);
//   }
//   50% {
//     -webkit-transform: rotate(5deg);
//   }
//   to {
//     -webkit-transform: rotate(-130deg);
//   }
// }
//
// @keyframes right-spin {
//   from {
//     -webkit-transform: rotate(-130deg);
//             transform: rotate(-130deg);
//   }
//   50% {
//     -webkit-transform: rotate(5deg);
//             transform: rotate(5deg);
//   }
//   to {
//     -webkit-transform: rotate(-130deg);
//             transform: rotate(-130deg);
//   }
// }
//
// #spinnerContainer.cooldown {
//   /* duration: SHRINK_TIME */
//   -webkit-animation: container-rotate 1568ms linear infinite, fade-out 400ms cubic-bezier(0.4, 0, 0.2, 1);
//   animation: container-rotate 1568ms linear infinite, fade-out 400ms cubic-bezier(0.4, 0, 0.2, 1);
// }
//
// @-webkit-keyframes fade-out {
//   from {
//     opacity: 1;
//   }
//   to {
//     opacity: 0;
//   }
// }
//
// @keyframes fade-out {
//   from {
//     opacity: 1;
//   }
//   to {
//     opacity: 0;
//   }
// }
//
// .slider {
//   position: relative;
//   height: 400px;
//   width: 100%;
// }
//
// .slider.fullscreen {
//   height: 100%;
//   width: 100%;
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
// }
//
// .slider.fullscreen ul.slides {
//   height: 100%;
// }
//
// .slider.fullscreen ul.indicators {
//   z-index: 2;
//   bottom: 30px;
// }
//
// .slider .slides {
//   background-color: #9e9e9e;
//   margin: 0;
//   height: 400px;
// }
//
// .slider .slides li {
//   opacity: 0;
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 1;
//   width: 100%;
//   height: inherit;
//   overflow: hidden;
// }
//
// .slider .slides li img {
//   height: 100%;
//   width: 100%;
//   background-size: cover;
//   background-position: center;
// }
//
// .slider .slides li .caption {
//   color: #fff;
//   position: absolute;
//   top: 15%;
//   left: 15%;
//   width: 70%;
//   opacity: 0;
// }
//
// .slider .slides li .caption p {
//   color: #e0e0e0;
// }
//
// .slider .slides li.active {
//   z-index: 2;
// }
//
// .slider .indicators {
//   position: absolute;
//   text-align: center;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   margin: 0;
// }
//
// .slider .indicators .indicator-item {
//   display: inline-block;
//   position: relative;
//   cursor: pointer;
//   height: 16px;
//   width: 16px;
//   margin: 0 12px;
//   background-color: #e0e0e0;
//   -webkit-transition: background-color .3s;
//   transition: background-color .3s;
//   border-radius: 50%;
// }
//
// .slider .indicators .indicator-item.active {
//   background-color: #4CAF50;
// }
//
// .carousel {
//   overflow: hidden;
//   position: relative;
//   width: 100%;
//   height: 400px;
//   -webkit-perspective: 500px;
//           perspective: 500px;
//   -webkit-transform-style: preserve-3d;
//           transform-style: preserve-3d;
//   -webkit-transform-origin: 0% 50%;
//           transform-origin: 0% 50%;
// }
//
// .carousel.carousel-slider {
//   top: 0;
//   left: 0;
// }
//
// .carousel.carousel-slider .carousel-fixed-item {
//   position: absolute;
//   left: 0;
//   right: 0;
//   bottom: 20px;
//   z-index: 1;
// }
//
// .carousel.carousel-slider .carousel-fixed-item.with-indicators {
//   bottom: 68px;
// }
//
// .carousel.carousel-slider .carousel-item {
//   width: 100%;
//   height: 100%;
//   min-height: 400px;
//   position: absolute;
//   top: 0;
//   left: 0;
// }
//
// .carousel.carousel-slider .carousel-item h2 {
//   font-size: 24px;
//   font-weight: 500;
//   line-height: 32px;
// }
//
// .carousel.carousel-slider .carousel-item p {
//   font-size: 15px;
// }
//
// .carousel .carousel-item {
//   visibility: hidden;
//   width: 200px;
//   height: 200px;
//   position: absolute;
//   top: 0;
//   left: 0;
// }
//
// .carousel .carousel-item > img {
//   width: 100%;
// }
//
// .carousel .indicators {
//   position: absolute;
//   text-align: center;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   margin: 0;
// }
//
// .carousel .indicators .indicator-item {
//   display: inline-block;
//   position: relative;
//   cursor: pointer;
//   height: 8px;
//   width: 8px;
//   margin: 24px 4px;
//   background-color: rgba(255, 255, 255, 0.5);
//   -webkit-transition: background-color .3s;
//   transition: background-color .3s;
//   border-radius: 50%;
// }
//
// .carousel .indicators .indicator-item.active {
//   background-color: #fff;
// }
//
// .carousel.scrolling .carousel-item .materialboxed,
// .carousel .carousel-item:not(.active) .materialboxed {
//   pointer-events: none;
// }
//
// .tap-target-wrapper {
//   width: 800px;
//   height: 800px;
//   position: fixed;
//   z-index: 1000;
//   visibility: hidden;
//   -webkit-transition: visibility 0s .3s;
//   transition: visibility 0s .3s;
// }
//
// .tap-target-wrapper.open {
//   visibility: visible;
//   -webkit-transition: visibility 0s;
//   transition: visibility 0s;
// }
//
// .tap-target-wrapper.open .tap-target {
//   -webkit-transform: scale(1);
//           transform: scale(1);
//   opacity: .95;
//   -webkit-transition: opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);
//   transition: opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);
//   transition: transform 0.3s cubic-bezier(0.42, 0, 0.58, 1), opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1);
//   transition: transform 0.3s cubic-bezier(0.42, 0, 0.58, 1), opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);
// }
//
// .tap-target-wrapper.open .tap-target-wave::before {
//   -webkit-transform: scale(1);
//           transform: scale(1);
// }
//
// .tap-target-wrapper.open .tap-target-wave::after {
//   visibility: visible;
//   -webkit-animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;
//           animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;
//   -webkit-transition: opacity .3s,
//  visibility 0s 1s,
//  -webkit-transform .3s;
//   transition: opacity .3s,
//  visibility 0s 1s,
//  -webkit-transform .3s;
//   transition: opacity .3s,
//  transform .3s,
//  visibility 0s 1s;
//   transition: opacity .3s,
//  transform .3s,
//  visibility 0s 1s,
//  -webkit-transform .3s;
// }
//
// .tap-target {
//   position: absolute;
//   font-size: 1rem;
//   border-radius: 50%;
//   background-color: #ee6e73;
//   -webkit-box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.14), 0 10px 50px 0 rgba(0, 0, 0, 0.12), 0 30px 10px -20px rgba(0, 0, 0, 0.2);
//           box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.14), 0 10px 50px 0 rgba(0, 0, 0, 0.12), 0 30px 10px -20px rgba(0, 0, 0, 0.2);
//   width: 100%;
//   height: 100%;
//   opacity: 0;
//   -webkit-transform: scale(0);
//           transform: scale(0);
//   -webkit-transition: opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);
//   transition: opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);
//   transition: transform 0.3s cubic-bezier(0.42, 0, 0.58, 1), opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1);
//   transition: transform 0.3s cubic-bezier(0.42, 0, 0.58, 1), opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);
// }
//
// .tap-target-content {
//   position: relative;
//   display: table-cell;
// }
//
// .tap-target-wave {
//   position: absolute;
//   border-radius: 50%;
//   z-index: 10001;
// }
//
// .tap-target-wave::before, .tap-target-wave::after {
//   content: '';
//   display: block;
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   border-radius: 50%;
//   background-color: #ffffff;
// }
//
// .tap-target-wave::before {
//   -webkit-transform: scale(0);
//           transform: scale(0);
//   -webkit-transition: -webkit-transform .3s;
//   transition: -webkit-transform .3s;
//   transition: transform .3s;
//   transition: transform .3s, -webkit-transform .3s;
// }
//
// .tap-target-wave::after {
//   visibility: hidden;
//   -webkit-transition: opacity .3s,
//  visibility 0s,
//  -webkit-transform .3s;
//   transition: opacity .3s,
//  visibility 0s,
//  -webkit-transform .3s;
//   transition: opacity .3s,
//  transform .3s,
//  visibility 0s;
//   transition: opacity .3s,
//  transform .3s,
//  visibility 0s,
//  -webkit-transform .3s;
//   z-index: -1;
// }
//
// .tap-target-origin {
//   top: 50%;
//   left: 50%;
//   -webkit-transform: translate(-50%, -50%);
//           transform: translate(-50%, -50%);
//   z-index: 10002;
//   position: absolute !important;
// }
//
// .tap-target-origin:not(.btn):not(.btn-large):not(.btn-small), .tap-target-origin:not(.btn):not(.btn-large):not(.btn-small):hover {
//   background: none;
// }
//
// @media only screen and (max-width: 600px) {
//   .tap-target, .tap-target-wrapper {
//     width: 600px;
//     height: 600px;
//   }
// }
//
// .pulse {
//   overflow: visible;
//   position: relative;
// }
//
// .pulse::before {
//   content: '';
//   display: block;
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   top: 0;
//   left: 0;
//   background-color: inherit;
//   border-radius: inherit;
//   -webkit-transition: opacity .3s, -webkit-transform .3s;
//   transition: opacity .3s, -webkit-transform .3s;
//   transition: opacity .3s, transform .3s;
//   transition: opacity .3s, transform .3s, -webkit-transform .3s;
//   -webkit-animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;
//           animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;
//   z-index: -1;
// }
//
// @-webkit-keyframes pulse-animation {
//   0% {
//     opacity: 1;
//     -webkit-transform: scale(1);
//             transform: scale(1);
//   }
//   50% {
//     opacity: 0;
//     -webkit-transform: scale(1.5);
//             transform: scale(1.5);
//   }
//   100% {
//     opacity: 0;
//     -webkit-transform: scale(1.5);
//             transform: scale(1.5);
//   }
// }
//
// @keyframes pulse-animation {
//   0% {
//     opacity: 1;
//     -webkit-transform: scale(1);
//             transform: scale(1);
//   }
//   50% {
//     opacity: 0;
//     -webkit-transform: scale(1.5);
//             transform: scale(1.5);
//   }
//   100% {
//     opacity: 0;
//     -webkit-transform: scale(1.5);
//             transform: scale(1.5);
//   }
// }
//
// /* Modal */
// .datepicker-modal {
//   max-width: 325px;
//   min-width: 300px;
//   max-height: none;
// }
//
// .datepicker-container.modal-content {
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-orient: vertical;
//   -webkit-box-direction: normal;
//   -webkit-flex-direction: column;
//       -ms-flex-direction: column;
//           flex-direction: column;
//   padding: 0;
// }
//
// .datepicker-controls {
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-pack: justify;
//   -webkit-justify-content: space-between;
//       -ms-flex-pack: justify;
//           justify-content: space-between;
//   width: 280px;
//   margin: 0 auto;
// }
//
// .datepicker-controls .selects-container {
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
// }
//
// .datepicker-controls .select-wrapper input {
//   border-bottom: none;
//   text-align: center;
//   margin: 0;
// }
//
// .datepicker-controls .select-wrapper input:focus {
//   border-bottom: none;
// }
//
// .datepicker-controls .select-wrapper .caret {
//   display: none;
// }
//
// .datepicker-controls .select-year input {
//   width: 50px;
// }
//
// .datepicker-controls .select-month input {
//   width: 70px;
// }
//
// .month-prev, .month-next {
//   margin-top: 4px;
//   cursor: pointer;
//   background-color: transparent;
//   border: none;
// }
//
// /* Date Display */
// .datepicker-date-display {
//   -webkit-box-flex: 1;
//   -webkit-flex: 1 auto;
//       -ms-flex: 1 auto;
//           flex: 1 auto;
//   background-color: #ff411d;
//   color: #fff;
//   padding: 20px 22px;
//   font-weight: 500;
// }
//
// .datepicker-date-display .year-text {
//   display: block;
//   font-size: 1.5rem;
//   line-height: 25px;
//   color: rgba(255, 255, 255, 0.7);
// }
//
// .datepicker-date-display .date-text {
//   display: block;
//   font-size: 2.8rem;
//   line-height: 47px;
//   font-weight: 500;
// }
//
// /* Calendar */
// .datepicker-calendar-container {
//   -webkit-box-flex: 2.5;
//   -webkit-flex: 2.5 auto;
//       -ms-flex: 2.5 auto;
//           flex: 2.5 auto;
// }
//
// .datepicker-table {
//   width: 280px;
//   font-size: 1rem;
//   margin: 0 auto;
// }
//
// .datepicker-table thead {
//   border-bottom: none;
// }
//
// .datepicker-table th {
//   padding: 10px 5px;
//   text-align: center;
// }
//
// .datepicker-table tr {
//   border: none;
// }
//
// .datepicker-table abbr {
//   text-decoration: none;
//   color: #999;
// }
//
// .datepicker-table td {
//   border-radius: 50%;
//   padding: 0;
// }
//
// .datepicker-table td.is-today {
//   color: #ff411d;
// }
//
// .datepicker-table td.is-selected {
//   background-color: #ff411d;
//   color: #fff;
// }
//
// .datepicker-table td.is-outside-current-month, .datepicker-table td.is-disabled {
//   color: rgba(0, 0, 0, 0.3);
//   pointer-events: none;
// }
//
// .datepicker-day-button {
//   background-color: transparent;
//   border: none;
//   line-height: 38px;
//   display: block;
//   width: 100%;
//   border-radius: 50%;
//   padding: 0 5px;
//   cursor: pointer;
//   color: inherit;
// }
//
// .datepicker-day-button:focus {
//   background-color: rgba(43, 161, 150, 0.25);
// }
//
// /* Footer */
// .datepicker-footer {
//   width: 280px;
//   margin: 0 auto;
//   padding-bottom: 5px;
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-pack: justify;
//   -webkit-justify-content: space-between;
//       -ms-flex-pack: justify;
//           justify-content: space-between;
// }
//
// .datepicker-cancel,
// .datepicker-clear,
// .datepicker-today,
// .datepicker-done {
//   color: #ff411d;
//   padding: 0 1rem;
// }
//
// .datepicker-clear {
//   color: #F44336;
// }
//
// /* Media Queries */
// @media only screen and (min-width: 601px) {
//   .datepicker-modal {
//     max-width: 625px;
//   }
//   .datepicker-container.modal-content {
//     -webkit-box-orient: horizontal;
//     -webkit-box-direction: normal;
//     -webkit-flex-direction: row;
//         -ms-flex-direction: row;
//             flex-direction: row;
//   }
//   .datepicker-date-display {
//     -webkit-box-flex: 0;
//     -webkit-flex: 0 1 270px;
//         -ms-flex: 0 1 270px;
//             flex: 0 1 270px;
//   }
//   .datepicker-controls,
//   .datepicker-table,
//   .datepicker-footer {
//     width: 320px;
//   }
//   .datepicker-day-button {
//     line-height: 44px;
//   }
// }
//
// /* Timepicker Containers */
// .timepicker-modal {
//   max-width: 325px;
//   max-height: none;
// }
//
// .timepicker-container.modal-content {
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-orient: vertical;
//   -webkit-box-direction: normal;
//   -webkit-flex-direction: column;
//       -ms-flex-direction: column;
//           flex-direction: column;
//   padding: 0;
// }
//
// .text-primary {
//   color: white;
// }
//
// /* Clock Digital Display */
// .timepicker-digital-display {
//   -webkit-box-flex: 1;
//   -webkit-flex: 1 auto;
//       -ms-flex: 1 auto;
//           flex: 1 auto;
//   background-color: #ff411d;
//   padding: 10px;
//   font-weight: 300;
// }
//
// .timepicker-text-container {
//   font-size: 4rem;
//   font-weight: bold;
//   text-align: center;
//   color: rgba(255, 255, 255, 0.6);
//   font-weight: 400;
//   position: relative;
//   -webkit-user-select: none;
//      -moz-user-select: none;
//       -ms-user-select: none;
//           user-select: none;
// }
//
// .timepicker-span-hours,
// .timepicker-span-minutes,
// .timepicker-span-am-pm div {
//   cursor: pointer;
// }
//
// .timepicker-span-hours {
//   margin-right: 3px;
// }
//
// .timepicker-span-minutes {
//   margin-left: 3px;
// }
//
// .timepicker-display-am-pm {
//   font-size: 1.3rem;
//   position: absolute;
//   right: 1rem;
//   bottom: 1rem;
//   font-weight: 400;
// }
//
// /* Analog Clock Display */
// .timepicker-analog-display {
//   -webkit-box-flex: 2.5;
//   -webkit-flex: 2.5 auto;
//       -ms-flex: 2.5 auto;
//           flex: 2.5 auto;
// }
//
// .timepicker-plate {
//   background-color: #eee;
//   border-radius: 50%;
//   width: 270px;
//   height: 270px;
//   overflow: visible;
//   position: relative;
//   margin: auto;
//   margin-top: 25px;
//   margin-bottom: 5px;
//   -webkit-user-select: none;
//      -moz-user-select: none;
//       -ms-user-select: none;
//           user-select: none;
// }
//
// .timepicker-canvas,
// .timepicker-dial {
//   position: absolute;
//   left: 0;
//   right: 0;
//   top: 0;
//   bottom: 0;
// }
//
// .timepicker-minutes {
//   visibility: hidden;
// }
//
// .timepicker-tick {
//   border-radius: 50%;
//   color: rgba(0, 0, 0, 0.87);
//   line-height: 40px;
//   text-align: center;
//   width: 40px;
//   height: 40px;
//   position: absolute;
//   cursor: pointer;
//   font-size: 15px;
// }
//
// .timepicker-tick.active,
// .timepicker-tick:hover {
//   background-color: rgba(38, 166, 154, 0.25);
// }
//
// .timepicker-dial {
//   -webkit-transition: opacity 350ms, -webkit-transform 350ms;
//   transition: opacity 350ms, -webkit-transform 350ms;
//   transition: transform 350ms, opacity 350ms;
//   transition: transform 350ms, opacity 350ms, -webkit-transform 350ms;
// }
//
// .timepicker-dial-out {
//   opacity: 0;
// }
//
// .timepicker-dial-out.timepicker-hours {
//   -webkit-transform: scale(1.1, 1.1);
//           transform: scale(1.1, 1.1);
// }
//
// .timepicker-dial-out.timepicker-minutes {
//   -webkit-transform: scale(0.8, 0.8);
//           transform: scale(0.8, 0.8);
// }
//
// .timepicker-canvas {
//   -webkit-transition: opacity 175ms;
//   transition: opacity 175ms;
// }
//
// .timepicker-canvas line {
//   stroke: #ff411d;
//   stroke-width: 4;
//   stroke-linecap: round;
// }
//
// .timepicker-canvas-out {
//   opacity: 0.25;
// }
//
// .timepicker-canvas-bearing {
//   stroke: none;
//   fill: #ff411d;
// }
//
// .timepicker-canvas-bg {
//   stroke: none;
//   fill: #ff411d;
// }
//
// /* Footer */
// .timepicker-footer {
//   margin: 0 auto;
//   padding: 5px 1rem;
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-pack: justify;
//   -webkit-justify-content: space-between;
//       -ms-flex-pack: justify;
//           justify-content: space-between;
// }
//
// .timepicker-clear {
//   color: #F44336;
// }
//
// .timepicker-close {
//   color: #ff411d;
// }
//
// .timepicker-clear,
// .timepicker-close {
//   padding: 0 20px;
// }
//
// /* Media Queries */
// @media only screen and (min-width: 601px) {
//   .timepicker-modal {
//     max-width: 600px;
//   }
//   .timepicker-container.modal-content {
//     -webkit-box-orient: horizontal;
//     -webkit-box-direction: normal;
//     -webkit-flex-direction: row;
//         -ms-flex-direction: row;
//             flex-direction: row;
//   }
//   .timepicker-text-container {
//     top: 32%;
//   }
//   .timepicker-display-am-pm {
//     position: relative;
//     right: auto;
//     bottom: auto;
//     text-align: center;
//     margin-top: 1.2rem;
//   }
// }
//
// .flex .col .card {
//
//   height: 100%;
//
// }
//
// html {
//     scroll-behavior: smooth;
// }
//
// body a {
//     color: #039be5;
// }
//
// a, button, .btn-primary, input[type="submit"] {
//     cursor:pointer;
// }
//
// .apto-page.row {
//     margin: 0;
// }
//
// .container {
//     width: 75%!important;
//     max-width: 1140px!important;
// }
//
// @media only screen and (max-width: 990px) {
//
//     .container {
//         width: 85% !important;
//     }
//
// }
// @media only screen and (max-width: 600px) {
//
//     .container {
//         width: 95% !important;
//     }
//
// }
//
// @media only screen and (max-width: 360px) {
//
//     .container {
//         width: 100% !important;
//     }
//
// }
//
// .single-application .application-page .container {
//     width: 90% !important;
// }
//
// @media screen and (max-width: 400px) {
//
//     .single-application .application-page .container {
//
//         width: 100% !important;
//     }
//
// }
//
// // main svg:not(.caret){
// //     width: 100%;
// //     height: auto;
// //     position:relative;
// //     top:6px;
// // }
//
// main svg.diagonal-left {
//     top: 6px;
//     margin-top: -30px;
// }
//
// svg.curved-divider.curved-bottom-left,svg.curved-divider.curved-bottom-right {
//     position: absolute;
//     bottom: 0;
//     top: auto;
//
// }
//
// @media only screen and (max-width: 530px) {
//     #pageCardContent .separator-wrapper svg.curved-divider.curved-bottom-right {
//
//         top: 0;
//
//     }
// }
//
// svg.curved-divider.curved-top-left, svg.curved-divider.curved-top-right {
//     position: absolute;
//     top: 0;
// }
//
// #homeIntro svg.curved-divider.curved-top-left{
//     top: 0;
// }
//
// .separator-wrapper {
//     overflow: hidden;
//     position: relative;
//     z-index:0;
//     width: 100%;
// }
//
// svg.diagonal-left, svg.diagonal-right  {
//     position: relative;
//     top: 6px;
// }
//
// section.right-diagonal-cutter::before {
//     top: 0;
//     left: -25%;
//     z-index: -1;
//     width: 150%;
//     height: 75%;
//     background: inherit;
//     -webkit-transform: rotate(-2deg);
//     -ms-transform: rotate(-2deg);
//     transform: rotate(-2deg);
//     -webkit-transform-origin: 0 0;
//     transform-origin: 0 0;
//     position: absolute;
//     content: '';
//     pointer-events: none;
// }
//
// section.left-diagonal-cutter::before {
//     top: -20%;
//     left: -25%;
//     z-index: -1;
//     width: 150%;
//     height: 75%;
//     background-color: inherit;
//     -webkit-transform: rotate(-2deg);
//     -ms-transform: rotate(-2deg);
//     transform: rotate(2deg);
//     -webkit-transform-origin: 0 0;
//     transform-origin: 0 0;
//     position: absolute;
//     content: '';
//     pointer-events: none;
// }
//
// .sidenav ul.apto-login-register.mobile li a.btn {
//
//     border-radius: 25px;
//     box-shadow: none;
//
// }
//
// .files-marketplace-plugin footer.page-footer {
//     background-color: #384267!important;
//     padding-top: 80px!important;
// }
//
// .files-marketplace-plugin footer.page-footer h4 {
//     font-weight: 300;
//     font-size: 1.3rem;
//     margin-bottom: 15px;
// }
//
// .files-marketplace-plugin footer.page-footer .footer-widgets .menu li a {
//     color: #afb3c2;
//     margin-bottom: 7px;
//     display: inline-block;
//     font-size: 1rem;
//     outline: none;
// }
//
// .files-marketplace-plugin footer.page-footer .footer-widgets .menu li a:hover {
//     color: #61a9f6;
// }
//
// .files-marketplace-plugin footer .copyright-text {
//     margin-top: 0;
//     font-size: 0.9rem;
// }
//
// .files-marketplace-plugin footer .footer-widgets.flex .col {
//     width: 15%;
//     margin-left: 0;
// }
//
// .files-marketplace-plugin footer .footer-widgets.flex .col:nth-child(3) {
//     margin-left: 3%;
//     width: 20%;
// }
//
// .files-marketplace-plugin footer .footer-widgets.flex .col:last-child {
//     width: 25%;
//     margin-left: auto;
// }
//
// .files-marketplace-plugin .footer-social {
//     margin-top:25px;
// }
//
// .files-marketplace-plugin .footer-social li {
//     margin-right: 10px;
//     display: inline-block;
// }
//
// .files-marketplace-plugin .footer-social li a {
//     display: inline-block;
//     background-color: #2b385c;
//     width: 42px;
//     height: 42px;
//     line-height: 42px;
//     text-align: center;
//     border-radius: 50%;
//     color: #fff;
//     -webkit-transition:0.2s ease-in;
//     -o-transition:0.2s ease-in;
//     -moz-transition:0.2s ease-in;
//     transition:0.2s ease-in;
// }
//
// .files-marketplace-plugin .footer-social li:hover a {
//     -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
// .files-marketplace-plugin .footer-social li a, .files-marketplace-plugin .footer-social li i {
//     color:inherit;
// }
//
// @media screen and (max-width: 600px) {
//
//     .files-marketplace-plugin footer.page-footer {
//         padding-top: 20px !important;
//     }
//
//     .files-marketplace-plugin footer .footer-widgets.flex .col {
//         width: 100% !important;
//         margin-left: 0 !important;
//     }
//
//     .files-marketplace-plugin footer.page-footer h4 {
//         margin-bottom: 10px;
//     }
//
//     .files-marketplace-plugin .footer-social {
//         margin-top: 15px;
//     }
//
//     .files-marketplace-plugin .footer-social li a {
//         width: 50px;
//         height: 50px;
//         line-height: 50px;
//     }
//
// }
//
// header nav {
//     background-color: #fff;
//     color: #505f79;
// }
//
// header nav ul a {
//     color:inherit;
//     padding: 0 15px;
//     font-size: 0.9rem;
// }
//
// header nav ul a:hover, header nav ul li.active {
//     background-color: rgb(229, 236, 255);
// }
//
// header nav .actions li {
//     margin-left: 10px;
// }
//
// header #profileMenu {
//     top: 64px !important;
// }
//
// header #profileMenu li:not(.divider) {
// min-height:40px;
// }
//
// header #profileMenu.dropdown-content li > a, header #profileMenu.dropdown-content li > span {
//     color: #000 !important;
//     font-size: 0.9rem;
//     padding: 10px;
// }
//
// header #profileMenu.dropdown-content li > a > i {
//     width:20px;
// }
//
// header .sidenav .user-view .background {
//     background: linear-gradient(#475ba1 50%, #5264a9);
// }
//
// header .sidenav .user-view .background img {
//     display:none;
// }
//
// header .sidenav .user-view .apto-credits-menu .credits-item {
//     margin-right:0;
// }
//
// .files-marketplace-plugin header nav .sidenav-trigger {
//     border-left: 1px solid #e7ecfe;
//     color: #3c5ea5;
//     float: right;
// }
//
// .files-marketplace-plugin header nav .mobile-additional-menu {
//     font-weight: 700;
//     color: #4558ae;
//     height: 100%;
// }
//
// .files-marketplace-plugin header nav .mobile-additional-menu li {
//     border-left: 1px solid #e7ecfe;
//     height: 100%;
//     line-height: 53px;
//     overflow: hidden;
// }
//
// .files-marketplace-plugin header nav .mobile-additional-menu svg {
//
//     width: auto;
//     height: 25px;
//     display: inline-block;
//     vertical-align: middle;
//     fill: #435db0;
//
// }
//
//
// @media screen and (max-width: 1200px) {
//
//     header nav {
//         padding: 0 0 0 15px;
//     }
//
//     header nav ul a {
//         padding: 0 15px;
//         height: 100%;
//         line-height: 64px;
//     }
//
// }
//
// @media screen and (max-width: 990px) {
//     header nav {
//         padding: 0;
//     }
//
//     header nav .brand-logo img {
//         padding: 8px 0 4px!important;
//     }
//
// }
//
// @media screen and (max-width: 600px) {
//
//     header nav ul a {
//         line-height: 53px;
//     }
//
// }
//
// .btn-primary {
//     outline: none !important;
//     height: 50px;
//     line-height: 48px;
//     padding: 0 40px;
//     border-radius: 30px;
//     margin-top: 10px;
//     border: 1px solid #61a9f6;
//     -webkit-transition: 0.2s ease;
//     -o-transition:0.2s ease;
//     -moz-transition:0.2s ease;
//     transition: 0.2s ease;
//     display: inline-block;
//     cursor: pointer;
//     text-align: center;
// }
//
// .btn-primary:hover {
//     -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
// }
//
// @media screen and (max-width: 600px) {
//
//     .card .btn-primary {
//         width: 100%;
//         height: 50px;
//         line-height: 46px;
//         font-size: 1rem;
//     }
//
//     #save-btn {
//         width:100%!important;
//     }
//
// }
//
// @media screen and (max-width: 400px) {
//     .btn-primary {
//         padding: 0 20px;
//         font-size:1rem!important;
//     }
// }
//
// .btn-primary.with-icon {
//     padding-right:5px;
//     min-width: 190px;
// }
//
// .btn-primary.with-icon i {
//     float: right !important;
//     height: 42px;
//     line-height: 42px;
//     width: 42px;
//     background-color: #4798ed;
//     border-radius: 50%;
//     margin-top: 3px;
//     text-align: center;
//     -webkit-transition: 0.2s ease;
//     -o-transition:0.2s ease;
//     -moz-transition:0.2s ease;
//     transition: 0.2s ease;
// }
//
// .btn-primary.with-icon:hover i {
//     -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     -webkit-transform: translate3d(15px,0,0);
//     -ms-transform: translate3d(15px,0,0);
//     transform: translate3d(15px,0,0);
// }
//
// .btn-primary.apto-orange.with-icon i {
//     background-color: #ffab00;
// }
//
// .btn-primary.apto-purple.with-icon i {
//     background-color: #6c7ec4;
// }
//
// @media screen and (max-width: 900px) {
//     .btn-primary.with-icon {
//         padding-left:42px;
//     }
//     .btn-primary.with-icon i {
//         margin-left:0;
//     }
// }
//
// @media screen and (max-width: 440px) {
//     .btn-primary.with-icon {
//         padding:0!important;
//     }
//     .btn-primary.with-icon i {
//         display:none;
//     }
// }
//
// .btn-primary.apto-blue {
//     background-color:#61a9f6;
//     color:#fff;
// }
//
// .btn-primary.apto-blue:hover {
//     background-color: #4798ed;
// }
//
// .btn-primary.apto-orange {
//     background: -webkit-gradient(linear, left top, left bottom, from(#ffa421), to(#fd7b49));
//     background: -o-linear-gradient(right, #ffa421, #fd7b49);
//     background: linear-gradient(#ffa421, #fd7b49);
//     border-color: #ff9e27;
//     color: #fff;
// }
//
// .btn-primary.apto-purple {
//     background: -webkit-gradient(linear, left top, left bottom, from(#596bae), to(#5264a9));
//     background: -o-linear-gradient(right, #596bae, #5264a9);
//     background: linear-gradient(#596bae, #5264a9);
//     border-color: #5264a9;
//     color: #fff;
// }
//
// .btn-primary.btn-transparent {
//     background:transparent;
//     color:#fff;
//     border-color:#fff;
// }
//
// .card .btn-primary.btn-transparent {
//     border: 1px solid #61a9f6;
//     color: #61a9f6;
// }
//
// .btn-primary.btn-transparent.btn-hover-orange:hover {
//     background: linear-gradient(#ffa421, #fd7b49);
//     border-color: #ff9e27 !important;
//     color: #fff !important;
// }
//
// .card .btn-primary.btn-transparent.with-icon i {
//     background-color:#e5ecff;
//     color: #61a9f6;
// }
//
// .card .btn-primary.btn-transparent.with-icon:hover {
//     background-color: #4798ed;
//     color:#fff;
// }
//
// .card .btn-primary.btn-transparent.with-icon:hover i {
//     background-color:#61a9f6;
//     color:#fff;
// }
//
// body header nav .apto-login-register .btn {
//     border-radius: 25px;
//     padding: 0 35px;
//     border: 1px solid #61a9f6;
//     margin: -2px 5px 0;
//     font-weight: 700;
//     font-size: 11px !important;
//     height: 35px;
//     line-height: 34px;
//     box-shadow: none;
//     -webkit-transition: 0.2s ease;
//     -o-transition: 0.2s ease;
//     -moz-transition: 0.2s ease;
//     transition: 0.2s ease;
// }
//
// body header nav .btn.btn-medium.btn-secondary.btn-login {
//
//     background: linear-gradient(to right, #61a9f6, #559ce8);
//
// }
//
// header nav .apto-login-register .btn:hover {
//     -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
// header nav .apto-login-register .btn.btn-register {
//     background-color: transparent !important;
//     color:#61a9f6;
// }
//
// header nav .apto-login-register.btn-login, header nav .apto-login-register .btn-register:hover {
//     background-color: #61a9f6!important;
//     color:#fff;
// }
//
// // section {
// //     position: relative;
// //     padding: 80px 0 0;
// // }
//
// .section-content {
//     position: relative;
//     z-index: 1;
// }
//
// .section-title {
//     color: #fff;
//     font-weight: 800;
//     margin-bottom:15px;
//     font-size: 2.2rem;
//     font-family: 'Arial Black', 'Arial Bold', Gadget, sans-serif;
// }
//
// @media only screen and (max-width: 600px) {
//
//     .section-title {
//         font-size: 1.6rem !important;
//         line-height: 2rem !important;
//         margin-bottom: 5px !important;
//     }
// }
//
// .section-title.dark-color.try-title {
//     font-weight: 400;
//     font-family: inherit;
// }
//
// .section-description {
//     max-width: 100%;
//     width: 60%;
//     display: block;
//     margin: 0 auto;
// }
//
// @media only screen and (max-width: 600px) {
//     .section-description {
//         width:100%!important;
//     }
// }
//
// h1.section-title.light-color {
//     font-size: 2.2rem;
//     line-height: 3rem;
//     margin: 1.52rem 0 0.912rem 0;
// }
//
// .section-title.light-text {
//     font-weight: 400;
// }
//
// .section-title.light-color {
//     color: #deebff;
// }
//
// .section-title.dark-color {
//     color: #7e87a6;
// }
//
// .section-paragraph {
//     color: #d7dbeb;
//     font-size: 1.08rem;
// }
//
// .section-paragraph.dark-color {
//     color: #808ba1;
//     line-height: 2rem;
// }
//
// .section-btns-wrapper {
//     margin-top:30px;
// }
//
// .section-btns-wrapper .btn-primary {
//     margin: 0 5px 0 0;
// }
//
// #solutionIllustration {
//     margin-top: 60px;
// }
//
// #lawFirms {
//     padding: 0 0 100px;
//     background: -webkit-gradient(linear, left top, left bottom, from(#eef3ff), to(#dde5ff));
//     background: -o-linear-gradient(right, #eef3ff, #dde5ff);
//     background: linear-gradient(#eef3ff 50%, #dde5ff);
// }
//
// #lawFirms .separator-wrapper {
//     height: 100px;
//     background-color: #dde5ff;
// }
//
// #lawFirms .separator-wrapper svg {
//     top: 0;
// }
//
// #lawFirms .section-content {
//     margin-top: -30px;
// }
//
// .law-firms-wrapper {
//     margin-top: 30px;
//     text-align:center;
// }
//
// #lawFirmsPage #pageCardContent .law-firms-wrapper {
//     position: relative;
//     z-index: 1;
// }
//
// .law-firm-item {
//     display: block !important;
//     background: -webkit-gradient(linear, left top, left bottom, from(#6db1fa), to(#529ef0));
//     background: -o-linear-gradient(right, #6db1fa, #529ef0);
//     background: linear-gradient(#6db1fa 50%, #529ef0);
//     color: #edfbfc;
//     margin: 12px auto;
//     padding: 15px;
//     border-radius: 35px;
//     font-size: 1.1rem;
//     -webkit-transition: 0.2s ease;
//     -o-transition: 0.2s ease;
//     -moz-transition: 0.2s ease;
//     transition: 0.2s ease;
//     outline: none;
// }
//
// .law-firm-item:hover {
//     -webkit-transform: scale(1.04);
//     -ms-transform: scale(1.04);
//     transform: scale(1.04);
//     -webkit-box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
//     box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
// }
//
// #viewAllLawFirms {
//     border-color: #7e87a6;
//     color: #7e87a6;
//     width: 100%;
//     margin-top: 35px;
// }
//
// #pricing {
//     background-color: #f6f6f8;
//     padding-bottom: 0;
//     padding-top:10px;
// }
//
// #pricing .credits-ways {
//     max-width: 900px;
// }
//
// .pricing-table {
//     margin-top: 35px;
//     margin-bottom:45px;
// }
//
// .card.pricing-item {
//     max-width:100%;
//     opacity: 1;
//     border-radius: 15px !important;
//     overflow: hidden;
//     margin: 10px auto !important;
//     padding: 0 !important;
//     text-align: center;
//     cursor: pointer;
//     -webkit-transition: 0.2s ease;
//     -o-transition:0.2s ease;
//     -moz-transition:0.2s ease;
//     transition: 0.2s ease;
//     width: 240px;
//     -webkit-box-shadow: 0 2px 59px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 2px 59px 0 rgba(126, 136, 172, 0.44);
// }
//
// @media only screen and (max-width: 900px) {
//
//     #pricing .card.pricing-item {
//         height: auto !important;
//     }
//
// }
//
// .card.pricing-item.inactive {
//     opacity: 0.5;
// }
//
// .pricing-head {
//     background: linear-gradient(#475ba1 50%, #43579e);
//     padding: 23px 15px;
//     color: #deebff;
//     -webkit-transition: 0.2s ease;
//     -o-transition:0.2s ease;
//     -moz-transition:0.2s ease;
//     transition: 0.2s ease;
// }
//
// .card.pricing-item:hover  {
//     -webkit-box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
//     box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
// }
//
// .card.pricing-item:hover .pricing-head {
//     background: linear-gradient(#475ba1 50%, #5a6caf);
// }
//
// .card.pricing-item:hover .pricing-cost {
//     color: #ffab00;
// }
//
// .pricing-name {
//     font-size: 1rem;
//     margin: 10px 0 5px;
//     font-weight: 200;
// }
//
// .pricing-cost {
//     font-weight: 700;
//     font-size: 2rem;
//     margin: 0 0 5px;
//     -webkit-transition: 0.2s ease;
//     -o-transition:0.2s ease;
//     -moz-transition:0.2s ease;
//     transition: 0.2s ease;
// }
//
// .pricing-content {
//     color: #505f79;
//     padding: 15px;
// }
//
// .pricing-benefits {
//     margin-top: 0;
//     margin-bottom: 10px;
// }
//
// .pricing-benefits li {
//     margin: 5px 0;
//     font-size: 0.95rem;
// }
//
// @media only screen and (max-width: 600px) {
//
//     .pricing-benefits li {
//         font-size:1rem;
//     }
//
//     .card.pricing-item {
//         width: 300px;
//         height: calc(100% - 30px) !important;
//         margin-bottom: 30px !important;
//         box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44);
//     }
//
//     .pricing-table {
//         margin: 15px 0 0;
//     }
//
//     .center.payment-paragraph.after-pricing.col.s12 {
//         margin-top: 10px!important;
//         font-size: 1rem;
//     }
//
// }
//
// #tryFreeTitle {
//     margin: 55px 0 10px;
//     display: block;
//     padding-top: 0;
//
// }
//
// #tryFreeParagraph {
//     margin-bottom:35px;
// }
//
//
// #registerCTA {
//     padding:0;
//     background-color: #5a6caf;
//     position: relative;
// }
//
// #registerCTA::before {
//     background-color: #5062a7;
// }
//
// #registerCTA .separator-wrapper {
//     height:110px;
// }
//
// #registerCTA .curved-divider.curved-bottom-left path {
//     fill: #5062a7;
// }
//
// #registerCTA .curved-divider.curved-top-left path {
//     fill: #5466aa;
// }
//
// #registerCTA .section-content {
//     margin-top: -95px;
// }
//
// #registerCTA .section-paragraph {
//
//     margin: 0 auto;
//
// }
//
// #whatWeDo {
//
//     padding: 0;
//
// }
//
// #whatWeDo .svg-illustration-wrapper svg {
//
//     max-width:100%;
// }
//
// #illustration2 {
//
//     max-width: 490px;
//     margin-left: 10%;
//
// }
//
// #whatWeDo .separator-wrapper {
//
//     height: 100px;
//
// }
//
// #whatWeDo .separator-wrapper:last-child {
//
//     height: 100px;
//
// }
//
// #whatWeDo .separator-wrapper path {
//     fill:#e6ecff;
// }
//
// #whatWeDo .section-content {
//
//     margin-bottom: 20px;
//
// }
//
// #whatWeDo .section-title.dark-color.animateItem {
//
//     margin-top: 5px!important;
//
// }
//
// #homeIntro {
//     padding: 0;
//     background-color: #5c6eb0;
// }
//
// #homeIntro .separator-wrapper:first-child {
//
//     height: 120px;
//
// }
//
// #homeIntro .separator-wrapper:last-child {
//
//     height: 170px;
//
// }
//
// #homeIntro .section-paragraph {
//
//     max-width: 500px;
//
// }
//
// #illustration1 {
//
//     height: 617px;
//
// }
//
// /*#homeIntro .svg-illustration-wrapper svg {*/
//
// /*    width: 75% !important;*/
// /*    display: block;*/
// /*    top: 25px;*/
// /*    max-width: 450px !important;*/
// /*}*/
//
// #homeIntro .svg-illustration-wrapper svg {
//
//     display: block;
//     top: -95px;
//     margin-left: -12%;
//     width: 110% !important;
//
// }
//
// #filler {
//     background-color: #5264a9;
//     padding: 0;
// }
//
// #uploadApplication #filler svg {
//
//     fill: #fff;
//
// }
//
// #lawFirmsPage #pageHeader .separator-wrapper.separator-bottom {
//     height:160px;
// }
//
//
// @media only screen and (max-width: 1440px) {
//
//     .diagonal-separator.before-what-we-do {
//
//         margin-top: -90px;
//
//     }
//
//     #whatWeDo .separator-wrapper:last-child {
//
//         height: 140px;
//
//     }
//
// }
//
// @media only screen and (max-width: 1300px) {
//
//     #lawFirmsPage #pageHeader .separator-wrapper.separator-bottom {
//         height:130px;
//     }
//
// }
//
// @media only screen and (max-width: 700px) {
//
//     #lawFirmsPage #pageHeader .separator-wrapper.separator-top {
//
//         height: 80px;
//
//     }
//
//     #lawFirmsPage #pageHeader .separator-wrapper.separator-bottom {
//
//         height: 90px;
//
//     }
//
// }
//
//
// @media only screen and (max-width: 460px) {
//
//     #lawFirmsPage #pageHeader .separator-wrapper {
//         height: 40px !important;
//     }
//
// }
//
// #lawFirmsPage .diagonal-separator:before {
//     background: #e7ecfe;
// }
//
// #lawFirmsPage #prePageContent {
//     padding: 25px 0 5px;
// }
//
// #lawFirmsPage #prePageContent .section-paragraph.dark-color {
//
//     width: 90%;
//     text-align: center;
//     margin: 0 auto;
//     display:block;
// }
//
// #lawFirmsPage #pageCardContent {
//
//     padding-bottom: 0;
//
// }
//
// #homeIntro .section-content {
//
//     margin-top: -60px;
//     margin-bottom: -240px;
//
// }
//
// @media screen and (max-width: 900px) {
//     #homeIntro .section-title br {
//         display:none;
//     }
// }
//
//
//
// #homeIntro .curved-top-left path {
//     fill:#5264a9;
//
// }
// #homeIntro .curved-bottom-left path {
//     fill:#6a7aba;
//
// }
//
// #homeIntro .section-title {
//     color:#fff;
//     line-height: 2.5rem;
//     margin-top:70px;
//     font-size: 1.9rem;
// }
//
// #pageHeader {
//     padding: 0;
//     background-color: #596bae;
// }
//
// #pageHeader .curved-bottom-left path {
//     fill: #5568ab;
// }
//
// #pageHeader .curved-top-left path {
//     fill: #5264a9;
// }
//
// #pageHeader .separator-wrapper.separator-top {
//     height: 100px;
// }
//
// #pageHeader .separator-wrapper.separator-bottom {
//     height: 100px;
// }
//
// .error404 #pageHeader .separator-wrapper {
//     height: 164px !important;
// }
//
// #pageHeader .section-content {
//
//
// }
//
// @media only screen and (max-width: 600px) {
//     #pageHeader .section-content {
//
//         padding-bottom: 20px;
//
//     }
// }
//
// .taxonomy-law-firm.apto-page.row h1.section-title.light-color.law-firm-name {
//     font-size: 3rem;
//     margin-top: 0;
// }
//
// .taxonomy-law-firm #filler svg {
//     margin-top: -30px;
// }
//
// .taxonomy-law-firm #whatWeDo .section-content {
//     margin-top: 0;
// }
//
// .taxonomy-law-firm #whatWeDo .center.section-paragraph.dark-color {
//     font-size: 1rem;
//     margin-bottom: 30px;
// }
//
// .taxonomy-law-firm #pageHeader .separator-wrapper.separator-bottom {
//     height: 160px;
// }
//
// .taxonomy-law-firm #whatWeDo .separator-wrapper {
//     height: 110px;
// }
//
// body .collapsible {
//     border: 0;
//     box-shadow: none;
// }
//
// body .collapsible li {
//     border-radius: 4px;
//     margin-bottom: 20px;
//     -webkit-transition:0.3s ease-in;
//     -o-transition: 0.3s ease-in;
//     -moz-transition: 0.3s ease-in;
//     transition:0.3s ease-in;
//     -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
// }
//
// body .collapsible li:hover {
//     -webkit-box-shadow: 0 24px 38px 3px rgba(0,0,0,0.14),0 9px 46px 8px rgba(0,0,0,0.12),0 11px 15px -7px rgba(0,0,0,0.2);
//     box-shadow: 0 24px 38px 3px rgba(0,0,0,0.14),0 9px 46px 8px rgba(0,0,0,0.12),0 11px 15px -7px rgba(0,0,0,0.2);
// }
//
// body .collapsible-header {
//     border: 0;
//     background: linear-gradient(to right,#4d9bee, #6db1fa);
//     color: #fff;
//     padding: 20px 25px;
//     display: block;
//     height: 80px;
// }
//
// #faqPage .collapsible-header {
//     padding: 20px 15px !important;
//     font-weight: 400;
//     font-size: 14px;
//     height: 60px;
//     line-height: 20px;
// }
//
// body .collapsible-body {
//     background-color: #e4effe;
//     border-radius: 4px;
// }
//
// @media screen and (max-width: 990px) {
//
//     body .collapsible-body {
//         padding: 15px 20px 20px;
//     }
//
//     body .collapsible-header {
//         padding: 13px 18px;
//         height: 70px;
//     }
//
// }
//
// @media screen and (max-width: 600px) {
//
//     .questions-wrapper .collapsible .collapsible-header {
//
//         height: auto !important;
//         line-height: 1.6rem !important;
//         font-weight: 400 !important;
//         font-size: 1rem !important;
//         min-height: 50px;
//
//     }
//
// }
//
// body .collapsible-header .rating {
//     margin-left: 25px;
// }
//
// .rating {
//     border: none;
//     float: left;
// }
//
// .rating > input { display: none; }
// .rating > label:before {
//     margin: 5px;
//     font-size: 1.25em;
//     font-family: "Font Awesome 5 Free",serif;
//     display: inline-block;
//     content: "\\f005";
// }
//
// .rating > .half:before {
//     content: "\\f005";
//     position: absolute;
//     font-weight: 900;
// }
//
// .rating > label {
//     color: #457dbe;
//     float: right;
// }
//
// /***** CSS Magic to Highlight Stars on Hover *****/
//
// .rating > input:checked ~ label, /* show gold star when clicked */
// .rating:not(:checked) > label:hover, /* hover current star */
// .rating:not(:checked) > label:hover ~ label { color: #ffe380;  } /* hover previous stars in list */
//
// .rating > input:checked + label:hover, /* hover current star when changing rating */
// .rating > input:checked ~ label:hover,
// .rating > label:hover ~ input:checked ~ label, /* lighten current selection */
// .rating > input:checked ~ label:hover ~ label { color: #ffe380;  }
//
// .application-item-title {
//     display: inline-block;
//     line-height: 42px;
//     font-size: 1rem;
// }
//
// .application-item-views {
//     font-weight: 700;
//     line-height: 42px;
//     float:right;
// }
//
// @media only screen and (max-width: 440px) {
//
//     #access-btn {
//         width: 100%;
//     }
//
//     .row.law-firm-item-stats .col:first-child {
//         color: #7e87a6;
//     }
//
//     .row.law-firm-item-stats {
//
//         margin-bottom: 12px;
//
//     }
// }
//
// .collapsible-header i.right {
//     margin-right: 0;
//     text-align: right;
//     display: inline-block;
//     float: right !important;
//     line-height: 42px;
//     font-size: 1.2rem;
//     width: auto;
// }
//
// .section-title.law-firm-fact-title {
//     margin-bottom: 15px;
//     margin-top: 0;
//     font-size: 2rem;
// }
//
// .law-firm-how-to {
//     color: #505f79;
//     text-align: center;
//     margin-bottom: 35px;
//     margin-top: 0;
// }
//
// .law-firm-facts.card {
//     font-size: 14px;
//     border-radius: 10px;
//     padding: 30px 25px 15px;
//     background: linear-gradient(to top,#fff, #e6ecff);
//     margin-top: -3px;
//     -webkit-box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
// }
//
// .row.laf-firm-fact {
//     color: #505f79;
//     margin-bottom: 12px;
// }
//
// .row.laf-firm-fact.sub-fact .col:first-child,
// .sub-fact .info-key {
//
//     opacity: 0.8;
//     padding-left: 30px;
//
// }
//
// .row.laf-firm-fact strong {
//
//     font-weight: 700;
//     color: #505f79;
//     text-align: right !important;
//     float: right;
// }
//
//
// @media screen and (max-width: 600px) {
//
//     .row.laf-firm-fact strong {
//         text-align: left !important;
//         float: left;
//     }
//
//     .row.laf-firm-fact.sub-fact .col:first-child {
//         padding-left: 0.75rem;
//     }
//
//     .row.laf-firm-fact {
//         margin-bottom: 10px;
//     }
//
//     .law-firm-facts.card {
//         font-size: 1rem;
//         border-radius: 10px;
//         padding: 20px 25px 15px;
//         background: #e6ecff;
//         margin-top: 0;
//         -webkit-box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44);
//         box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44);
//     }
//
// }
//
// .tab-content .card {
//     border-radius: 0 0 10px 10px;
//     padding: 15px 30px 35px;
//     color: #747f94;
//     line-height: 1.9rem;
//     font-size: 1.1rem;
//     margin-top: 0;
// }
//
// section .tabs {
//     background-color: #eaf0ff;
// }
//
// section .tabs , section .tabs .tab {
//     height:55px;
//     line-height: 55px;
//     border-radius: 10px 10px 0 0;
// }
//
// section .tabs .tab a, section .tabs .tab a:hover {
//     color: #2b3858;
//     font-size: 1.05rem;
// }
//
// section .tabs .tab a.active, section .tabs .tab a:focus {
//     background-color: #509def !important;
//     color: #fff;
// }
//
// section .tabs .indicator {
//     display:none;
// }
//
// #lawFirmDetails .section-title {
//     margin-bottom: 40px;
// }
//
// #lawFirmDetails {
//     padding: 60px 0 60px;
// }
//
// #lawFirmDetails h4 {
//
//     font-size: 1.8rem;
//
// }
//
// #pageCardContent {
//     padding: 0 0 60px;
//     background-color: #e7ecfe;
// }
//
//
// @media only screen and (max-width: 600px) {
//     #pageCardContent {
//         padding: 0 0 10px;
//     }
// }
//
// #pageCardContent .separator-wrapper {
//
//     height: 120px;
//
// }
//
//
// @media only screen and (max-width: 990px) {
//
//     #pageCardContent .separator-wrapper {
//
//         height: 90px;
//
//     }
// }
//
// @media only screen and (max-width: 600px) {
//     .section-title.law-firm-fact-title {
//         margin-top:10px;
//     }
//
//     .law-firm-how-to {
//         margin-bottom:15px;
//     }
// }
//
//
// @media only screen and (max-width: 600px) {
//
//     #pageCardContent > .separator-wrapper.separator-bottom {
//
//         display: none;
//
//     }
// }
//
// .register.apto-page.row #filler svg {
//
//     fill: #fff;
//
// }
// #pageCardContent svg {
//     fill:#fff;
// }
//
// #pageCardContent > .container > .col.s12 > .card {
//     border-radius: 30px;
//     padding: 45px 35px;
//     position: relative;
//     margin-top: -300px;
//     overflow:hidden;
// }
//
// @media screen and (max-width: 1300px) {
//
//     #pageCardContent > .container > .col.s12 > .card{
//         margin-top: -250px;
//     }
//
// }
//
//
// @media screen and (max-width: 990px) {
//
//     #pageCardContent > .container > .col.s12 > .card {
//         margin-top: -200px;
//     }
//
// }
//
//
// @media screen and (max-width: 600px) {
//
//     #pageCardContent > .container > .col.s12 > .card {
//         margin-top: -175px;
//     }
//
//     .register.apto-page.row #pageCardContent > .container > .col.s12 > .card {
//         padding: 30px 15px;
//     }
//
//     .register.apto-page.row .container {
//         width: 100% !important;
//     }
//
// }
//
// @media screen and (max-width: 600px) {
//
//     #pageCardContent > .container > .col.s12 > .card {
//         margin-top: -150px;
//         padding: 30px 15px;
//         border-radius: 15px;
//         margin-bottom: 30px;
//     }
//
// }
//
// @media screen and (max-width: 400px) {
//
//     .congrapps-page-template #pageCardContent .container > .col.s12 > .card {
//
//         padding: 35px 7%;
//
//     }
//
// }
//
// #pageCardContent .card h5 {
//
//     color: #505f79;
//     font-weight: 700;
//     font-size: 1.4rem;
//     margin-bottom: 0;
// }
//
// // #pageCardContent .card .small-paragraph {
// //     color: #505f79;
// //     font-size: 1.1rem;
// //     margin-top: 10px;
// // }
//
// .register.apto-page.row #pageCardContent h5 {
//     margin-bottom: 30px;
// }
//
// #pageCardContent .tos-privacy {
//     margin-top: 25px;
//     -webkit-box-shadow: 0 2px 59px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 2px 59px 0 rgba(126, 136, 172, 0.44);
//     padding: 25px;
//     margin-bottom: 25px;
// }
//
// @media screen and (max-width: 600px) {
//
//     #pageCardContent .tos-privacy {
//         margin: 0 !important;
//         -webkit-box-shadow: none;
//         box-shadow: none;
//         padding: 0;
//     }
//
// }
//
//
// .tos-privacy label {
//     color: #505f79;
// }
//
// #pageCardContent .tos-privacy a {
//     color:#0f3d95;
// }
//
// #pageCardContent .tos-privacy p {
//     margin:5px 0;
// }
//
// #pageCardContent .preview-image {
//
//     width: 200px;
//     height: 200px;
//     background-color: #e5ecff;
//     border-radius: 50%;
//     display: block;
//     margin: 20px auto;
//     border: 1px solid #c2cce8;
//     overflow: hidden;
//
// }
//
// @media screen and (max-width: 600px) {
//     #pageCardContent .preview-image {
//         width: 120px;
//         height: 120px;
//         margin: 10px auto;
//     }
//
//     .register.apto-page.row #pageCardContent h5 {
//         margin-bottom: 15px;
//         margin-top: 0;
//     }
//
//     .register.apto-page.row #pageCardContent {
//         padding: 0;
//     }
//
// }
//
//
// #register-btn {
//     margin-top: 20px;
// }
//
//
// @media screen and (max-width: 600px) {
//
//     .col.s12.update-btn-wrapper {
//         padding: 0;
//     }
//
//     #register-btn {
//         margin-top: 0;
//     }
//
// }
//
// .login .container {
//     width: 60% !important;
// }
//
// .login #filler svg {
//     fill:#fff;
// }
//
// .login .separator-bottom svg path {
//     fill:#ecf1ff;
// }
//
// .login #pageCardContent {
//     padding:0;
// }
//
//
// .login .separator-wrapper.separator-top {
//     height: 160px;
//     padding-top: 35px;
// }
//
// #login-btn {
//     margin: 30px 0;
//     width: 300px;
//     max-width:100%;
// }
//
// .login #pageCardContent .card {
//     margin-top:-280px;
// }
//
// @media screen and (max-width: 600px) {
//
//     .login .container {
//         width: 100% !important;
//     }
//
//     #login-btn {
//         margin: 5px 0;
//     }
//
//     .login-form-wrapper .input-field.col.s12 {
//         padding: 0;
//     }
//
// }
//
// #save-btn {
//     font-weight: 700;
//     margin-top: 25px;
//     width: auto;
// }
//
//
// #uploadApplication .card .container {
//     width:80%!important;
// }
//
// @media screen and (max-width: 900px) {
//     #uploadApplication .card .container {
//         width:100%!important;
//     }
// }
//
// .btn {
//     background-color:#61a9f6!important;
// }
// // .input-field label {
// //
// //     color: #505f79!important;
// //     font-weight: 700;
// //     font-size: 1.3rem;
// //
// // }
// .input-field input:focus {
//     border-color: #61a9f6 !important;
// }
//
// .apto-page [type="checkbox"]:checked + span:not(.lever)::before {
//     border-right: 2px solid #505f79;
//     border-bottom: 2px solid #505f79;
//
// }
//
// .payment-paragraph {
//
//     color: #637890;
//     font-size: 1rem;
//
// }
//
// .payment-paragraph.after-pricing {
//     margin-top:50px;
//     color: #637890;
// }
//
// .payment-paragraph.after-pricing a {
//     font-weight:700;
// }
//
// .payment-paragraph.dependency-item {
//
//     color: #5264a9;
//     font-weight: 700;
//
// }
//
// .center.payment-paragraph.after-pricing.col.s12 {
//     margin-top: 0;
// }
//
// .payment #filler svg {
//
//     fill: #fff;
//
// }
//
// .payment #pageCardContent {
//
//     padding-bottom: 0;
//
// }
//
// .low-opacity {
//
//     opacity: 0.4;
//
// }
//
// .payment-details {
//     margin-top: 45px;
// }
//
// #pageHeader p {
//     color: #c0caee;
//     font-size: 1.1rem;
// }
//
// .btn-primary.apto-orange.message {
//     font-size: 1.2rem;
//     font-weight: 700;
// }
//
// .dropdown-content li > a, .dropdown-content li > span {
//     color: #505f79 !important;
// }
//
// .congrapps-page-template #filler svg {
//
//     fill: #fff;
//
// }
//
// .congrapps-page-template #pageCardContent {
//     padding:0;
// }
//
//
// @media screen and (max-width: 700px) {
//     .congrapps-page-template #pageCardContent .container {
//
//         width: 100% !important;
//
//     }
// }
//
// .congrapps-page-template #pageCardContent .separator-wrapper.separator-bottom {
//
//     height: 130px;
//
// }
//
// .modal.congrapps-modal.modal-with-separator {
//
//     padding: 0;
//
// }
//
// .modal.congrapps-modal.modal-with-separator .separator-wrapper {
//
//     height:100px!important;
//
// }
//
// .modal.congrapps-modal.modal-with-separator .separator-wrapper svg {
//     top:0;
//     bottom:auto;
//     fill: #e7ecfe;
// }
//
// .modal.congrapps-modal.modal-with-separator .svg-icon {
//
//     width: 90px;
//     display: block;
//     margin: -90px auto 20px auto;
//
// }
//
// .congrapps-modal.modal {
//
//     width: 500px;
//     top: 20% !important;
//     border-radius: 10px;
//     padding: 25px 20px;
//     max-width: 95%;
// }
//
// .congrapps-modal.modal .modal-intro {
//     color: #505f79;
//     margin-bottom: 20px;
//
// }
//
// @media screen and (max-width: 700px) {
//
//     .congrapps-modal.modal {
//         padding: 10px 0;
//     }
//
// }
//
// @media screen and (max-width: 600px) {
//
//     .congrapps-modal.modal {
//         padding: 20px 25px;
//         max-height: calc(100% - 85px);
//         top: 75px !important;
//     }
//
//     .congrapps-modal.modal .modal-intro {
//         margin-bottom:15px;
//     }
//
//     #newsletterSubscribeModal {
//         padding: 10px;
//         top: 20% !important;
//     }
//
// }
//
// @media screen and (max-width: 360px) {
//
//     .congrapps-modal.modal {
//         padding: 5px;
//     }
//
// }
//
// .congrapps-modal.modal.credits-modal {
//     width:700px;
// }
//
// .congrapps-modal.modal .row {
//
//     margin-bottom: 0;
//
// }
//
// .congrapps-modal h4 {
//     font-size: 20px;
//     font-weight: 700;
//     margin-bottom:10px;
// }
//
//
// .congrapps-modal .how-to {
//     color: #637890 !important;
//     margin: 0 0 15px;
//     border-bottom: 1px solid #e5ecff;
//     padding-bottom: 15px;
// }
//
// .congrapps-modal .btn-primary.btn-transparent {
//     border-color: #7e87a6;
//     color: #7e87a6;
//
// }
//
// #newsletterSubscribeModal.congrapps-modal .modal-intro {
//     margin-bottom: 20px;
// }
//
// #newsletterSubscribeModal.congrapps-modal .how-to {
//     margin-bottom: 0;
// }
//
// .subscribe-tos {
//
//     display: inline-block;
//     margin:5px 0 0;
//
// }
//
// .credits-name {
//
//     text-align: center;
//     font-size: 1.1rem;
//     color: #666;
//
// }
//
// .congrapps-modal .btn-primary {
//
//     width: 300px;
//     text-align: center;
//     font-weight: 700;
//     max-width: 100%;
//     margin: 10px auto;
//     display: block;
//
// }
//
// .congrapps-modal.modal.credits-modal .btn-primary{
//     width:auto;
// }
//
// @media screen and (max-width: 700px) {
//
//     .congrapps-modal.modal.credits-modal .btn-primary {
//         width: 100%;
//         padding-left: 15px;
//     }
//
// }
//
//
// @media screen and (max-width: 400px) {
//
//     .congrapps-modal.modal.credits-modal .btn-primary {
//
//         font-size: 13px !important;
//         height: 45px;
//         line-height: 42px;
//
//     }
//
// }
//
// .inline-btns-wrapper a {
//     margin: 10px 5px 0 5px;
// }
//
// .congrapps-modal.modal.credits-modal .btn-primary.btn-transparent {
//     color:#000;
//     border-color:#ddd;
// }
//
// .credit-item-option {
//     border-radius:10px;
//     -webkit-transition:0.3s ease-in;
//     -o-transition: 0.3s ease-in;
//     -moz-transition: 0.3s ease-in;
//     transition:0.3s ease-in;
//     padding-top: 15px !important;
//     padding-bottom: 15px !important;
// }
//
// .credit-item-option:hover {
//     background-color:#e6ecff;
//     -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
// }
//
// .credits-item {
//     display: block;
//     margin: 0 auto;
//     width: 70px;
//     height: 70px;
//     text-align: center;
//     line-height: 48px;
//     border-radius: 50%;
//     font-weight: 700;
//     font-size: 18px;
//     border: 11px solid #fff;
//     -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
// }
//
// @media screen and (max-width: 500px) {
//
//     .congrapps-modal.modal .credits-item {
//         width: 60px;
//         height: 60px;
//         line-height: 42px;
//         font-size: 1.4rem;
//         border: 8px solid #fff;
//     }
//
//     .congrapps-modal.modal .credits-name {
//         margin-top: 10px;
//         margin-bottom: 5px;
//     }
//
// }
//
// .credits-item.credits-application {
//     background-color: #E6E9ED;
//     border-color: #5D9CEC!important;
// }
//
// .credits-item.credits-law-firm {
//     background-color: #E6E9ED;
//     border-color: #ffab00!important;
// }
//
// .credit-item-option.disabled .credits-item {
//     border-color: #ddd !important;
//     color: #666!important;
//     box-shadow: none;
// }
//
// .credit-item-option.disabled {
//     box-shadow:none!Important;
// }
//
// .credit-item-option.disabled .btn-primary.with-icon {
//     background-color: #ddd;
//     border-color: #ddd;
//     color: #666;
// }
//
// .credit-item-option.disabled .btn-primary.with-icon i {
//     background-color:#e6e9ed;
// }
//
// .credit-item-option.disabled .btn-primary.with-icon.apto-blue:hover {
//     background-color: #61a9f6;
//     border-color: #61a9f6;
//     color: #fff;
// }
//
// .credit-item-option.disabled .btn-primary.with-icon.apto-blue:hover i {
//     background-color:#4798ed;
// }
//
// .credit-item-option.disabled .btn-primary.with-icon.apto-orange:hover {
//     background: linear-gradient(#ffa421, #fd7b49)!important;
//     border-color: #ff9e27;
//     color: #fff;
// }
//
// .credit-item-option.disabled .btn-primary.with-icon.apto-orange:hover i {
//     background-color:#ffab00;
// }
//
// .apto-credits-menu .credits-item {
//     box-shadow: none;
//     width: 20px;
//     height: 20px;
//     display: inline-block;
//     vertical-align: middle;
//     margin-right: 5px;
//     border:4px solid #fff;
//     margin-top: -3px;
// }
//
// .apto-credits-menu {
//     border-left: 1px solid #e5ecff;
// }
//
// .apto-credits-menu li {
//     padding: 0 10px;
// }
//
// .apto-credits-menu li.credits-label {
//     font-size: 0.9rem;
//     color: #666;
//     padding-right: 2px;
// }
//
// .apto-credits-menu li .unlimited-credits {
//     background-color: #e5ecff;
//     display: inline;
//     padding: 10px;
//     border-radius: 4px;
//     font-weight: 700;
//     color: #5264a9;
//     font-size: 0.9rem;
// }
//
// .apto-credits-menu.sidenav-element {
//     background-color: #e5ecff;
//     display: inline-block;
//     border-bottom: 1px solid #e5ecff;
//     padding: 15px 20px;
//     width: 100%;
//     position: relative;
//     margin-top: -15px;
//     margin-bottom: -15px;
//     top: -15px;
// }
//
// .apto-credits-menu.sidenav-element li {
//     padding: 0;
//     display: inline-block;
//     margin-right: 10px;
//     line-height: 20px;
// }
//
// .apto-credits-menu.sidenav-element li.credits-label {
//     color: #222;
// }
//
// .apto-credits-menu.sidenav-element li .unlimited-credits {
//     padding: 5px 18px;
//     background-color: #fff;
//     font-size: 14px;
//     border-radius: 4px;
//     -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
// body.files-marketplace-plugin .sidenav .user-view {
//     padding-top: 25px;
// }
//
// body .sidenav .user-view .separator-wrapper {
//     height: 70px;
//     width: calc(100% + 40px);
//     margin-left: -20px;
//     margin-bottom: -20px;
// }
//
// body .sidenav .user-view .separator-wrapper svg {
//     fill: #e5ecff;
//     bottom: 0;
//     top: auto;
// }
//
// .toast.success{
//     background-color:#4CAF50;
// }
//
// .toast.error{
//     background-color:#f44336;
// }
//
// .card.credit-meta-item input, .card.credit-meta-item select {
//     outline:none!important;
//     width: 100%;
//     text-align: center;
//     height: 40px;
//     line-height: 40px;
//     border: 0;
//     background: #eee;
//     box-shadow: none!important;
//     border-radius: 2px;
//     -webkit-transition:0.3s ease-in;
//     -o-transition: 0.3s ease-in;
//     -moz-transition: 0.3s ease-in;
//     transition:0.3s ease-in;
// }
//
// .card.credit-meta-item input:hover, .card.credit-meta-item select:hover,
// .card.credit-meta-item input:focus, .card.credit-meta-item select:focus {
//     background: #fff;
//     -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
// .card.credit-meta-item {
//     text-align:center;
//     background-color: #e6e9ed;
//     -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     padding: 25px;
//     border-radius: 15px;
// }
//
// .card.credit-meta-item:hover {
//
//     -webkit-box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44)!important;
//     box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44)!important;
//
// }
//
// @media only screen and (max-width: 600px) {
//
//     .card.credit-meta-item {
//         -webkit-box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44) !important;
//         box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44) !important;
//     }
//
// }
//
// @media screen and (max-width: 990px) {
//     .credits-ways .card.credit-meta-item {
//
//         margin-bottom: 40px !important;
//         height: calc(100% - 40px) !important;
//
//     }
// }
//
//
// @media screen and (max-width: 600px) {
//
//     .card.credit-meta-item {
//         height: auto !important;
//         margin-bottom: 40px;
//         box-shadow: none;
//     }
//
//     .credits-ways .card.credit-meta-item {
//         margin-bottom: 20px !important;
//         height: auto!important;
//     }
//
// }
//
// .card.credit-meta-item .credits-item {
//     margin-top: -45px;
//     margin-bottom: 6px;
// }
//
// .credits-item.expire-icon {
//     background-color: #5466aa;
//     color: #fff;
//     border-color: #5466aa!important;
//     font-size: 24px;
//     margin-bottom: 27px !important;
// }
//
// .credits-connected-icon .credits-item {
//     display: inline-block;
// }
//
// .credits-connected-icon .credits-item.credits-law-firm.credits-law-firm-counter {
//     margin-left: -30px;
// }
//
// @media screen and (max-width: 600px) {
//     .card.credit-meta-item .credits-item {
//
//         margin-top: -40px;
//         width: 75px;
//         height: 75px;
//         line-height: 54px;
//         border: 10px solid #000;
//         font-size: 1.5rem;
//
//     }
// }
//
// .card.credit-meta-item p {
//     color: #637890;
//     font-size: 14px;
//     margin-top: 10px;
// }
//
// .card.credit-meta-item h4 {
//     font-weight:700;
//     font-size: 1.1rem;
//     color: #37405e;
//     margin-top: 15px;
//     margin-bottom: 0;
// }
//
// .card.credit-meta-item .purchase-date {
//     font-weight: 200;
//     color: #666;
// }
//
// #accessedApplications {
//
//     text-align: center;
//     max-width: 1000px;
//     margin: 0 auto;
//
// }
//
// .accessed-content {
// }
//
// .not-accessed-yet p {
//
//     color: #637890;
//     margin: 5px 0;
//
// }
//
// .not-accessed-yet .btn-primary {
//     margin-top:15px;
//     margin-right: 15px;
//
// }
//
// @media screen and (max-width: 600px) {
//
//     .accessed-content {
//         margin-top: 0;
//         margin-bottom:30px;
//     }
//
//     .accessed-content:last-child {
//
//         margin-bottom: 0;
//
//     }
//
//     .accessed-content h3 {
//         margin-top:0;
//     }
//
//     .not-accessed-yet p {
//         font-size: 1.1rem;
//
//     }
//
// }
//
// #accordion .ui-accordion-header {
//     outline:none!important;
//     background-color: #fff;
//     padding: 20px;
//     cursor: pointer;
//     -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
// .card.admin-application-item h4 {
//     font-size: 1rem;
//     margin: 10px 0;
//     font-weight: 700;
//     color: #37405e;
// }
//
// .card.admin-application-item .btn-transparent {
//     margin-top:10px;
// }
//
// .accessed-applications {
//     margin-top:20px;
// }
//
// .row.accessed-applications.flex .col {
//
//     margin-left: 0 !important;
//     padding: 20px 0.8rem;
//
// }
//
//
// .card.admin-application-item {
//
//     background-color: #e7ecfe;
//     text-align: left;
//     border-radius: 10px;
//     padding: 30px 20px;
//     box-shadow: none;
//     border: 2px solid #e7ecfe;
//     margin: 0;
//
// }
//
// .accessed-content:not(.expired-content) .card.admin-application-item.expired-item {
//     border: 2px solid #ced3e6;
//     opacity: 0.6;
//
// }
//
// .card.admin-application-item:hover {
//     opacity:1!important;
//     border: 2px solid #e7ecfe;
//     -webkit-box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
//     box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
// }
//
//
//
// .card.admin-application-item .application-expiring-soon-label {
//     display: inline-block;
//     padding: 10px;
//     position: absolute;
//     top: -20px;
//     right: 12px;
//     background-color: #e5ecff;
//     font-weight: 700;
//     color: #5264a9;
//     border-radius: 10px;
//     -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     font-size: 13px;
// }
//
// .card.admin-application-item svg {
//
//     float: left;
//     max-width: 50px;
//     height: auto;
//     display: block;
//     margin: 0 20px 0 0;
//     position: absolute;
//     top: -21px;
//
// }
//
// .card.admin-application-item .application-expire-date {
//     color: #637890;
// }
//
// .card.admin-application-item .application-date-value {
//     color: #37405e;
//     text-align: right;
//     float: right;
// }
//
// .card.admin-application-item .col.s12.view-application-btn-wrapper {
//     padding: 0;
//     margin-top: 15px;
// }
//
// .card.admin-application-item .col.s12.view-application-info-wrapper {
//     padding: 0;
// }
//
// .card.admin-application-item .col.s12.view-application-btn-wrapper a {
//     width:100%;
// }
//
// #accordion .ui-accordion-header .dashicons.dashicons-arrow-down-alt2 {
//
//     float: right;
//
// }
//
// #accordion input {
//     border-radius:4px;
//     float: left;
//     background: #fff;
//     border: 0;
//     height: 40px;
//     line-height: 40px;
//     display: inline-block;
//     outline: none !important;
//     padding-left: 10px;
//     width: 100%;
//     margin: 15px 0;
//     -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
//
//
//
// /*
//  * Stripe Form style
//  */
//
// #paymentModal {
//     width: 600px;
//     max-height: 75%;
//     top: 15% !important;
//     padding-top: 0;
// }
//
// #paymentModal.modal.congrapps-modal.modal-with-separator .separator-wrapper {
//     margin-top: -30px;
// }
//
// #paymentModal.modal.congrapps-modal.modal-with-separator .separator-wrapper svg {
//
//     top: auto;
//     bottom: 0;
// }
//
// #card-element {
//     padding-bottom: 0;
//     background-color: #e5ecff;
//     font-weight: 700;
//     border: 2px solid #e5ecff;
//     border-radius: 35px;
//     color: #53596f;
//     font-size: 1rem;
//     height: 50px;
//     margin-top: -4px;
//     line-height: 50px;
//     padding-left: 25px;
//     width: 100%;
// }
//
// #card-element > div {
//     transform: translateY(4px);
// }
//
// #paymentModal .card-info-wrapper > label {
//     background-color: #e5ecff;
//     font-size: 1rem;
//     -webkit-transform: translateY(-25px) scale(0.8);
//     -ms-transform: translateY(-25px) scale(0.8);
//     transform: translateY(-25px) scale(0.8);
//
// }
//
// #paymentModal input[name="cardnumber"] {
//     font-size:1rem!important;
// }
//
// .secure-notice {
//     color: #637890;
//     text-align: center;
//     font-style: italic;
//     margin-top: 10px;
//     font-size: 13px;
// }
//
//
// @media only screen and (max-width: 600px) {
//
//     #paymentModal .btn-primary {
//         width:100%;
//     }
//
//     #paymentModal {
//         padding: 0;
//     }
//
//     #paymentModal.modal.congrapps-modal.modal-with-separator .separator-wrapper {
//         margin-top: -40px;
//     }
//
//     #paymentModal .modal-content {
//         padding: 24px 10px;
//     }
//
// }
//
// .collapsible.transactions {
//     margin-top: 35px;
// }
//
// body .collapsible.transactions li {
//     box-shadow: none;
// }
//
// body .collapsible.transactions li:hover {
//     -webkit-box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
// }
//
// body .collapsible.transactions .collapsible-header {
//     background: linear-gradient(to right,#e7ecfe, #e9edfd);
//     color: #37405e;
//     font-weight: 700;
// }
//
// body .collapsible.transactions .collapsible-header .transaction-amount {
//     color: #37405e;
// }
//
// body .collapsible.transactions .collapsible-header i.right {
//     color: #37405e;
// }
//
// body .collapsible.transactions .collapsible-header .transaction-plan {
//     color: #637890;
//     font-size: 14px;
//     font-weight: 400;
// }
//
// body .collapsible.transactions .collapsible-body {
//     background-color: #fff;
// }
//
// body .collapsible.transactions .collapsible-body .credit-brand {
//
//     display: inline-block;
//     margin-right: 5px;
//
// }
// body .collapsible.transactions .collapsible-body .credit-number {
//
//     display: inline-block;
// }
//
// body .collapsible.transactions .collapsible-body .credits-count {
//
//     margin-right: 5px;
//     font-weight: 700;
//
// }
//
// .collapsible.transactions .key {
//     color: #637890;
// }
//
// .collapsible.transactions .gift-item {
//
//     display: block;
//
// }
//
// @media screen and (max-width: 600px) {
//
//     body .collapsible.transactions .collapsible-header i.fas.fa-chevron-down.right{
//
//         font-size:1.2rem;
//
//     }
//
// }
// @media screen and (max-width: 990px) {
//
//     .collapsible.transactions .key {
//         margin-top:10px;
//     }
//
// }
//
// .transactions-page .how-to {
//     color:#637890;
// }
//
//
// .payment-result table.balance.striped {
//     width: 30%;
//     float: right;
//     margin-top: 20px;
// }
//
// .payment-result table tr th:last-child, .payment-result table tr td:last-child, .payment-result thead tr th:last-child {
//     text-align: right;
// }
//
// .modal.congrapps-modal.new-credits .separator-wrapper {
//     height: 100px;
// }
//
// .modal.congrapps-modal.new-credits {
//     padding:0;
// }
//
//
// .modal.congrapps-modal.new-credits .separator-wrapper svg {
//     top: 0;
// }
//
// .modal.congrapps-modal.new-credits .how-to {
//     border:0;
// }
//
// #newAppCreditsModal .separator-wrapper svg {
//     fill: #5d9cec;
//     opacity: 0.9;
// }
//
// #newLawCreditsModal .separator-wrapper svg {
//     fill: #ffab00 ;
//     opacity: 0.9;
// }
//
// .modal.congrapps-modal.new-credits .credits-item {
//     margin-top: -60px;
//     position: relative;
//     z-index: 2;
//     width: 90px;
//     height: 90px;
//     line-height: 62px;
//     border: 13px solid #000;
// }
//
// .modal.congrapps-modal.new-credits .btn-primary {
//     width: auto;
// }
//
// .accessed-content h3 {
//     font-size: 1.6rem;
//     font-weight: 700;
//     margin-bottom: 10px;
//     color: #37405e;
// }
//
// .accessed-content p {
//     border-bottom: 1px solid #e5ecff;
//     padding-bottom: 15px;
//     margin-top: 0;
//     color: #637890;
// }
//
// .not-accessed-yet p {
//
//     border: 0;
//     padding-bottom: 0;
//
// }
//
// .single-application .application-page {
//     padding:0 0 80px;
// }
//
// .single-application .separator-wrapper {
//     height: 180px;
// }
//
// @media screen and (max-width: 1300px) {
//
//     .single-application .separator-wrapper svg {
//         top: 0;
//     }
//
// }
//
// .single-application .separator-wrapper path {
//
//     fill: #e6ecff;
//
// }
//
// #applicatioSidebar {
//     margin-top: -80px;
//     padding: 0 15px 25px;
//     border-radius: 20px;
// }
//
// @media screen and (max-width: 990px) {
//
//     #applicationContent {
//         margin-top: -140px!important;
//     }
//
//     #applicatioSidebar {
//         margin-top:30px;
//     }
//
// }
//
// .single-application .application-info h2, .single-application .application-law-firm-information h3, .single-application #applicationReviews .comments-title {
//     color: #7e87a6;
//     font-weight: 700;
//     font-size: 1.4rem;
//     border-bottom: 1px solid #e5ecff;
//     padding-bottom: 20px;
//     margin-bottom: 15px;
// }
//
// .single-application .application-info-item {
//     font-size: 14px;
//     float: left;
//     width: 100%;
//     margin: 8px 0;
// }
//
// .single-application .application-info-item .info-value {
//
//     font-weight: 700;
//     text-align: right;
// }
//
// .more-law-firm {
//
//     border-top: 1px solid #e5ecff;
//     margin-top: 15px;
//     padding-top: 15px !important;
//
// }
//
// #applicationContent {
//     margin-top: -80px;
//     border-radius: 20px;
//     padding: 0 25px 25px;
//     position:relative;
// }
//
// #applicationContent .application-title {
//
//     font-size: 2rem;
//     font-weight: 700;
//     margin-bottom: 15px;
//
// }
//
// #applicationContent .application-content-wrapper {
//     position:relative;
//     font-size: 1.1rem;
//     line-height: 1.9rem;
//     -moz-user-select: none;
//     -webkit-user-select: none;
//     -ms-user-select: none;
//     user-select: none;
// }
//
// #applicationContent .application-content-wrapper.blur-hide {
//     -webkit-filter:blur(5px);
//     filter:blur(5px);
// }
//
// #applicationContent .disable-copy {
//     position:absolute;
//     top:0;
//     left:0;
//     height:100%;
//     width:100%;
// }
//
//
// #applicationContent .no-access-application-wrapper {
//
//     position: absolute;
//     width: 100%;
//     left: 0;
//     top: 30%;
//     z-index: 1;
//     text-align: center;
//     padding: 0 20%;
// }
//
// #applicationContent .no-access-application-wrapper h4 {
//     font-weight: 700;
// }
//
// #applicationContent .no-access-application-wrapper p {
//     color: #666;
//     font-size: 1.1rem;
// }
//
// @media screen and (max-width: 600px) {
//
//     .single-application .application-page .separator-wrapper {
//         display: none;
//     }
//
//     #applicationContent {
//         margin: 0 !important;
//         padding: 0 !important;
//         box-shadow: none !important;
//         border-bottom: 1px solid #e7ecfe;
//         border-radius: 0 !important;
//     }
//
//     .single-application .application-info-item .info-value {
//         text-align: left!important;
//     }
//
//     .single-application .application-info-item {
//         margin: 0 0 10px;
//     }
//
//     .single-application .application-info h2, .single-application .application-law-firm-information h3, .single-application #applicationReviews .comments-title {
//         padding-bottom: 15px;
//         margin-bottom: 15px;
//         margin-top: 15px;
//     }
//
//     #applicatioSidebar {
//         margin-top: 30px;
//         padding: 15px 15px 25px;
//     }
//
//     .single-application .application-page {
//         padding: 0 0 30px;
//     }
//
// }
//
// @media screen and (max-width: 400px) {
//
//     #applicationContent .no-access-application-wrapper {
//         top:160px;
//         padding: 0 20px;
//     }
//
//     #applicationContent .no-access-application-wrapper h4 {
//
//         font-weight: 700;
//         font-size: 1.6rem;
//
//     }
// }
//
// .views-rating-wrapper {
//
//     display: inline-block;
//     border-bottom: 1px solid #e5ecff;
//     padding-bottom: 10px;
//     width: 100%;
//
// }
//
// .apto-stars-rating {
//     display: inline-block;
//     font-size: inherit;
//     position: relative;
//     overflow: hidden;
//     float: left;
//     margin-right: 7px;
//     margin-top: -1px;
//
// }
//
// .apto-stars-rating-wrap {
//     display: inline-block;
//     position: relative;
//     height: 19px;
// }
//
// .apto-stars-rating .stars-active {
//     color: #FFAB00;
//     position: relative;
//     z-index: 10;
//     display: inline-block;
//     overflow: hidden;
//     white-space: nowrap;
// }
//
// .apto-stars-rating .stars-inactive {
//     color: #c4cadd;
//     position: absolute;
//     top: 0;
//     left: 0;
//     -webkit-text-stroke: initial;
//     /* overflow: hidden; */
// }
//
// .views-col {
//     padding-left: 10px;
//
// }
//
// .views-col span {
//
//     color: #7e87a6;
//
// }
//
//
// .comments-rating {
//     border: none;
//     padding: 0;
//     margin-left: 0;
// }
//
// .comments-rating label {
//     display: inline-block;
// }
//
// .rating-container {
//     /* remove inline-block whitespace */
//     font-size: 0;
//     /* flip the order so we can use the + and ~ combinators */
//     unicode-bidi: bidi-override;
//     direction: rtl;
// }
//
// .rating-container * {
//     font-size: 1.4rem;
// }
//
// .rating-container > input {
//     display: none;
// }
//
// .rating-container > input + label {
//
//     font-family: 'Font Awesome 5 Free', serif;
//     display: inline-block;
//     overflow: hidden;
//     text-indent: 9999px;
//     width: 20px;
//     white-space: nowrap;
//     cursor: pointer;
//     margin: 0 5px 0 0;
//     -webkit-transition:0.3s ease-in;
//     -o-transition: 0.3s ease-in;
//     -moz-transition: 0.3s ease-in;
//     transition: 0.3s ease-in;
//     font-size: 1.2rem;
//
// }
//
// .rating-container > input + label:before {
//     display: inline-block;
//     text-indent: -9999px;
//     content: "\\f005";
//     font-weight:700;
//     font-family: "Font Awesome 5 Free", serif;
//     color: #c4cadd;
//     -webkit-transition:0.3s ease-in;
//     -o-transition: 0.3s ease-in;
//     -moz-transition: 0.3s ease-in;
//     transition:0.3s ease-in;
// }
//
// .rating-container > input:checked ~ label:before,
// .rating-container > input + label:hover ~ label:before,
// .rating-container > input + label:hover:before {
//     content: "\\f005";
//     font-weight:700;
//     font-family: "Font Awesome 5 Free", serif;
//     color: #FFAB00;
// }
//
// .rating-container > .star-cb-clear + label {
//     text-indent: -9999px;
//     width: .5em;
//     margin-left: -.5em;
// }
//
// .rating-container > .star-cb-clear + label:before {
//     width: .5em;
// }
//
// .rating-container:hover > input + label:before {
//     content: "\\f005";
//     font-weight:700;
//     font-family: "Font Awesome 5 Free", serif;
//     color: #c4cadd;
//     text-shadow: none;
// }
//
// .rating-container:hover > input + label:hover ~ label:before,
// .rating-container:hover > input + label:hover:before {
//     content: "\\f005";
//     font-weight:700;
//     font-family: "Font Awesome 5 Free", serif;
//     color: #FFAB00;
// }
//
// .comment-respond .rating-container > .star-cb-clear + label, .comment-respond .rating-container > input + label:before {
//     text-indent: 9999px;
// }
//
// .comment-respond .rating-container > input + label {
//     text-indent: -9999px;
// }
//
// #applicationReviews {
//     margin-top: 30px;
//     padding: 1px 20px 15px;
//     border-radius: 20px;
//
// }
//
// #applicationReviews .discussion-meta {
//
//     display: none;
//
// }
//
// #applicationReviews .comment-form-flex .submit {
//     display: block;
//     margin: 20px auto 0;
// }
//
// .comment-metadata a {
//
//     color: #7e87a6;
//
// }
//
// #comment {
//     width:100%;
//     border: 0;
//     background-color: #e5ecff;
//     height: 80px;
//     margin-top: 5px;
//     border-radius: 10px;
//     padding: 15px;
//     -webkit-transition: 0.2s ease;
//     -o-transition: 0.2s ease;
//     -moz-transition: 0.2s ease;
//     transition: 0.2s ease;
// }
//
// #comment:hover, #comment:focus {
//     -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
// #comments .comment-metadata .edit-link svg {
//     width: 18px;
//     height: 22px;
//     fill: #7e87a6;
// }
//
// .comment-rating-wrapper {
//     float: left;
//     width: 100%;
//     display: inline-block;
//     height: 22px;
//     margin-bottom:5px;
// }
//
// .comment-reply-link {
//     color: #7e87a6;
// }
//
// #reply-title {
//     margin: 0;
// }
//
// .comment-reply {
//     margin-top: -10px;
// }
//
// .comment-rating-wrapper .apto-stars-rating span i {
//     margin-right: 4px;
// }
//
// #commentform > label {
//     display: none;
// }
//
// #applicationReviews .comment-form-comment label {
//     display: none;
// }
//
// #cancel-comment-reply-link {
//     font-size: 1rem;
//     color: #8691b5;
//     font-weight: 700;
// }
//
// #comments .children {
//     list-style: none;
// }
//
// #comments .children .comment-rating-wrapper{
//     display: none;
// }
//
// #respond .comments-rating {
//     height:30px;
// }
//
// .comment #respond .comments-rating {
//   display: none;
// }
//
// #reply-title {
//     line-height: 1.6rem;
// }
//
// .no-access-comment {
//     text-align: center;
//     color: #7e87a6;
//     border-top: 1px solid #e5ecff;
//     padding-top: 15px;
//     font-weight: 700;
// }
//
// body.no-access-on-application .comment-reply,
// body.no-access-on-application #respond .comments-rating,
// body.no-access-on-application #respond .comment-form-comment,
// body.no-access-on-application .comment-form-flex .comments-title {
//     display: none;
// }
//
// #blogPage #pageHeader .separator-wrapper.separator-top {
//     height: 90px;
// }
//
// #blogPage .section-title {
//     margin-top: 0;
// }
//
// .single-post .card.blog-post-item .card-content {
//     margin-top: -60px;
// }
//
// .blog-categories-items {
//     margin-top: 30px;
// }
//
// .card.blog-category-item {
//     border-radius: 10px;
//     background: linear-gradient(to top,#fff, #e7ecfe);
//     color: #000;
// }
//
//
// @media screen and (max-width: 600px) {
//     .blog-categories-items .col:last-child .card.blog-category-item {
//         margin-bottom: 0!important;
//     }
// }
//
// .card.blog-category-item:hover {
//     -webkit-box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
// }
//
// .card.blog-category-item a {
//     color: #1e1f21;
// }
//
// .blog-category-info {
//     display: inline-block;
//     vertical-align: middle;
// }
//
// .card.blog-category-item a {
//     color: #1e1f21;
//     padding: 20px 25px 30px;
//     display: inline-block;
//     width: 100%;
// }
//
// @media only screen and (max-width: 900px) {
//     .card.blog-category-item a {
//         padding: 15px 20px 20px;
//     }
// }
//
// .blog-category-info a:hover, .card.blog-category-item:hover a {
//     color: #3c4a80!important;
// }
//
// .blog-category-icon {
//     display: inline-block;
//     vertical-align: middle;
//     width: 48px;
//     height: auto;
//     margin-right: 15px;
// }
//
// .blog-category-icon svg {
//     display: inline-block;
//     vertical-align: middle;
//     fill: #3c4a80 !important;
// }
//
// .card.blog-category-item h3 {
//     font-size: 1.1rem;
//     font-weight: 700;
//     margin-top: 10px;
//     margin-bottom: 5px;
// }
//
// .card.blog-category-item .articles-of-category {
//     color: #7e87a6;
//     font-size: 0.9rem;
//     text-align: left;
// }
//
// .card.blog-category-item .btn-primary {
//     height: 45px;
//     line-height: 43px;
//     margin-top: 20px;
// }
//
// .latest-articles-wrapper {
//     position: relative;
//     z-index: 1;
//     padding-top: 40px;
// }
//
// .latest-articles-title {
//     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
//     font-weight: 700;
//     font-size: 2rem;
//     margin-bottom: 10px;
//     margin-top: 0;
// }
//
// .latest-articles-desc {
//     color: #808ba1;
//     font-size: 1rem;
//     margin-top: 0;
// }
//
// .blog-posts-items.flex {
//     margin-top: 10px;
// }
//
// @media only screen and (max-width: 600px) {
//
//     .pagination-wrapper {
//         margin: 10px 0 15px;
//     }
//
// }
//
// .blog-posts-items.flex .col {
//     margin-left: 0!important;
// }
//
// .flex .col .card.blog-post-item {
//     height: calc(100% - 30px);
//     overflow: hidden;
// }
//
// .card.blog-post-item {
//     border-radius: 10px;
//     height: calc(100% - 25px);
// }
//
// .card.blog-post-item:hover {
//     box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
// }
//
// .card.blog-post-item .separator-wrapper svg {
//
//     fill: #fff;
//
// }
//
// .card.blog-post-item:hover a, .card.blog-post-item:hover .article-title {
//     color: #3c4a80!important;
// }
//
// .card.blog-post-item .separator-wrapper {
//
//     margin-top: -40px;
//
// }
//
// .card.blog-post-item .card-content {
//     margin-top: -100px;
//     padding: 24px 24px 45px;
//     position: relative;
// }
//
// @media screen and (max-width: 990px) {
//     .card.blog-post-item .card-content {
//         margin-top: -50px;
//     }
// }
//
// .card.blog-post-item .article-title {
//     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
//     font-size: 1.5rem;
//     font-weight: 700;
//     margin-top: -15px;
//     position: relative;
//     line-height: 2.1rem;
//     color: #000;
//     -webkit-transition: 0.3s ease-in;
//     -o-transition: 0.3s ease-in;
//     -moz-transition: 0.3s ease-in;
//     transition: 0.3s ease-in;
// }
//
// .card.blog-post-item .card-image {
//     max-height: 220px;
//     overflow: hidden;
//     border-radius: 10px 10px 0 0;
// }
//
// .card.blog-post-item .article-meta, .card.blog-post-item .article-category {
//     color: #7e87a6;
// }
//
// .card.blog-post-item .article-category {
//     margin-top: 2px;
// }
//
// .card.blog-post-item .article-overview {
//     margin: 15px 0 10px;
//     font-size: 1rem;
//     line-height: 1.7rem;
// }
//
// .card.blog-post-item .article-read-more {
//
//     -webkit-transition: 0.3s ease-in;
//     -o-transition: 0.3s ease-in;
//     -moz-transition: 0.3s ease-in;
//     transition: 0.3s ease-in;
//     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
//     font-size: 1.2rem;
//     font-weight: 700;
//     color: #000;
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     background-color: #fff;
//     padding-left: 23px;
//     padding-bottom: 12px;
//     width: 100%;
//
// }
//
// .files-marketplace-plugin .page-numbers.current {
//     background-color: #5264a9;
//     color: #fff;
// }
//
// .subscribe-modal .how-to {
//     font-size: 1rem !important;
// }
//
// .subscribe-modal.modal .modal-content {
//     padding: 10px 24px 0;
// }
//
// .subscribe-modal.modal.congrapps-modal .btn-primary {
//     font-size: 1rem;
// }
//
// .mc4wp-form-fields a {
//     color: #505f79;
// }
//
// #pageHeader .section-content .btn-primary {
//     margin-top: 15px;
// }
//
// @media screen and (max-width: 600px){
//     #pageHeader .section-content .btn-primary {
//         width:100%;
//     }
// }
//
// #postCategory .latest-articles-wrapper {
//     margin-top: 0;
// }
//
// #postCategory #pageCardContent > .separator-wrapper svg {
//     fill: #5264a9;
// }
//
// body.category .section-title {
//     margin-top: 0;
// }
//
// #blogSidebar .blog-categories-items {
//     margin-top: 57px;
// }
//
//
// @media only screen and (max-width: 600px) {
//     #blogSidebar .blog-categories-items {
//
//         margin-top: 25px;
//
//     }
//
//     .latest-articles-wrapper {
//         padding-top:25px!important;
//     }
// }
//
// #blogSidebar .blog-categories-items .blog-category-icon {
//     width:45px;
// }
//
// #blogSidebar .blog-categories-items .card.blog-category-item h3 {
//     font-size: 1rem;
//     font-weight: 700;
//     margin-top: 10px;
//     margin-bottom: 2px;
// }
//
// #promoteApplications {
//     margin: 30px 0;
//     border-radius: 10px;
//     background: linear-gradient(to top,#596bae, #5264a9);
//     color: #fff;
//     padding: 25px 20px;
//     overflow: hidden;
// }
//
// #promoteApplications:hover {
//     -webkit-box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
// }
//
// #promoteApplications h4 {
//     font-size: 1.1rem;
//     font-weight: 700;
//     margin-top: 10px;
//     line-height: 1.7rem;
// }
//
// #promoteApplications p {
//     color: #cfd5ee;
// }
//
// #promoteApplications .btn-primary {
//     position:relative;
//     z-index:1;
// }
//
// #promoteApplications .separator-wrapper {
//
//     position: absolute;
//     z-index: 0;
//     left: 0;
//     bottom: 0;
//     height: 50px;
//
// }
//
// #promoteApplications .separator-wrapper svg {
//
//     fill: #6575b3;
//
// }
//
// .blog-posts-items-sidebar.card {
//
//     padding: 20px;
//     border-radius: 10px;
//
// }
//
// .blog-posts-items-sidebar.card h4 {
//
//     font-size: 1.4rem;
//     font-weight: 700;
//     margin-top: 10px;
//     border-bottom: 1px solid #e5ecff;
//     padding-bottom: 15px;
//     margin-bottom: 0;
//
// }
//
// .blog-posts-items-sidebar.card ul li:first-child {
//     padding-top:5px;
// }
//
// .blog-posts-items-sidebar.card ul li {
//     -webkit-transition:0.3s ease-in;
//     -o-transition: 0.3s ease-in;
//     -moz-transition: 0.3s ease-in;
//     transition:0.3s ease-in;
//     padding: 15px 0;
//     display: block;
//     color: #000;
//     font-weight: 700;
//     border-bottom: 1px solid #e5ecff;
// }
//
//
// .blog-posts-items-sidebar.card ul li .article-meta,
// .blog-posts-items-sidebar.card ul li .article-category {
//     font-weight: 400;
//     color: #7e87a6;
//     font-size: 0.9rem;
// }
//
// .blog-posts-items-sidebar.card ul li a {
//     color: #000;
//     -webkit-transition:0.3s ease-in;
//     -o-transition: 0.3s ease-in;
//     -moz-transition: 0.3s ease-in;
//     transition:0.3s ease-in;
// }
//
// .blog-posts-items-sidebar.card ul li a:hover, .blog-posts-items-sidebar.card ul li:hover a {
//     color: #3c4a80;
//
// }
//
// .read-all-articles.btn-primary.apto-blue {
//     display: block;
//     text-align: center;
// }
//
// #postCategory .section-description {
//     width: 70%;
// }
//
// .single-post .separator-wrapper {
//     height: 120px;
// }
//
// .single-post .separator-wrapper svg {
//     fill:#e7ecfe;
// }
//
// .single-post section {
//     padding-top: 0;
//     background: linear-gradient(to bottom,#fff, #e7ecfe);
//     padding-bottom: 80px;
// }
//
// .single-post #blogSidebar .blog-categories-items {
//     margin-top: 0;
// }
//
// .single-post .article-content {
//     margin-top: 20px;
//     border-top: 1px solid #e5ecff;
//     font-size: 1rem;
//     line-height: 2rem;
//     -moz-user-select: none;
//     -webkit-user-select: none;
//     -ms-user-select: none;
//     user-select: none;
// }
//
// .single-post .article-content p {
//     margin: inherit!important;
// }
//
// .single-post .article-content ul {
//
//     padding-left: 30px;
//     list-style: disc;
//
// }
//
// .single-post .article-content ul li {
//     list-style-type: disc;
// }
//
//
// #postArticleContent .article-title {
//     margin-top: 0;
//     margin-bottom: 20px;
//     font-size: 2.2rem;
// }
//
// .single-post .article-content h3 {
//     font-size: 2rem;
//     margin-bottom: 15px;
// }
//
// #postArticleContent .card-image {
//     max-height: 350px;
// }
//
// #articleComments {
//
//     border-radius: 10px;
//     padding: 25px;
//     margin-top: 40px;
// }
//
//
// @media screen and (max-width: 600px) {
//     #articleComments {
//         margin-top:25px;
//     }
// }
//
// #articleComments .comment-form-flex .comments-title {
//     color: #7e87a6;
// }
//
// #articleComments .comments-title {
//     font-size: 1.5rem;
//     font-weight: 700;
//     margin-top: 0;
//     border-bottom: 1px solid #e5ecff;
//     padding-bottom: 20px;
//
// }
// #articleComments .discussion-meta {
//     display: none;
// }
//
// .comment {
//
//     margin-top: 15px;
//
// }
//
//
// @media screen and (max-width: 900px) {
//     #postArticleContent {
//
//         margin-top: -90px;
//
//     }
//
//     .single-post section {
//         padding-bottom:0;
//     }
//
// }
// @media screen and (max-width: 700px) {
//
//     .single-post .separator-wrapper svg {
//         top: 0;
//     }
//
//     .card.blog-post-item .card-content {
//
//         padding-top: 0;
//
//     }
//
//     #postArticleContent .article-title {
//
//         font-size: 1.8rem;
//
//     }
//
//     .single-post .article-content {
//
//         margin-top: 10px;
//         padding-top: 10px;
//
//     }
//
// }
//
// .diagonal-separator {
//     padding-top: 0;
//     background: transparent;
//     position: relative;
//     overflow: hidden;
//     height: 78px;
//     z-index: 1;
// }
//
//
// .diagonal-separator::before {
//     position: absolute;
//     content: '';
//     pointer-events: none;
//     top: 90px;
//     left: -25%;
//     z-index: 3;
//     width: 150%;
//     height: 90px;
//     background: #e6ecff;
//     -webkit-transform: rotate(-2deg);
//     -ms-transform: rotate(-2deg);
//     transform: rotate(-2deg);
//     -webkit-transform-origin: 0 0;
//     transform-origin: 0 0;
//
// }
//
// .apto-page.row .diagonal-separator {
//     margin-top: -80px;
// }
//
// .apto-page.row .diagonal-separator::before {
//     background:#fff;
// }
//
// #faqPage #pageHeader .separator-wrapper.separator-bottom {
//     height:130px;
// }
//
//
// .apto-page.row .diagonal-separator.before-law-firms {
//
//     margin-top: -75px;
//
// }
//
// .apto-page.row .diagonal-separator.before-law-firms:before {
//
//     background: #dde5ff;
//
// }
//
// .diagonal-separator.before-what-we-do {
//
//     margin-top: -80px;
//
// }
//
// .apto-page.row .diagonal-separator.before-what-we-do:before{
//     background: #e6ecff;
// }
//
// .apto-page.row .diagonal-separator.before-pricing {
//
//     margin-top: -80px;
// }
//
// .apto-page.row .diagonal-separator.before-pricing:before {
//     background: #f6f6f8;
// }
//
//
// body .collapsible.white-collapsible {
//     border-radius: 10px;
//     overflow: hidden;
//     -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
// }
//
// body .collapsible.white-collapsible li {
//
//     margin-bottom: 0;
//     box-shadow: none;
//     border-radius: 0;
//     border-bottom: 1px solid #e5ecff;
//
// }
//
// .collapsible.white-collapsible .collapsible-header {
//     background: #fff;
//     color: #000;
//     line-height: 40px;
//     font-size: 1rem;
//     font-weight: 700;
//     -webkit-transition:0.2s ease-in;
//     -o-transition: 0.2s ease-in;
//     -moz-transition: 0.2s ease-in;
//     transition:0.2s ease-in;
// }
//
// .collapsible.white-collapsible .collapsible-header:hover {
//     background-color: #e5ecff;
// }
//
// .collapsible.white-collapsible .collapsible-header .question-title {
//     float: left;
//     width: calc(100% - 45px);
// }
//
// body .collapsible.white-collapsible .collapsible-body {
//     background-color:#f0f3ff;
//     font-size: 1rem;
//     line-height: 1.9rem;
//     padding: 15px 25px;
// }
//
// body .collapsible.white-collapsible li .collapsible-header i {
//     font-size: inherit;
//     margin-right: 0;
//     text-align: right;
//     -webkit-transition:0.2s ease-in;
//     -o-transition: 0.2s ease-in;
//     -moz-transition: 0.2s ease-in;
//     transition:0.2s ease-in;
// }
//
//
// @media only screen and (max-width: 600px) {
//
//     body .collapsible.white-collapsible li .collapsible-header i {
//         font-size: 1.2rem;
//         vertical-align: bottom;
//         float: right;
//     }
//
//     #contactForm.card h2 {
//         font-size: 1.6rem!important;
//     }
//
// }
//
// body .collapsible.white-collapsible li.active .collapsible-header i.fas.fa-chevron-down {
//     -webkit-transform: rotate(180deg) translateX(-10px);
//     -ms-transform: rotate(180deg) translateX(-10px);
//     transform: rotate(180deg) translateX(-10px);
// }
//
// #faqPage #pageCardContent {
//     padding: 0;
// }
//
// #contactForm.card {
//     -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     margin-top: 7px !important;
//     border-radius: 10px !important;
//     padding: 20px 25px;
// }
//
// #contactForm.card h2 {
//     font-size: 1.6rem;
//     margin-top: 10px;
//     font-weight: 700;
//     margin-bottom: 10px;
// }
//
// #contactForm .how-to {
//     color: #747f94;
// }
//
// #contactForm.card .contact-form-wrapper {
//     margin-top: 10px;
//     border-top:1px solid #e5ecff;
//     padding-top:10px;
// }
//
// #contactForm.card label {
//     font-size: 0.9rem;
// }
//
// #faqPage #pageCardContent > .container > .col {
//     margin-top: -60px;
// }
//
// #contactForm .wpcf7-form-control.wpcf7-textarea {
//     box-shadow: none;
//     border: 0;
//     background-color: #e7ecfe;
//     height: 70px;
//     margin-top: 10px;
//     border-radius: 4px;
//     padding: 15px;
// }
//
// .wpcf7-form-control-wrap input {
//
//     margin-top: 10px !important;
//     border-radius: 4px !important;
//
// }
//
// .questions-wrapper body .collapsible li.active .collapsible-header.waves-effect {
//     background-color: #4558ae;
//     color: #fff;
// }
//
// .questions-wrapper .collapsible-body p {
//     margin:2px 0;
// }
//
// .answer-date {
//     color: #808ba1;
//     font-style: italic;
// }
//
// @media screen and (max-width: 600px) {
//
//     #faqPage #pageCardContent > .container > .col {
//         margin-top: 10px;
//     }
//
//     #contactForm.card {
//         margin-bottom: 30px !important;
//         padding-bottom: 5px;
//     }
//
//     #questionsContent {
//         margin-top: -60px !important;
//     }
//
// }
//
// #myUploadsPage #pageHeader .btn-primary {
//     margin-top: 40px;
// }
//
// @media only screen and (max-width: 600px) {
//     #myUploadsPage #pageHeader .btn-primary {
//
//         margin-top: 0;
//         width: 300px;
//         max-width: 100%;
//
//     }
// }
//
// #myUploadsPage #pageHeader .separator-wrapper.separator-bottom {
//     height: 190px;
// }
//
// #myUploadsPage #pageCardContent {
//     padding: 0;
// }
//
// #myUploadsPage #pageCardContent .separator-wrapper.separator-bottom {
//     height:160px;
// }
//
// #uploadsContent {
//     margin-top: -60px;
//     position: relative;
//     z-index:1;
// }
//
//
// @media only screen and (max-width: 600px) {
//     #uploadsContent .collapsible.white-collapsible .collapsible-header {
//
//         padding: 20px 0 20px 35px;
//
//     }
// }
//
// .application-status-wrapper {
//     display: inline-block;
//     margin-right: 10px;
//     float: right;
// }
//
// .application-status-label {
//     background: #e5ecff;
//     padding: 0 15px;
//     border-radius: 4px;
//     font-size: 0.9rem;
//     -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
// @media only screen and (max-width: 600px) {
//
//     .application-status-label {
//         border-radius: 50%;
//         width: 40px;
//         height: 40px;
//         text-align: center;
//         padding: 0;
//         line-height: 42px;
//         position: absolute;
//         left: -10px;
//     }
//
//     .application-status-label i {
//
//         margin: 0 !important;
//         font-size: 1.2rem !important;
//         line-height: inherit !important;
//         width: auto !important;
//
//     }
//
// }
//
// @media only screen and (max-width: 360px) {
//
//     .application-status-label {
//         border-radius: 50%;
//         width: 40px;
//         height: 40px;
//         text-align: center;
//         padding: 0;
//         line-height: 42px;
//         position: absolute;
//         left: 2px;
//     }
// }
//
// .application-status-label.status-rejected, .application-status-text.status-rejected {
//
//     color: #f44336;
//
// }
//
// .application-status-label.status-pending, .application-status-text.status-pending {
//     color:#FF9800;
// }
//
// .application-status-label.status-publish, .application-status-text.status-publish {
//     color:#4CAF50;
// }
//
// body .collapsible-body .application-info-item {
//
//     display: inline-block;
//     float: left;
//     width: 100%;
//     margin-bottom: 10px;
//
// }
//
// @media only screen and (max-width: 900px) {
//     .application-info-item .info-key {
//
//         color: #7e87a6;
//
//     }
// }
//
// .application-status-text {
//     text-transform: capitalize;
//     font-weight: 700;
// }
//
// #uploadPromotion.card {
//
//     margin-top: 65px !important;
//     border-radius: 10px !important;
//     background: linear-gradient(to top,#596bae, #5264a9);
//     color: #fff;
//     padding: 25px 20px;
//     overflow: visible !important;
// }
//
//
// @media only screen and (max-width: 600px) {
//
//     #uploadPromotion.card {
//         margin-bottom:40px;
//         padding: 35px 20px !important;
//     }
//
//     #uploadPromotion h2 {
//         font-size: 1.2rem;
//     }
//
// }
//
// #uploadPromotion .credits-item.credits-application {
//     margin-top: -80px;
//     width: 80px;
//     height: 80px;
//     line-height: 56px;
//     color: #5d9cec;
//     border: 12px solid #000;
//     margin-bottom: -15px;
// }
//
// @media screen and (max-width: 600px) {
//
//     #uploadPromotion .credits-item.credits-application {
//         margin-top: -80px;
//         width: 90px;
//         height: 90px;
//         line-height: 60px;
//         border: 13px solid #000;
//         font-size: 1.8rem;
//     }
// }
//
// #uploadsContent .section-title {
//     font-size: 24px;
//     margin-bottom: 10px;
// }
//
// #uploadsContent .section-description {
//     text-align: left;
//     margin: 0 0 30px;
//     font-size: 1rem;
//     color: #666;
// }
//
// #uploadPromotion h2 {
//     font-size: 17px;
//     font-weight: 700;
//     line-height: 24px;
//     margin-bottom: 10px;
// }
//
// #uploadResultModal {
//     padding: 0;
// }
//
// #uploadResultModal .separator-wrapper {
//     height: 100px;
// }
//
// #uploadResultModal .separator-wrapper svg {
//     top: 0 !important;
//     fill: #e7ecfe;
// }
//
// .upload-result-icon {
//     width: 70px;
//     height: 70px;
//     display: block;
//     margin: -80px auto 20px auto;
//     background: #e7ecfe;
//     color: #4CAF50;
//     border-radius: 50%;
//     line-height: 70px;
//     font-size: 2rem;
//     position: relative;
//     z-index: 2;
//     -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
// .upload-result-icon i {
//     line-height: inherit;
// }
//
// .upload-result-icon i.fas.fa-times {
//     color: #f44336;
// }
//
// #registerResultModal .upload-result-icon {
//     color: #5d9cec;
// }
//
// .upload-success .upload-result-icon {
//     color:#4CAF50;
// }
//
// .upload-fail .upload-result-icon {
//     color:#f44336;
// }
//
// body .collapsible-header .apto-stars-rating-wrap {
//     margin: 10px;
// }
//
// body .collapsible-header .apto-stars-rating-wrap i {
//     width: auto;
//     font-size: 1rem;
//     margin: 0 3px;
// }
//
// #aboutUsPage .section-title {
//     font-weight: 800;
// }
//
// #aboutUsPage #overviewIntro {
//     padding: 0;
// }
//
// #aboutUsPage #overviewIntro .separator-wrapper {
//     height: 150px;
// }
//
// #aboutUsPage #overviewIntro .separator-wrapper svg path {
//     fill: #e6ecff;
// }
//
// #overviewIntro .section-title {
//     margin-top: 0;
// }
//
// #overviewIntro .section-btns-wrapper {
//     margin-bottom: 10px;
// }
//
// #aboutUsPage #overviewIntro .illustration {
//     width: 400px;
//     margin: -40px auto 0 auto;
// }
//
// #ourStory {
//     background-color: #e6ecff;
//     padding: 0;
// }
//
// #ourStory .separator-wrapper {
//     height: 150px;
// }
//
// #ourStory .separator-wrapper svg path {
//    fill:#fff;
// }
//
// .story-section {
//     padding: 0;
// }
//
// .story-section .container {
//     margin-top: 50px;
// }
//
// .story-section .illustration {
//     width: 300px;
//     margin: 0 auto;
// }
//
// .story-section  .separator-wrapper {
//     height: 150px;
// }
//
// #theProblem .separator-wrapper  svg path {
//     fill:#e6ecff;
// }
//
// #theSolution {
//     background-color: #e6ecff;
//     padding-bottom: 140px;
// }
//
// #theSolution .separator-wrapper svg path {
//     fill:#fff;
// }
//
// #aboutUsPage #pageCardContent {
//     padding: 0;
// }
//
// #howItWorks {
//     margin: 0 !important;
//     border-radius: 10px !important;
// }
//
// #aboutUsPage .diagonal-separator {
//     margin-top: -90px;
// }
//
// #aboutUsPage .diagonal-separator:before {
//     background: #fff;
// }
//
// #aboutUsPage .btn-transparent {
//     border-color: #7e87a6;
//     color: #7e87a6;
// }
//
// .credits-item.inline-credits {
//     display: inline-block;
//     width: 20px;
//     height: 20px;
//     border: 4px solid #eee;
//     box-shadow: none;
//     vertical-align: middle;
//     margin-top: -3px;
// }
//
// .credits-explain, .credits-ways {
//     margin: 30px auto 0!important;
//     display: inline-block;
//     float: unset !important;
// }
//
// @media screen and (max-width: 600px){
//     .credits-explain, .credits-ways {
//         margin: 20px auto 0 !important;
//     }
// }
//
// .credits-explain {
//     max-width: 800px;
//     width: 100%;
// }
//
// .credits-meta-wrapper {
//     margin-top: 45px;
// }
//
// .credits-meta-wrapper .credits-explain {
//     padding: 0;
//     margin: 0 !important;
// }
//
// .credits-explain.how-to-use-it {
//     max-width: 90%;
// }
//
// .credits-explain .card.credit-meta-item, .credits-ways .card.credit-meta-item {
//     box-shadow: none;
//     background-color: #e7ecfe;
// }
//
// @media screen and (min-width: 990px) and (max-width: 1140px){
//     .credits-ways .card.credit-meta-item {
//         padding: 25px 10px;
//     }
//     .credits-ways .card.credit-meta-item .btn-primary {
//         font-size:14px;
//         padding-left: 30px;
//     }
// }
//
// .credits-explain .card.credit-meta-item {
//     background: #fff;
//     -webkit-box-shadow: 0 2px 59px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 2px 59px 0 rgba(126, 136, 172, 0.44);
// }
//
//
// @media screen and (max-width: 600px) {
//     .credits-explain .col:last-child .card.credit-meta-item {
//         margin-bottom:0;
//     }
// }
//
// .home .credits-ways .card.credit-meta-item {
//     background-color: white;
//     -webkit-box-shadow: 0 2px 59px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 2px 59px 0 rgba(126, 136, 172, 0.44);
//     width: 350px;
//     margin: 0 auto;
//     max-width: 100%;
// }
//
// #referFriend .btn-primary {
//     margin-top: 8px;
// }
//
// .about-icon-wrapper {
//     display: inline-block;
//     width: 65px;
//     height: 65px;
//     border-radius: 50%;
//     background-color: #dbe0f2;
//     color: #37405e;
//     line-height: 65px;
//     font-size: 21px;
//     -webkit-box-shadow: none;
//     box-shadow: none;
//     transition: color 0.2s ease;
// }
//
// .about-icon-wrapper.upload-icon {
//     background: linear-gradient(#ffa421, #fd7b49);
//     color:#fff;
// }
//
// .about-icon-wrapper.purchase-icon {
//     background-color: #4798ed;
//     color:#fff;
// }
//
// .about-icon-wrapper.referral-icon {
//     background-color: #5365aa;
//     color: #fff;
// }
//
//
//
// @media screen and (max-width: 1400px) {
//     #aboutUsPage .credit-meta-item .btn-primary.with-icon {
//         padding-left:5%!important;
//     }
// }
//
// #aboutUsPage #pageCardContent .separator-wrapper.separator-bottom {
//     height: 180px;
// }
//
// #theProblem .go-to-link {
//     font-weight: 700;
// }
//
// #howItWorks .col .section-title {
//     padding-top: 20px;
//     font-size: 2rem;
// }
//
// #howItWorks .col:first-child .section-title {
//     border-top: 0;
//     padding-top: 0;
//     margin-top: 5px!important;
// }
//
// #howItWorks .how-it-works-section {
//     border-top: 1px solid #e5ecff;
// }
//
// .coupon-message {
//     text-align: center;
//     background-color: #e5ecff;
//     display: inline-block;
//     width: 100%;
//     padding: 15px 10px;
//     border-radius: 20px;
//     margin: 10px 0;
//     font-weight: 700;
//     font-size: 0.9rem;
// }
//
// #validateCoupon {
//     height: 40px;
//     line-height: 38px;
//     margin-top: 7px;
//     font-size: 0.9rem;
// }
//
// .coupon-code-wrapper .input-field:first-child, .coupon-code-wrapper .input-field:first-child label {
//     padding-left: 0;
//     left: 0;
// }
//
// .coupon-code-wrapper .input-field:last-child {
//     padding-right:0;
// }
//
// #paymentModal .modal-content {
//     position: relative;
// }
//
// .preloader-overlay {
//     position: absolute;
//     width: 100%;
//     top: 0;
//     left: 0;
//     height: 100%;
//     background-color: rgba(255,255,255,0.7);
//     z-index: 1;
// }
//
// .preloader-overlay .preloader-wrapper {
//     position: fixed;
//     left: calc(50% - 25px);
//     top: calc(50% - 25px);
// }
//
// .preloader-overlay .preloader-wrapper .spinner-layer {
//     border-color:#475ba1;
// }
//
// .upload-result-icon.referral-credits {
//     color: #4798ed;
//     font-weight: 700;
//     font-size: 1.8rem;
// }
//
// .input-field.referral-register {
//     background-color: #e5ecff;
//     padding: 20px 25px;
//     border-radius: 10px;
//     width: 80%;
//     margin: 30px auto 5px;
//     -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
// }
//
// .referral-register h3 {
//     color: #505f79;
//     font-weight: 700;
//     font-size: 1.4rem;
//     margin: 10px 0 5px;
// }
//
// .referral-register p {
//     color: #647393;
// }
//
// .referral-item {
//     color: #505f79;
//     background-color: #d4e1f4;
//     padding: 10px 5px;
//     border-radius: 10px;
// }
//
// .ref-value {
//     color: #5ea7f4;
//     display: block;
// }
//
// .user-referral-copy {
//
//     margin-top: 20px;
//
// }
//
// .copy-tooltip {
//     position: relative;
//     display: inline-block;
// }
//
// @media screen and (max-width: 900px) {
//
//     .input-field.referral-register {
//         width:100%;
//         box-shadow: none;
//     }
//
//     .referral-item {
//         margin-bottom: 15px;
//     }
//
//     .copy-tooltip {
//         display: block;
//         margin: 0 auto;
//         text-align: center;
//     }
//
// }
//
// .copy-tooltip .tooltiptext {
//     visibility: hidden;
//     width: 140px;
//     background-color: #53596f;
//     color: #fff;
//     text-align: center;
//     border-radius: 6px;
//     padding: 0 5px;
//     position: absolute;
//     z-index: 1;
//     bottom: 120%;
//     left: 54%;
//     margin-left: -75px;
//     opacity: 0;
//     -webkit-transition: opacity 0.3s;
//     -o-transition:  opacity 0.3s;
//     -moz-transition:  opacity 0.3s;
//     transition: opacity 0.3s;
// }
//
// .copy-tooltip .tooltiptext::after {
//     content: "";
//     position: absolute;
//     top: 100%;
//     left: 50%;
//     margin-left: -5px;
//     border-width: 5px;
//     border-style: solid;
//     border-color: #555 transparent transparent transparent;
// }
//
// .copy-tooltip:hover .tooltiptext {
//     visibility: visible;
//     opacity: 1;
// }
//
// #referral_url {
//     background-color: #e5ecff;
//     font-weight: 700;
//     border: 0 !important;
//     border-radius: 35px;
//     color: #53596f;
//     font-size: 1rem;
//     height: 50px;
//     margin-top: -4px;
//     line-height: 50px;
//     text-align: center;
//     width: 420px;
//     display: inline-block;
//     padding-left: 0;
// }
//
//
//
// .user-referral-copy .input-field, .user-referral-copy .copy-tooltip {
//     display: inline-block;
//     margin: 0 5px;
// }
//
// .user-referral-code-wrapper .section-title.dark-color {
//     font-size: 1.5rem;
//     line-height: 1.8rem;
//     margin-bottom: 10px;
// }
//
// @media screen and (max-width: 600px) {
//
//     #referral_url {
//         font-size: 0.9rem;
//         margin-bottom: 0;
//         width:100%;
//     }
//
//     .user-referral-copy .input-field, .user-referral-copy .copy-tooltip {
//         display: inline-block;
//         margin: 5px 0;
//         width: 100%;
//     }
//
//     .user-referral-code-wrapper .section-title.dark-color {
//
//         font-size: 1.3rem;
//         line-height: 1.6rem;
//         margin-bottom: 10px;
//
//     }
//
// }
//
// @media screen and (max-width: 900px) {
//
//     .user-referral-code-wrapper .section-title.dark-color  {
//         margin-top: 0;
//     }
//
// }
//
// .user-referral-code-wrapper .section-paragraph.dark-color {
//     margin-top:0;
//     font-size: 15px;
//     line-height: 1.8rem;
// }
//
//
//
// .referred-user-item.card {
//     text-align: center;
//     padding: 15px 15px 20px;
//     border-radius: 10px;
//     background: #e7ecfe;
//     box-shadow:none;
// }
//
// .referred-user-item.card:hover {
//     -webkit-box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
//     box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
// }
//
// .referred-user-item.card .avatar {
//     border-radius: 50%;
//     width: 60px;
//     margin: 5px 0;
// }
//
// @media screen and (max-width: 900px) {
//     .referred-user-item.card .avatar {
//         width: 60px;
//     }
// }
//
// .referred-user-item.card .user-name {
//     color: #37405e;
//     font-weight: 700;
// }
//
// .referred-user-item.card .user-data-date {
//     color: #808ba1;
//     font-size: 14px;
// }
//
// .user-referral-code-wrapper {
//     margin-bottom: 30px;
//     border-bottom: 1px solid #e5ecff;
//     padding-bottom: 30px !important;
// }
//
// @media screen and (max-width: 400px) {
//     .user-referral-code-wrapper {
//         padding-left:0!important;
//         padding-right:0!important;
//     }
// }
//
// .card .user-referral-code-wrapper:nth-child(3) {
//     border: none;
//     padding-bottom: 0 !important;
//     margin-bottom: 0;
// }
//
// #lawFirmDetails .tab-content ul {
//     list-style-type: disc;
//     padding-left: 40px;
// }
//
// #lawFirmDetails .tab-content ul li {
//     list-style-type: disc;
// }
//
// #lawFirmDetails .tab-content blockquote {
//     margin: 20px 0;
//     padding: 10px 20px;
//     border-left: 5px solid #5ea7f4;
//     background-color: #e5ecff;
//     border-radius: 4px;
//     font-style: italic;
// }
//
// .forgot-password-icon {
//     width: 180px;
//     display: block;
//     margin: 0 auto;
//     max-width: 100%;
// }
//
// .card.center.lost-password-card {
//     width: 800px;
//     max-width: 100%;
//     margin: 10px auto;
//     border-radius: 25px;
//     padding: 35px 10%;
// }
//
// .lost-password-card h1 {
//     font-weight: 700;
//     font-size: 2rem;
//     color: #7e87a6;
//     margin-top: 20px;
//     margin-bottom: 30px;
// }
//
// #password-lost-form p {
//     color: #7e87a6!important;
//     font-size: 1rem;
// }
//
// #lostpasswordform #user_login:hover,
// #lostpasswordform #user_login:focus,
// #resetpassform input:hover,
// #resetpassform input:focus {
//     border-color:#e6ecff;
//     -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
//     box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
// }
//
// #lostpasswordform #user_login, #resetpassform input {
//     width: calc(100% - 25px);
//     background-color: #e6ecff;
//     border-radius: 25px;
//     padding-left: 25px;
//     border: 2px solid #d6def9;
//     height: 50px;
//     margin-top: -5px;
//     box-shadow: none;
// }
//
//
// #lostpasswordform #user_login::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
//     color: #7e87a6;
//     opacity: 1; /* Firefox */
// }
//
// #lostpasswordform #user_login:-ms-input-placeholder { /* Internet Explorer 10-11 */
//     color: #7e87a6;
// }
//
// #lostpasswordform #user_login::-ms-input-placeholder { /* Microsoft Edge */
//     color: #7e87a6;
// }
//
// .card.lost-password-message {
//     width: 800px;
//     margin: 0 auto 30px;
//     border-radius: 35px;
//     padding: 20px 30px;
//     background-color: #e6ecff;
//     font-weight: 700;
//     color: #5568ab;
//     text-align: center;
//     max-width: 100%;
// }
//
// .lost-password-message-icon {
//     background-color: #000;
//     color: #fff;
//     width: 45px;
//     height: 45px;
//     line-height: 45px;
//     border-radius: 50%;
//     margin-top: -10px;
//     margin-left: -18px;
//     margin-right: 18px;
// }
//
// .lost-password-message-icon.success {
//     background-color:#61A9F6;
// }
//
// .lost-password-message-icon.error {
//     background-color:#7e87a6;
// }
//
// #resetpassform input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
//     color: #7e87a6;
//     opacity: 1; /* Firefox */
// }
//
// #resetpassform input:-ms-input-placeholder { /* Internet Explorer 10-11 */
//     color: #7e87a6;
// }
//
// #resetpassform input::-ms-input-placeholder { /* Microsoft Edge */
//     color: #7e87a6;
// }
//
// .password-hint {
//     padding: 0 15px;
//     border-radius: 10px;
//     color: #7e87a6;
// }
//
// #resetpass-button {
//     margin-top: 30px;
//     width: 280px;
// }
//
// #password-strength {
//     position: relative;
//     background-color: #e6ecff;
//     padding: 10px;
//     margin-bottom: 20px;
//     border-radius: 25px;
//     font-weight: 700;
//     overflow: hidden;
//     height: 45px;
//     margin-top: 10px;
// }
//
// #password-strength:before {
//     position:absolute;
//     display:block;
//     content:'';
//     left:0;
//     height:100%;
//     background-color: #4798ed;
//     top: 0;
// }
//
// #password-strength.short:before {
//     width:15%;
//     opacity:0.2;
// }
//
// #password-strength.bad:before {
//     width:45%;
//     opacity:0.5;
// }
//
// #password-strength.good:before {
//     width:60%;
//     opacity:0.7;
// }
//
// #password-strength.strong:before {
//     width:100%;
//     opacity:1;
// }
//
// // span {
// //     position: relative;
// //     z-index: 2;
// // }
//
// #password-strength.good span,
// #password-strength.strong span {
//     color:#fff;
// }
//
// .card.center.lost-password-card.password-changed {
//     pointer-events: none;
//     opacity: 0.7;
// }
//
// @media only screen and (max-width: 600px) {
//     .forgot-password-icon {
//         width: 100px;
//     }
//
//     .lost-password-card h1 {
//         font-size:1.6rem;
//         margin-bottom: 15px;
//     }
//
//     #lostpasswordform {
//         padding: 0;
//     }
//
//     .lostpassword-button {
//         margin-top: 0;
//     }
//
//     .card.lost-password-message {
//         padding: 20px;
//         border-radius: 25px;
//         margin-bottom: 15px;
//     }
//
//     .lost-password-message-icon {
//         display: none;
//     }
//
// }
//
// #lawFirmDetails .tab-content .card {
//     color: #464b55;
// }
//
//
// @media only screen and (max-width: 600px) {
//     #lawFirmDetails .tab-content .card {
//         box-shadow: none;
//         padding: 0;
//
//     }
//
//     .tabs .tab a {
//
//         padding: 0 5px;
//         font-size: 12px !important;
//
//     }
//
//     #lawFirmDetails {
//
//         padding: 20px 0;
//
//     }
//
// }
//
// .tabs.stickyTabs {
//
//     position: fixed;
//     top: 56px;
//     left: 0;
//     width: 100%;
//     z-index: 99;
//     border-radius: 0;
//     transition: transform 0.2s ease;
// }
//
// body.headerScrolledUp .tabs.stickyTabs {
//     transform: translateY(-56px);
// }
//
// body.admin-bar.headerScrolledDown .tabs.stickyTabs {
//     transform: translateY(46px);
// }
//
// .stickyLawFirmTabs header nav.scrollDown {
//     box-shadow: none;
// }
//
// .tabs.stickyTabs .tab.col.s4 {
//
//     width: auto;
//
// }
//
// .help-text-box {
//     background-color: #fff;
//     display: inline-block;
//     -webkit-box-shadow: 0 10px 29px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 10px 29px 0 rgba(126, 136, 172, 0.44);
//     padding: 25px 30px;
//     border-radius: 10px;
//     margin-top: 50px;
//     color: #5e697d;
//     font-weight: 700;
//     margin-bottom: 30px;
//     font-size: 0.9rem;
// }
//
// @media screen and (max-width: 990px) {
//     .help-text-box {
//         margin-top: 10px;
//     }
// }
//
// .not-accessed-yet.help-text-box {
//
//     margin: 30px auto;
//     background: #e7ecfe;
//     display: block;
//
// }
//
// @media only screen and (max-width: 600px) {
//
//     .help-text-box {
//         padding: 20px 15px;
//         font-size: 1rem;
//         margin: 0 0 35px;
//         -webkit-box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44);
//         box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44);
//     }
//
//     #lawFirmsPage .help-text-box {
//         margin-top: 20px !important;
//     }
//
// }
//
// /*
//  * Responsive Separators
//  */
//
//
// @media only screen and (max-width: 1300px) {
//
//     .apto-page #pageHeader .separator-wrapper.separator-bottom {
//         height: 120px !important;
//     }
//
// }
//
// @media only screen and (max-width: 900px) {
//
//     .apto-page #pageHeader .separator-wrapper.separator-bottom {
//         height: 70px !important;
//     }
//
//     .apto-page #pageHeader .separator-wrapper.separator-top {
//         height: 70px!important;
//     }
//
// }
//
// @media only screen and (max-width: 550px) {
//
//     .apto-page #pageHeader .separator-wrapper.separator-bottom {
//         height: 50px !important;
//     }
//
//     .apto-page #pageHeader .separator-wrapper.separator-top {
//         height: 50px!important;
//     }
//
// }
//
// @media only screen and (max-width: 400px) {
//
//     .apto-page #pageHeader .separator-wrapper.separator-bottom {
//         height: 55px !important;
//     }
//
//     .apto-page #pageHeader .separator-wrapper.separator-top {
//         height:55px;
//     }
//
// }
//
// #uploadApplication .file-field .btn {
//     border-radius: 25px;
//     padding: 0 30px;
//     font-size: 1rem;
//     text-transform: capitalize;
//     background-color: #fff !important;
//     box-shadow: none;
//     color: #61a9f6;
//     border: 2px solid #61a9f6;
//     line-height: 50px;
//     height: 55px;
// }
//
// #uploadApplication .file-field .btn:hover {
//     background-color: #61a9f6 !important;
//     color: #fff;
// }
//
//
// #uploadApplication .file-field .file-path-wrapper {
//     padding-top: 5px;
//     padding-right: 4px;
// }
//
//
// @media screen and (max-width: 900px) {
//
//     #uploadApplication .file-field .btn {
//         width:100%;
//     }
//
//     #uploadApplication .file-field .file-path-wrapper {
//
//         width: 100%;
//         padding: 0;
//         overflow: visible;
//         margin-top: 20px !important;
//         display: inline-block;
//     }
// }
//
// .step-item.card {
//     background-color: #e7ecfe;
//     border-radius: 20px;
//     padding: 25px;
//     text-align: center;
//     width: 300px;
//     margin: 0 auto;
//     -webkit-box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44);
//     max-width: 100%;
// }
//
//
// @media screen and (max-width: 990px) {
//
//     .step-item.card {
//         height: auto !important;
//         margin-bottom: 30px;
//     }
//
// }
//
// // .step-item.card .step-icon {
// //     width: 80px;
// //     height: 80px;
// //     margin: 0 auto;
// // }
// //
// // @media screen and (max-width: 600px) {
// //     .step-item.card .step-icon {
// //         width: 60px;
// //         height: 60px;
// //     }
// // }
//
// // .step-item.card .step-tile {
// //     color: #505f79;
// //     font-weight: 700;
// //     font-size: 1.1rem;
// //     margin-bottom: 8px;
// // }
//
// // .step-icon .credits-item {
// //     position:relative;
// //     width: 105px;
// //     height: 105px;
// //     line-height: 74px;
// //     border: 14px solid #000;
// //     box-shadow: none;
// //     color: #5D9CEC;
// //     z-index:1;
// // }
//
// // .step-item.card .step-description {
// //     color: #505f79;
// //     font-size: 14px;
// // }
//
// // .upload-steps {
// //     border-bottom: 1px solid #e7ecfe;
// //     margin-bottom: 25px;
// //     padding-bottom: 20px;
// // }
//
// // .upload-steps > p {
// //     color: #505f79;
// //     text-align: center;
// // }
// //
// // .upload-steps > h5 {
// //     margin-bottom:10px!important;
// // }
//
// .steps-cards.flex {
//     margin-top: 35px;
// }
//
// .optional-label {
//     opacity: 0.6;
// }
//
// .inline-radio-button {
//     display: inline-block;
//     margin-right: 10px;
//     margin-top: 20px;
//     margin-bottom: 5px;
//     background-color: #e5ecff;
//     font-weight: 700;
//     border: 0 !important;
//     border-radius: 35px;
//     color: #53596f;
//     font-size: 1rem;
//     height: 50px;
//     line-height: 25px;
//     padding: 0 10px 0 5px;
// }
//
// #uploadApplication .input-field.col label.inline-radio-label {
//     position: relative !important;
//     display: block;
//     width: 100%;
//     left: 0 !important;
//     margin-bottom: 0;
//     margin-top: -20px;
// }
//
// [type="radio"]:checked + span::after, [type="radio"].with-gap:checked + span::after {
//     background-color: #61a9f6!important;
// }
//
// [type="radio"]:checked + span::after, [type="radio"].with-gap:checked + span::before, [type="radio"].with-gap:checked + span::after {
//     border: 2px solid #61a9f6!important;
// }
//
// .files-marketplace-plugin input:not([type]),
// .files-marketplace-plugin input[type="text"]:not(.browser-default),
// .files-marketplace-plugin input[type="password"]:not(.browser-default),
// .files-marketplace-plugin input[type="email"]:not(.browser-default),
// .files-marketplace-plugin input[type="url"]:not(.browser-default),
// .files-marketplace-plugin input[type="time"]:not(.browser-default),
// .files-marketplace-plugin input[type="date"]:not(.browser-default),
// .files-marketplace-plugin input[type="datetime"]:not(.browser-default),
// .files-marketplace-plugin input[type="datetime-local"]:not(.browser-default),
// .files-marketplace-plugin input[type="tel"]:not(.browser-default),
// .files-marketplace-plugin input[type="number"]:not(.browser-default),
// .files-marketplace-plugin input[type="search"]:not(.browser-default),
// .files-marketplace-plugin textarea.materialize-textarea {
//     background-color: #e5ecff;
//     font-weight: 700;
//     border: 2px solid #e5ecff;
//     border-radius: 35px;
//     color: #53596f;
//     font-size: 1rem;
//     height: 50px;
//     margin-top: -4px;
//     line-height: 50px;
//     padding-left: 25px;
//     width: calc(100% - 25px);
// }
//
// .files-marketplace-plugin .input-field.col label {
//     left: 28px;
//     display: inline-block;
//     width: auto!important;
//     border-radius: 10px;
//     padding: 1px 10px;
//     -webkit-transform: translateY(9px);
//     -ms-transform: translateY(9px);
//     transform: translateY(9px);
// }
//
// .files-marketplace-plugin .input-field.col > label:not(.label-icon).active {
//     background-color: #e5ecff;
//     -webkit-transform: translateY(-14px) scale(0.8);
//     -ms-transform: translateY(-14px) scale(0.8);
//     transform: translateY(-14px) scale(0.8);
// }
//
// .form-group.col.s12 {
//     padding: 0;
//     margin-top: 30px;
// }
//
// .form-group-title {
//     border-bottom: 2px solid #c0cae3;
//     padding-bottom: 15px;
//     margin-bottom: 20px !important;
//     opacity: 0.6;
//     text-align: left;
//     padding-left: 10px;
//     font-size: 1.2rem !important;
// }
//
// .files-marketplace-plugin input.invalid:not([type]),
// .files-marketplace-plugin input.invalid:not([type]):focus,
// .files-marketplace-plugin input.invalid[type="text"]:not(.browser-default),
// .files-marketplace-plugin input.invalid[type="text"]:not(.browser-default):focus,
// .files-marketplace-plugin input.invalid[type="password"]:not(.browser-default),
// .files-marketplace-plugin input.invalid[type="password"]:not(.browser-default):focus,
// .files-marketplace-plugin input.invalid[type="email"]:not(.browser-default),
// .files-marketplace-plugin input.invalid[type="email"]:not(.browser-default):focus,
// .files-marketplace-plugin input.invalid[type="url"]:not(.browser-default),
// .files-marketplace-plugin input.invalid[type="url"]:not(.browser-default):focus,
// .files-marketplace-plugin input.invalid[type="time"]:not(.browser-default),
// .files-marketplace-plugin input.invalid[type="time"]:not(.browser-default):focus,
// .files-marketplace-plugin input.invalid[type="date"]:not(.browser-default),
// .files-marketplace-plugin input.invalid[type="date"]:not(.browser-default):focus,
// .files-marketplace-plugin input.invalid[type="datetime"]:not(.browser-default),
// .files-marketplace-plugin input.invalid[type="datetime"]:not(.browser-default):focus,
// .files-marketplace-plugin input.invalid[type="datetime-local"]:not(.browser-default),
// .files-marketplace-plugin input.invalid[type="datetime-local"]:not(.browser-default):focus,
// .files-marketplace-plugin input.invalid[type="tel"]:not(.browser-default),
// .files-marketplace-plugin input.invalid[type="tel"]:not(.browser-default):focus,
// .files-marketplace-plugin input.invalid[type="number"]:not(.browser-default),
// .files-marketplace-plugin input.invalid[type="number"]:not(.browser-default):focus,
// .files-marketplace-plugin input.invalid[type="search"]:not(.browser-default),
// .files-marketplace-plugin input.invalid[type="search"]:not(.browser-default):focus,
// .files-marketplace-plugin textarea.materialize-textarea.invalid, textarea.materialize-textarea.invalid:focus,
// .files-marketplace-plugin .select-wrapper.invalid > .files-marketplace-plugin input.select-dropdown,
// .files-marketplace-plugin .select-wrapper.invalid > .files-marketplace-plugin input.select-dropdown:focus {
//     -webkit-box-shadow: none;
//     box-shadow: none;
//     border: 2px solid #F44336!important;
// }
//
// .files-marketplace-plugin input.valid:not([type]),
// .files-marketplace-plugin input.valid:not([type]):focus,
// .files-marketplace-plugin input.valid[type="text"]:not(.browser-default),
// .files-marketplace-plugin input.valid[type="text"]:not(.browser-default):focus,
// .files-marketplace-plugin input.valid[type="password"]:not(.browser-default),
// .files-marketplace-plugin input.valid[type="password"]:not(.browser-default):focus,
// .files-marketplace-plugin input.valid[type="email"]:not(.browser-default),
// .files-marketplace-plugin input.valid[type="email"]:not(.browser-default):focus,
// .files-marketplace-plugin input.valid[type="url"]:not(.browser-default),
// .files-marketplace-plugin input.valid[type="url"]:not(.browser-default):focus,
// .files-marketplace-plugin input.valid[type="time"]:not(.browser-default),
// .files-marketplace-plugin input.valid[type="time"]:not(.browser-default):focus,
// .files-marketplace-plugin input.valid[type="date"]:not(.browser-default),
// .files-marketplace-plugin input.valid[type="date"]:not(.browser-default):focus,
// .files-marketplace-plugin input.valid[type="datetime"]:not(.browser-default),
// .files-marketplace-plugin input.valid[type="datetime"]:not(.browser-default):focus,
// .files-marketplace-plugin input.valid[type="datetime-local"]:not(.browser-default),
// .files-marketplace-plugin input.valid[type="datetime-local"]:not(.browser-default):focus,
// .files-marketplace-plugin input.valid[type="tel"]:not(.browser-default),
// .files-marketplace-plugin input.valid[type="tel"]:not(.browser-default):focus,
// .files-marketplace-plugin input.valid[type="number"]:not(.browser-default),
// .files-marketplace-plugin input.valid[type="number"]:not(.browser-default):focus,
// .files-marketplace-plugin input.valid[type="search"]:not(.browser-default),
// .files-marketplace-plugin input.valid[type="search"]:not(.browser-default):focus,
// .files-marketplace-plugin textarea.materialize-textarea.valid, textarea.materialize-textarea.valid:focus,
// .files-marketplace-plugin .select-wrapper.valid > .files-marketplace-plugin input.select-dropdown {
//     -webkit-box-shadow: none;
//     box-shadow: none;
//     border: 2px solid #4CAF50!important;
// }
//
// .files-marketplace-plugin input:not([type]):focus:not([readonly]),
// .files-marketplace-plugin input[type="text"]:not(.browser-default):focus:not([readonly]),
// .files-marketplace-plugin input[type="password"]:not(.browser-default):focus:not([readonly]),
// .files-marketplace-plugin input[type="email"]:not(.browser-default):focus:not([readonly]),
// .files-marketplace-plugin input[type="url"]:not(.browser-default):focus:not([readonly]),
// .files-marketplace-plugin input[type="time"]:not(.browser-default):focus:not([readonly]),
// .files-marketplace-plugin input[type="date"]:not(.browser-default):focus:not([readonly]),
// .files-marketplace-plugin input[type="datetime"]:not(.browser-default):focus:not([readonly]),
// .files-marketplace-plugin input[type="datetime-local"]:not(.browser-default):focus:not([readonly]),
// .files-marketplace-plugin input[type="tel"]:not(.browser-default):focus:not([readonly]),
// .files-marketplace-plugin input[type="number"]:not(.browser-default):focus:not([readonly]),
// .files-marketplace-plugin input[type="search"]:not(.browser-default):focus:not([readonly]),
// .files-marketplace-plugin textarea.materialize-textarea:focus:not([readonly]) {
//     -webkit-box-shadow: none;
//     box-shadow: none;
//     border: 2px solid #61a9f6!important;
//
// }
//
// .files-marketplace-plugin [type="checkbox"] + span:not(.lever)::before,
// .files-marketplace-plugin [type="checkbox"]:not(.filled-in) + span:not(.lever)::after {
//     margin-top:5px;
// }
//
// .files-marketplace-plugin [type="radio"]:not(:checked) + span,
// .files-marketplace-plugin [type="radio"]:checked + span {
//     padding-left: 30px;
// }
//
// .fas.fa-chevron-down.select-dropdown-icon {
//     position: absolute;
//     top: 16px;
//     right: 30px;
//     z-index: 1;
//     color: #505f79 !important;
// }
//
// .files-marketplace-plugin .input-field .helper-text {
//     color: #8c97af;
//     text-align: left;
//     font-size: 0.9rem;
//     margin-left: 25px;
//     font-style: italic;
// }
//
//
// @media screen and (max-width: 600px) {
//     .files-marketplace-plugin .input-field .helper-text {
//
//         margin: 0;
//         text-align: center;
//
//     }
// }
//
// .file-field .file-path-wrapper input[type="text"]::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
//     color: #8c98af;
//     font-size:0.9rem;
//     font-weight:400;
//     opacity: 1; /* Firefox */
// }
//
// .file-field .file-path-wrapper input[type="text"]:-ms-input-placeholder { /* Internet Explorer 10-11 */
//     color: #8c98af;
//     font-size:0.9rem;
//     font-weight:400;
// }
//
// .file-field .file-path-wrapper input[type="text"]::-ms-input-placeholder { /* Microsoft Edge */
//     color: #8c98af;
//     font-size:0.9rem;
//     font-weight:400;
// }
//
// .login-form-wrapper {
//     width: 900px;
//     margin: 0 auto;
//     max-width: 100%;
// }
//
// .card.application-filters {
//     margin-bottom: 30px;
//     border-radius: 10px;
//     padding: 10px 10px;
// }
//
// .card.application-filters h5 {
//     font-family: 'Arial Black', 'Arial Bold', Gadget, sans-serif;
//     color: #53596f;
//     font-size: 1.2rem;
//     font-weight: 700;
// }
//
// .card.application-filters .filters-wrapper {
//     display: inline-block;
//     border-top: 1px solid #e5ecff;
//     margin-top: 5px;
//     padding-top: 10px;
// }
//
// .card.application-filters label {
//     display: none !important;
// }
//
// .card.application-filters .select-wrapper input.select-dropdown {
//     margin-bottom:0;
//     font-size: 0.9rem;
//     padding-left: 15px;
// }
//
// .card.application-filters .btn-primary {
//     margin-top: 13px;
// }
//
// .taxonomy-law-firm .page-numbers {
//     border-radius: 50%;
//     width: 45px;
//     height: 45px;
// }
//
// .files-marketplace-plugin .taxonomy-law-firm .page-numbers.current {
//     background-color: #57a2f2;
// }
//
// .home #theProblem {
//     background-color: #e6ecff;
// }
//
// .home #theSolution {
//     background-color: #fff;
//     padding-bottom: 0;
// }
//
// .home #theSolution .btn-primary {
//
//     padding: 0 30px;
// }
//
// .home #theSolution .separator-wrapper svg path {
//     fill: #e6ecff;
// }
//
// .home .story-section .container {
//     margin-top: 0;
// }
//
// .home .story-section .illustration {
//     width: 450px;
//     max-width: 100%;
//     margin: 0 auto;
// }
//
// .home .section-title {
//     font-weight:800;
// }
//
// .home #theSolution .section-content {
//     margin-top: 80px;
// }
//
// .home #theProblem.story-section .illustration {
//     margin-left:0;
//     width: 430px;
//     max-width: 100%;
//     margin-top:-20px;
// }
//
// .home .story-section .separator-wrapper {
//     height: 100px;
// }
//
// .home #theProblem .section-content {
//     margin-top: 50px;
// }
// .home #theSolution.story-section .separator-wrapper {
//     height: 160px;
// }
//
// .home #theSolution.story-section .separator-wrapper:first-child {
//     height: 90px;
// }
//
// .home #theSolution .illustration {
//     margin-bottom: 40px;
// }
//
// #theSolution .btn-primary.btn-transparent {
//     border-color: #4798ed;
//     color: #4798ed;
// }
//
// @media screen and (max-width: 990px){
//     .home #theProblem .section-content {
//         margin-top: -30px;
//     }
//
//     .home #theSolution.story-section .separator-wrapper {
//         height: 80px !important;
//     }
// }
//
//
// .home .section-content .section-title,
// .home .section-content .section-paragraph,
// .home .section-content .section-btns-wrapper a,
// .home .pricing-table .card.pricing-item
// {
//     opacity:0;
//     -webkit-transform:translateY(100%);
//     -ms-transform:translateY(100%);
//     transform:translateY(100%);
//     -webkit-transition: opacity 0.3s, transform 0.6s, box-shadow 0.2s;
//     -o-transition: opacity 0.3s, transform 0.6s, box-shadow 0.2s;
//     transition: opacity 0.3s, transform 0.6s, box-shadow 0.2s;
// }
//
// .home .section-content .section-title.animateItem,
// .home .section-content .section-paragraph.animateItem,
// .home .section-content .section-btns-wrapper a.animateItem,
// .home #viewAllLawFirms.animateItem,
// .home .law-firm-item.animateItem,
// .home .pricing-table .card.pricing-item.animateItem
// {
//     opacity:1;
//     -webkit-transform:translateY(0);
//     -ms-transform:translateY(0);
//     transform:translateY(0);
//     -webkit-transition: opacity 0.3s, transform 0.6s, box-shadow 0.2s;
//     -o-transition: opacity 0.3s, transform 0.6s, box-shadow 0.2s;
//     transition: opacity 0.3s, transform 0.6s, box-shadow 0.2s;
// }
//
// .home .section-content .section-btns-wrapper a.animateItem:nth-child(1){
//     -webkit-transition-delay: 0s;
//     -o-transition-delay: 0s;
//     transition-delay: 0s;
// }
//
// .home .section-content .section-btns-wrapper a.animateItem:nth-child(2){
//     -webkit-transition-delay: 0.2s;
//     -o-transition-delay: 0.2s;
//     transition-delay: 0.2s;
// }
//
// .home .pricing-table .card.pricing-item {
//     -webkit-transform:translateY(40%);
//     -ms-transform:translateY(40%);
//     transform:translateY(40%);
// }
//
// .home .pricing-table .col:nth-child(1) .card.pricing-item.animateItem {
//     -webkit-transition-delay: 0s;
//     -o-transition-delay: 0s;
//     transition-delay: 0s;
// }
//
// .home .pricing-table .col:nth-child(2) .card.pricing-item.animateItem {
//     -webkit-transition-delay: 0.2s;
//     -o-transition-delay: 0.2s;
//     transition-delay: 0.2s;
// }
//
// .home .pricing-table .col:nth-child(3) .card.pricing-item.animateItem {
//     -webkit-transition-delay: 0.4s;
//     -o-transition-delay: 0.4s;
//     transition-delay: 0.4s;
// }
//
// @media screen and (max-width: 600px) {
//
//     .home .section-content .section-title,
//     .home .section-content .section-paragraph,
//     .home .section-content .section-btns-wrapper a,
//     .home .pricing-table .card.pricing-item
//     {
//         opacity:1;
//         -webkit-transform:translateY(0);
//         -ms-transform:translateY(0);
//         transform:translateY(0);
//         -webkit-transition: opacity 0.3s, transform 0.6s;
//         -o-transition: opacity 0.3s, transform 0.6s;
//         transition: opacity 0.3s, transform 0.6s;
//     }
//
// }
//
//
// #solutionIllustration #lamp {
//     opacity:0;
//     -webkit-transition: opacity 0.3s;
//     -o-transition: opacity 0.3s;
//     transition: opacity 0.3s;
// }
//
// #solutionIllustration.animateIllustration #lamp {
//     opacity:1;
//     -webkit-transition: opacity 0.6s;
//     -o-transition: opacity 0.6s;
//     transition: opacity 0.6s;
//     -webkit-transition-delay: 0.8s;
//     -o-transition-delay: 0.8s;
//     transition-delay: 0.8s;
// }
//
// #solutionIllustration #puzzle1,
// #solutionIllustration #puzzleShadow1,
// #solutionIllustration #puzzleFiller1,
// #solutionIllustration #puzzle2,
// #solutionIllustration #puzzleShadow2,
// #solutionIllustration #puzzleFiller2
// {
//    -webkit-transition: 0.4s ease-in 0.4s;
//    -o-transition: 0.4s ease-in 0.4s;
//    transition:0.4s ease-in 0.4s;
// }
//
// #solutionIllustration.animateIllustration #puzzle1,
// #solutionIllustration.animateIllustration #puzzleShadow1,
// #solutionIllustration.animateIllustration #puzzleFiller1
// {
//     -webkit-transform: translate3d(24px,-5px,0);
//     -ms-transform: translate3d(24px,-5px,0);
//     transform: translate3d(24px,-5px,0);
// }
//
// #solutionIllustration.animateIllustration #puzzle2,
// #solutionIllustration.animateIllustration #puzzleShadow2,
// #solutionIllustration.animateIllustration #puzzleFiller2
// {
//     -webkit-transform:translate3d(11px,-2px,1px);
//     -ms-transform: translate3d(11px,-2px,1px);
//     transform: translate3d(11px,-2px,1px);
// }
//
//
// .login-error-message {
//     width: 96%;
//     margin: -75px auto 30px auto;
//     background-color: #fff;
//     display: block;
//     -webkit-box-shadow: 0 10px 29px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 10px 29px 0 rgba(126, 136, 172, 0.44);
//     padding: 25px 30px;
//     border-radius: 10px;
//     color: #5e697d;
//     font-weight: 700;
// }
//
// .login-error-message .error {
//     color: #f44336;
// }
//
//
// .error-404-content .section-description {
//     margin: 0;
//     width: 100%;
// }
//
// .error-404-actions {
//     margin-top: 15px;
// }
//
// .error-404-actions a {
//     margin-right: 8px;
// }
//
// #howItWorks .illustration {
//     margin-top: 25px;
//     max-width: 500px;
//     width: 100%;
//
// }
//
// .information-resources .section-title.dark-color {
//
//     margin-top: 75px;
//
// }
//
// .access-expire-message {
//     border-radius: 10px;
//     padding: 20px;
//     background: linear-gradient(to top,#fff, #e6ecff);
//     -webkit-box-shadow: 0 19px 59px 0 rgba(126, 136, 172, 0.44);
//     box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44);
//     font-weight: 700;
//     color: #4b5166;
//     margin-bottom: 25px;
// }
//
// @media screen and (max-width: 1300px) {
//     #post-52 .container {
//
//         width: 85% !important;
//
//     }
// }
//
//
// #post-52 h1 {
//     display: none;
// }
//
// #post-52 #pageCardContent > .container > .col.s12 > .card {
//     margin-top: -440px;
// }
//
// #post-52 #pageHeader .section-content {
//     min-height: 60px;
// }
//
// @media only screen and (max-width: 600px) {
//     #post-52 #pageCardContent > .container > .col.s12 > .card {
//         margin-top: -250px;
//     }
// }
//
// .mc4wp-form-fields .input-field.col.s12 {
//     margin-bottom: 0;
// }
//
// #pageCardContent .card-section {
//     border-top: 1px solid #e7ecfe;
//     padding-top: 30px;
//     margin-top: 30px;
// }
//
// #pageCardContent .card-section:first-child {
//     border-top: 0;
//     padding-top:0;
//     margin-top: 10px;
// }
//
// #pageCardContent .card-section .section-title {
//     font-size: 2.2rem;
//     margin-top: 0;
//     margin-bottom: 10px;
// }
//
//
// @media screen and (max-width: 600px){
//
//     #howItWorks .illustration {
//         margin-top: 0;
//     }
//
//     #pageCardContent .card-section.information-resources .section-title {
//         margin-top: 10px!important;
//     }
// }
//
// #pageCardContent .card-section .how-to, #pageCardContent .card-section .section-paragraph {
//     margin-top: 0;
//     font-size: 15px;
//     line-height: 24px;
// }
//
// #pageCardContent .card-section.information-resources .section-title {
//     margin-top: 60px;
// }
//
// @media screen and (max-width: 600px) {
//     .card-section.information-resources .btn-primary {
//         margin-bottom: 20px;
//     }
// }
//
//
// @media screen and (max-width: 600px) {
//     #mc4wp-form-1 [type="checkbox"] + span:not(.lever) {
//
//         padding-left: 25px;
//
//     }
// }
//
//
// @media screen and (max-width: 1400px) {
//
//     #homeIntro .separator-wrapper:last-child {
//         height:210px;
//     }
//
//     .home .diagonal-separator::before {
//         height:60px;
//     }
//
//     #whatWeDo .separator-wrapper {
//         height: 100px;
//     }
//
//     #whatWeDo .separator-wrapper:last-child {
//
//         height: 150px;
//
//     }
//
// }
//
// @media screen and (max-width: 1200px) {
//
//     #homeIntro .separator-wrapper:first-child {
//         height: 75px;
//     }
//
//     #homeIntro .separator-wrapper:last-child {
//         height: 115px;
//     }
//
//     #whatWeDo .separator-wrapper:last-child {
//
//         height: 120px;
//     }
//
// }
//
// @media screen and (max-width: 990px) {
//
//     #homeIntro .section-content {
//         margin-top: 0;
//         margin-bottom: 0;
//     }
//
//     #homeIntro .svg-illustration-wrapper svg {
//         margin: -50px auto 20px;
//     }
//
//     #homeIntro .separator-wrapper:first-child {
//         height: 70px;
//     }
//
//     #homeIntro .separator-wrapper:last-child {
//         height:85px;
//     }
//
//     .home .diagonal-separator::before {
//         height:50px;
//     }
//
//     #illustration1 {
//         height: auto;
//     }
//
//     #homeIntro .svg-illustration-wrapper svg {
//         margin: 0 auto;
//         top: -35px;
//     }
//
//     #homeIntro .svg-illustration-wrapper {
//         max-height: 350px;
//     }
//
//     #homeIntro .section-title {
//         color: #fff;
//         line-height: 2rem;
//         margin-top: 20px;
//         font-size: 1.7rem;
//     }
//
//     #whatWeDo .separator-wrapper {
//         height: 80px;
//     }
//
//     #whatWeDo .section-content {
//
//         margin-bottom: 40px;
//
//     }
//
//     #whatWeDo .separator-wrapper:last-child {
//         height: 100px;
//     }
//
//     #lawFirms {
//         padding: 0 0 60px;
//     }
//
//     #lawFirms .separator-wrapper {
//         height: 130px;
//     }
//
//     #lawFirms .separator-wrapper svg {
//         bottom: -1px;
//         top: auto;
//     }
//
//     .apto-page.row .diagonal-separator.before-law-firms {
//         margin-top: -80px;
//     }
//
//     #lawFirms .section-content {
//         margin-top: -90px;
//     }
//
//     .home #theSolution .section-btns-wrapper {
//         margin-top: 20px;
//         margin-bottom: 30px;
//
//     }
//
//     .section-title {
//         font-size: 1.8rem;
//     }
//
//     .home #theSolution .section-content {
//
//         margin-top: 40px;
//
//     }
//
//     #viewAllLawFirms {
//         margin-top:15px;
//     }
//
//     #pricing .pricing-table {
//         margin-top: 10px;
//     }
//
//     #pricing .btn-primary.apto-orange {
//         margin-bottom: 20px;
//     }
//
//     #registerCTA .separator-wrapper {
//         height: 100px;
//     }
//
// }
//
// @media screen and (max-width: 700px) {
//
//     #homeIntro .separator-wrapper:first-child {
//         height: 50px;
//     }
//
//     #homeIntro .separator-wrapper:last-child {
//         height:50px;
//     }
//
//
//     .home .diagonal-separator::before {
//         height:40px;
//     }
//
//     .home .section-btns-wrapper {
//         margin-top: 20px;
//     }
//
//     #whatWeDo .separator-wrapper {
//         height: 50px;
//     }
//
//     #whatWeDo .separator-wrapper:last-child {
//         height: 40px;
//     }
//
//
//     #registerCTA .separator-wrapper {
//         height: 50px;
//     }
//
//     #registerCTA .section-content {
//         margin-top: -10px;
//     }
//
//     .home .section-btns-wrapper .btn-primary {
//         width: 100%;
//         margin-bottom: 15px;
//     }
//
// }
//
// @media screen and (max-width: 460px) {
//
//     #homeIntro .separator-wrapper:first-child {
//         height: 50px!important;
//     }
//
//     #homeIntro .separator-wrapper:last-child {
//         height:60px!important;
//     }
//
//     .home .diagonal-separator::before {
//         height:30px!important;
//     }
//
//     #whatWeDo .separator-wrapper {
//         height: 50px!important;
//     }
//
//     #whatWeDo .separator-wrapper:last-child {
//         height: 30px!important;
//     }
//
//     #lawFirms .separator-wrapper {
//         height: 140px!important;
//     }
//
//     #lawFirms .section-content {
//         margin-top: -145px!important;
//     }
//
//     #registerCTA .separator-wrapper {
//         height: 40px!important;
//     }
//
//     #registerCTA .section-content {
//         margin-top: -10px!important;
//     }
//
//     #registerCTA .section-content .btn-primary {
//         width:100%;
//     }
//
//     #registerCTA .section-content .btn-primary:first-child {
//         margin-bottom: 20px;
//     }
//
// }
//
// @media screen and (max-width: 300px) {
//
//     #homeIntro .separator-wrapper:first-child {
//         height: 40px!important;
//     }
//
//     #homeIntro .separator-wrapper:last-child {
//         height:50px!important;
//     }
//
//     #whatWeDo .separator-wrapper:last-child {
//         height: 50px!important;
//     }
//
//     #registerCTA .separator-wrapper {
//         height: 45px!important;
//     }
//
// }
//
//
// @media screen and (max-width: 600px) {
//
//     #homeIntro .svg-illustration-wrapper svg {
//         margin: 0 auto;
//         top: 0;
//         width: 100% !important;
//     }
//
//     #illustration1 {
//         height: auto;
//         margin: -70px auto 0;
//         width: 300px;
//         max-width: 100%;
//     }
//
//     #homeIntro .section-title {
//         margin-top:0;
//         text-align:center;
//     }
//
//     #homeIntro .btn-primary {
//         width:100%;
//     }
//
//     #homeIntro .section-content {
//         margin-top: -25px;
//     }
//
//     #homeIntro .section-paragraph {
//         max-width: 100%;
//         text-align: center;
//     }
//
//     .home #theProblem .section-content {
//         margin-top: 0!important;
//     }
//
//     .home #theSolution.story-section .separator-wrapper:first-child {
//         height: 30px!important;
//     }
//
//     .home #theSolution .section-content {
//         margin-top: 20px!important;
//     }
//
//     .home .section-title {
//         margin-bottom: 10px !important;
//     }
//
//     .home #theSolution.story-section .separator-wrapper {
//         height: 50px!important;
//     }
//
//     #lawFirms .section-content {
//         margin-top: -60px!important;
//     }
//
//     .apto-page.row .diagonal-separator.before-law-firms {
//         display:none;
//     }
//
//     #lawFirms .separator-wrapper {
//         height: 100px !important;
//     }
//
//     .law-firms-wrapper {
//         margin-top: 15px;
//     }
//
//     .law-firms-wrapper .col {
//         padding: 0 !important;
//     }
//
//     .law-firm-item {
//         margin: 12px auto 5px;
//     }
//
//     #lawFirms {
//         padding: 0 0 30px!important;
//     }
//
//     .section-paragraph.container {
//         width: 100% !important;
//     }
//
//     #pricing .card.pricing-item {
//         width: 350px;
//         -webkit-box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44) !important;
//         box-shadow: 0 2px 9px 0 rgba(126, 136, 172, 0.44) !important;
//         max-width: 100%;
//     }
//
//     #theSolution .section-btns-wrapper {
//         margin-bottom: 20px;
//     }
//
//     #tryFreeTitle {
//         margin: 15px 0 10px;
//     }
//
// }
//
// #noAccessPage {
//     width: calc(100% + 70px) !important;
//     margin-left: -35px;
//     margin-top: -45px;
//     height: calc(100% + 70px) !important;
//     margin-bottom: -45px;
// }
//
// #noAccessPage #pageHeader .separator-wrapper path {
//     fill: #e7ecfe;
// }
//
// #noAccessPage #pageHeader .section-title {
//     color: #384267;
//     line-height: 2.6rem;
//     margin-top: 50px;
// }
//
// #noAccessPage #pageHeader .error-404-content .section-description {
//     color: #637890!important;
// }
//
// #noAccessPage #pageHeader {
//     background-color: #fff;
// }
//
// #noAccessPage .container {
//     padding: 50px 0;
// }
//
// .rejected-item {
//     text-align: left;
//     font-size: 14px;
// }
//
// .rejected-item p {
//     margin-top: 0;
//     font-style: italic;
//     color: #f44336;
// }
//
// .preloader-overlay.register-preloader {
//     position: fixed;
//     z-index: 999;
// }
//
// .preloader-message {
//     position: fixed;
//     left: 50%;
//     transform: translateX(-50%);
//     top: 35%;
//     font-weight: 700;
//     font-size: 1.6rem;
// }
//
// .card.no-copy-text {
//
//     top: -90px;
//     padding: 15px 35px;
//     border-radius: 10px;
//     font-weight: 700;
//     background: #fbfcff;
//     color: #f44336;
//     display: inline-block;
//
// }
//
// body.no-access-on-application .card.no-copy-text{
//     display:none;
// }
//
// body .collapsible.applications-list li {
//     position: relative;
// }
//
//
// body .collapsible.applications-list li #accessIcon {
//
//     width: 50px;
//     position: absolute;
//     left: -35px;
//     top: 15px;
//     z-index: 2;
//     padding: 14px;
//     background-color: #5769ad;
//     border-radius: 50%;
//     fill: #fff;
//     -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//     box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
//
// }
//
// body .collapsible.applications-list li.is-accessible.has-preview #accessIcon {
//
//     width: 50px;
//     padding: 10px;
//     left: -35px;
//     top: 15px;
//     background-color: #fff;
//     fill: #5769ad;
//
// }
//
// .has-accessible-application .law-firm-item #accessIcon {
//     position: absolute;
//     width: 25px;
//     right: 18px;
//     top: 14px;
//     fill: #fff;
// }
//
// .has-preview .law-firm-item #accessIcon {
//     position: absolute;
//     width: 35px;
//     right: 12px;
//     top: 9px;
//     fill: #fff;
// }
//
// .has-accessible-application .law-firm-item,
// .has-preview .law-firm-item {
//
//     background: linear-gradient(#ffa421, #fd7b49);
//
// }
//
// body .collapsible.applications-list li.is-accessible .collapsible-header,
// body .collapsible.applications-list li.has-preview  .collapsible-header
// {
//
//     background: linear-gradient(to right,#5264a9, #596bae);
//
// }
//
// #lawFirmDetails .tabs .tab a {
//
//     text-transform: capitalize;
//
// }


`;

export default GlobalStyle;
